(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["funnel-main-product-sunscreen-cart"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
const activeMediaTemplate = activeMedia.querySelector('template');
const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

const container = this.querySelector('[role="document"]');
container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funnel-main-product-sunscreen"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
const activeMediaTemplate = activeMedia.querySelector('template');
const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

const container = this.querySelector('[role="document"]');
container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funnel-main-product-tanner-cart"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super()
    }

    hide() {
      super.hide()
    }

    show(opener) {
      super.show(opener)
      this.showActiveMedia()
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
      ).forEach((element) => {
        element.classList.remove('active')
      })
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`)
      const activeMediaTemplate = activeMedia.querySelector('template')
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null
      activeMedia.classList.add('active')
      activeMedia.scrollIntoView()

      const container = this.querySelector('[role="document"]')
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent()
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["funnel-main-product-tanner"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super()
    }

    hide() {
      super.hide()
    }

    show(opener) {
      super.show(opener)
      this.showActiveMedia()
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
      ).forEach((element) => {
        element.classList.remove('active')
      })
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`)
      const activeMediaTemplate = activeMedia.querySelector('template')
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null
      activeMedia.classList.add('active')
      activeMedia.scrollIntoView()

      const container = this.querySelector('[role="document"]')
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent()
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-bogo-st-14"] && !Shopify.designMode) return;
  try {
    
/* =============================================================================
   lp-col-bogo-st-14 (inline section JS) — advertorial BOGO LP behavior (st-11 + st-12).
   Dependency-free, idempotent. Reuses the shared framework button-loading
   helper (window.BBELP.setLoading) from lp-scripts.js. Scoped per [data-st11-root].

   Behaviors: select-2 BOGO grid, sticky selection bar, 2-step upsell modal
   (add-on + free gift), checkout (POST /cart/add.js then discount redirect chain),
   tap-to-copy code, and toast. Core content + product links work without JS.
============================================================================= */
(function () {
  "use strict";

  var SCROLL_THRESHOLD = 200;
  var MAX_SELECT = 2;

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function scrollY() {
    var api = stickyApi();
    if (api) return api.scrollY();
    return Math.max(window.scrollY || 0, window.pageYOffset || 0);
  }

  function scrollThreshold() {
    var api = stickyApi();
    if (api) return api.scrollThreshold(80, SCROLL_THRESHOLD);
    return window.matchMedia("(max-width: 767px)").matches ? 80 : SCROLL_THRESHOLD;
  }

  function scrollToShopSection(el) {
    var api = stickyApi();
    if (api) {
      api.scrollTo(el);
      return;
    }
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.reveal(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.hide(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    sticky.hidden = true;
    sticky.setAttribute("hidden", "");
  }

  function setLoading(el, on) {
    if (window.BBELP && typeof window.BBELP.setLoading === "function") {
      window.BBELP.setLoading(el, on);
    } else if (el) {
      el.classList.toggle("is-loading", on !== false);
    }
  }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function cardData(card) {
    return {
      el: card,
      id: card.getAttribute("data-st11-id"),
      variant: card.getAttribute("data-st11-variant"),
      price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
      title: card.getAttribute("data-st11-title") || "",
      img: card.getAttribute("data-st11-img") || "",
      available: card.getAttribute("data-st11-available") === "true",
    };
  }

  function init(root) {
    if (root.dataset.st11Bound === "1") return;
    root.dataset.st11Bound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-st11-config") || "{}");
    } catch (e) {
      config = {};
    }
    var discountCode = config.discountCode || "BOGO";
    var offerCopy = config.offerCopy || "Buy 1, Get 1 Free";

    var selected = []; // grid cards (max 2)

    var rootId = root.id || "";
    var stickyApiFn = stickyApi();
    var sticky = stickyApiFn ? stickyApiFn.resolve(root, rootId) : root.querySelector("[data-lp-sticky]");
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCta = sticky ? sticky.querySelector("[data-lp-sticky-cta]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;
    var stickyThumbsWrap = sticky ? sticky.querySelector(".lp-sticky__thumbs") : null;
    var gridStatus = root.querySelector("[data-st11-grid-status]");
    var tooltip = sticky ? sticky.querySelector("[data-lp-sticky-tooltip]") : null;

    function anchorStickyTooltip() {
      if (!tooltip || !stickyCta) return;
      if (tooltip.parentElement !== stickyCta) {
        stickyCta.appendChild(tooltip);
      }
    }

    anchorStickyTooltip();

    var shop = root.querySelector("#shop") || root.querySelector("[data-st11-sticky-anchor]");
    var toast = root.querySelector("[data-st11-toast]");
    var toastText = root.querySelector("[data-st11-toast-text]");
    var toastTimer = null;
    var stickyMqCompact = window.matchMedia("(max-width: 767px)");

    function showToast(msg, opts) {
      if (!toast) return;
      opts = opts || {};
      var tone = opts.tone === "success" ? "success" : "info";
      if (toastText && msg) toastText.textContent = msg;
      toast.classList.toggle("is-success", tone === "success");
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
          toast.classList.remove("is-success");
        }, 240);
      }, 3000);
    }

    function selectionProgressCopy(count) {
      if (count === 0) return "0 of 2 selected";
      if (count === 1) return "1 more to unlock BOGO";
      return "BOGO unlocked!";
    }

    function variantLabelFromCard(card) {
      if (!card) return "";
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || !sel.options.length) return "";
      var opt = sel.options[sel.selectedIndex];
      var variantLabel = (opt.getAttribute("data-variant-label") || opt.textContent || "")
        .replace(/\s*-\s*[^-]+$/, "")
        .replace(/\s*—\s*Sold out\s*$/, "")
        .trim();
      if (!variantLabel || variantLabel === "Default Title") return "";
      return variantLabel;
    }

    function selectionLabelFromCard(card) {
      if (!card) return "";
      var title = card.getAttribute("data-st11-title") || "";
      var variant = variantLabelFromCard(card);
      return variant ? title + " (" + variant + ")" : title;
    }

    function buildTooltipMessage(triggerCard) {
      if (selected.length >= MAX_SELECT) {
        return (
          "Selected: " +
          selectionLabelFromCard(selected[0].el) +
          " + " +
          selectionLabelFromCard(selected[1].el)
        );
      }
      if (triggerCard) {
        return "Selected: " + selectionLabelFromCard(triggerCard);
      }
      if (!selected.length) return "";
      return "Selected: " + selectionLabelFromCard(selected[0].el);
    }

    var tooltipTimer = null;

    function stickyStatusCopy(count) {
      if (count < MAX_SELECT) return offerCopy;
      if (stickyMqCompact.matches) return "";
      return "1 item free with code " + discountCode;
    }

    function updateStickyStatusPresentation(count) {
      if (!stickyStatus) return;
      var isReady = count >= MAX_SELECT;
      stickyStatus.classList.toggle("is-offer-pulse", count < MAX_SELECT);
      stickyStatus.hidden = isReady && stickyMqCompact.matches;
    }

    function updateGridStatus(count) {
      if (!gridStatus) return;
      gridStatus.textContent = selectionProgressCopy(count);
      gridStatus.classList.toggle("is-unlocked", count >= MAX_SELECT);
    }

    function updateSticky() {
      var count = selected.length;
      var isReady = count >= MAX_SELECT;
      if (sticky) sticky.classList.toggle("is-bogo-ready", isReady);
      if (stickyCta) stickyCta.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbsWrap) stickyThumbsWrap.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        selected.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) {
        stickyEmpty.hidden = count > 0;
      }
      if (stickyBadge) {
        stickyBadge.textContent = String(count);
        stickyBadge.classList.toggle("is-active", count > 0);
      }

      if (count === 0) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(0);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select products";
      } else if (count === 1) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(1);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select 1 More";
      } else {
        var total = selected[0].price + selected[1].price;
        var freeAmt = Math.min(selected[0].price, selected[1].price);
        var pay = total - freeAmt;
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(2);
        if (stickyPrice) {
          stickyPrice.hidden = false;
          if (stickyNow) stickyNow.textContent = money(pay);
          if (stickyWas) stickyWas.textContent = money(total);
        }
        if (stickyCtaText) stickyCtaText.textContent = "CLAIM NOW";
      }

      updateStickyStatusPresentation(count);
      updateGridStatus(count);

      function shopSectionVisible() {
        if (!shop) return false;
        var r = shop.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      var show = count >= 1 || scrollY() > scrollThreshold() || shopSectionVisible();
      if (sticky) {
        if (show) {
          revealSticky(sticky, root);
        } else {
          hideSticky(sticky, root);
        }
      }
    }

    function showTooltip(triggerCard) {
      if (!tooltip) return;
      anchorStickyTooltip();
      var msg = buildTooltipMessage(triggerCard);
      if (!msg) return;
      tooltip.textContent = msg;
      tooltip.hidden = false;
      if (tooltipTimer) clearTimeout(tooltipTimer);
      tooltipTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
      }, 3200);
    }

    function filterReviews(key) {
      var chips = root.querySelectorAll("[data-st11-rev-filter]");
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute(
          "aria-pressed",
          chips[i].getAttribute("data-st11-rev-filter") === key ? "true" : "false"
        );
      }
      var cards = root.querySelectorAll("[data-st11-review]");
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var match = key === "all" || cards[j].getAttribute("data-st11-skin") === key;
        cards[j].hidden = !match;
        if (match) shown++;
      }
      var countEl = root.querySelector("[data-st11-rev-count]");
      if (countEl) {
        countEl.textContent = "Showing " + shown + " review" + (shown === 1 ? "" : "s");
      }
    }

    function initCountdown() {
      var el = root.querySelector('[data-st11-countdown]');
      if (!el) return;
      var timeEl = el.querySelector('[data-st11-countdown-time]');
      if (!timeEl) return;
      var mins = parseInt(el.getAttribute('data-st11-countdown-mins'), 10) || 120;
      var totalSecs = mins * 60;
      var remaining = totalSecs;
      var timerId = null;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function render() {
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      function tick() {
        render();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (remaining <= 0) {
          remaining = totalSecs;
        } else {
          remaining -= 1;
        }
        timerId = setTimeout(tick, 1000);
      }
      tick();
    }

    function selectionIndicesForCard(card) {
      var indices = [];
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].el === card) indices.push(i);
      }
      return indices;
    }

    function cardSelectionCount(card) {
      return selectionIndicesForCard(card).length;
    }

    function removeLastSelectionForCard(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].el === card) {
          selected.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function addSelectionForCard(card) {
      if (card.getAttribute("data-st11-available") !== "true") return false;
      var cardCount = cardSelectionCount(card);
      if (cardCount >= 2) return false;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return false;
      }
      selected.push(cardData(card));
      if (cardCount === 0) {
        card.setAttribute("data-st11-bogo-phase", "first");
      } else if (selected.length === MAX_SELECT) {
        card.setAttribute("data-st11-bogo-phase", "both");
      }
      return true;
    }

    function decrementCard(card) {
      if (!removeLastSelectionForCard(card)) return;
      var cardCount = cardSelectionCount(card);
      if (cardCount === 0) {
        card.removeAttribute("data-st11-bogo-phase");
      } else if (cardCount === 1 && card.getAttribute("data-st11-bogo-phase") === "both") {
        card.setAttribute("data-st11-bogo-phase", "one-after-both");
      }
      refreshGridCards();
      updateSticky();
    }

    function incrementCard(card) {
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function refreshGridCards() {
      var cards = root.querySelectorAll('[data-st11-card][data-st11-mode="select"]');
      cards.forEach(function (card) {
        var slotIndices = selectionIndicesForCard(card);
        var cardCount = slotIndices.length;
        var isSel = cardCount > 0;
        var isFree = slotIndices.indexOf(1) > -1;
        card.classList.toggle("is-selected", isSel);
        card.classList.toggle("is-free", isFree);
        card.setAttribute("aria-pressed", isSel ? "true" : "false");
        if (!isSel) card.removeAttribute("data-st11-bogo-phase");

        var btn = card.querySelector("[data-st11-toggle]");
        var txt = card.querySelector("[data-st11-btn-text]");
        var btnCheck = card.querySelector("[data-st11-btn-check]");
        var qtyWrap = card.querySelector("[data-st11-qty]");
        var qtyCount = card.querySelector("[data-st11-qty-count]");
        var qtyMinus = card.querySelector("[data-st11-qty-minus]");
        var qtyPlus = card.querySelector("[data-st11-qty-plus]");
        var slotsFullElsewhere = selected.length >= MAX_SELECT && cardCount < 2;

        if (btn) {
          btn.hidden = isSel;
          btn.setAttribute("aria-pressed", isSel ? "true" : "false");
        }
        if (qtyWrap) {
          qtyWrap.hidden = !isSel;
          qtyWrap.setAttribute("aria-hidden", isSel ? "false" : "true");
        }
        if (qtyCount) qtyCount.textContent = String(cardCount);
        if (qtyMinus) qtyMinus.disabled = cardCount <= 0;
        if (qtyPlus) {
          qtyPlus.disabled = cardCount >= 2 || slotsFullElsewhere;
        }
        if (btnCheck) btnCheck.hidden = !isSel;
        if (txt && btn && !isSel) {
          txt.textContent = btn.getAttribute("data-st11-base-label") || "Select";
        }

        var label = card.querySelector("[data-st11-selected-label]");
        if (label) {
          if (!isSel) {
            label.textContent = "";
          } else if (cardCount >= 2) {
            label.textContent = "\u00d72";
          } else {
            label.textContent = String(slotIndices[0] + 1);
          }
        }

        var freeNow = card.querySelector("[data-st11-free-now]");
        if (freeNow) freeNow.hidden = !isFree;
      });
    }

    function toggleSelect(card) {
      if (card.getAttribute("data-st11-available") !== "true") return;
      var cardCount = cardSelectionCount(card);
      if (cardCount > 0) return;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return;
      }
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function selectionToCartItems(selections) {
      var qtyByVariant = {};
      selections.forEach(function (c) {
        var id = Number(c.variant);
        qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
      });
      return Object.keys(qtyByVariant).map(function (id) {
        return { id: Number(id), quantity: qtyByVariant[id] };
      });
    }

    var modalApi = null;

    function ensureModalApi() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) {
        return null;
      }
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selected.map(function (s) {
            return Number(s.variant);
          });
        },
        getParentProductIds: function () {
          return selected.map(function (s) {
            return Number(s.id);
          });
        },
        getParentCartItems: function () {
          return selectionToCartItems(selected);
        },
        canCheckout: function () {
          return selected.length >= MAX_SELECT;
        },
        onCheckoutBlocked: function () {
          showToast("Please select 2 products first");
        },
        onStickySuppress: function (on) {
          if (stickyApiFn) stickyApiFn.suppress(on);
        },
      });
      return modalApi;
    }

    function openModal() {
      var api = ensureModalApi();
      if (api && typeof api.open === "function") {
        api.open();
        return;
      }
      if (window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.open === "function") {
        ensureModalApi();
        window.BBELP.modal.open();
        return;
      }
      showToast("Please tap CLAIM NOW again");
    }

    window.setTimeout(function () {
      ensureModalApi();
    }, 0);

    root.addEventListener("bbe:lp-upsells:checkoutBlocked", function (e) {
      var reason = e.detail && e.detail.reason;
      if (reason === "upsell_required_for_gift" || reason === "upsell_required") {
        showToast("Please select an add-on item first");
        return;
      }
      if (reason === "free_gift_limit_reached") {
        showToast("You can only claim one free gift.");
        return;
      }
      showToast("Please select 2 products first");
    });

    /* ---- events ---- */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var card = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      e.preventDefault();
      toggleSelect(card);
    });

    root.addEventListener("click", function (e) {
      var qtyMinus = e.target.closest("[data-st11-qty-minus]");
      if (qtyMinus && root.contains(qtyMinus)) {
        var minusCard = qtyMinus.closest("[data-st11-card]");
        if (minusCard && minusCard.getAttribute("data-st11-mode") === "select") {
          decrementCard(minusCard);
        }
        return;
      }

      var qtyPlus = e.target.closest("[data-st11-qty-plus]");
      if (qtyPlus && root.contains(qtyPlus)) {
        var plusCard = qtyPlus.closest("[data-st11-card]");
        if (plusCard && plusCard.getAttribute("data-st11-mode") === "select") {
          incrementCard(plusCard);
        }
        return;
      }

      var toggle = e.target.closest("[data-st11-toggle]");
      if (toggle && root.contains(toggle)) {
        var card = toggle.closest("[data-st11-card]");
        if (!card) return;
        if (card.getAttribute("data-st11-mode") === "select") {
          toggleSelect(card);
        }
        return;
      }

      /* Main grid: entire card toggles selection (select mode only) */
      var gridCard = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (gridCard && root.contains(gridCard)) {
        if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
        e.preventDefault();
        toggleSelect(gridCard);
        return;
      }

      if (e.target.closest("[data-st11-cta-scroll], [data-lp-listicle-scroll]")) {
        if (selected.length === MAX_SELECT) {
          openModal();
        } else {
          scrollToShopSection(shop);
        }
        return;
      }

      var revFilter = e.target.closest("[data-st11-rev-filter]");
      if (revFilter && root.contains(revFilter)) {
        filterReviews(revFilter.getAttribute("data-st11-rev-filter"));
        return;
      }

      var copyBtn = e.target.closest("[data-st11-copy-code], [data-lp-copy-code]");
      if (copyBtn) {
        var code = copyBtn.getAttribute("data-st11-code") || copyBtn.getAttribute("data-lp-code") || discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              showToast("Code " + code + " copied", { tone: "success" });
            },
            function () {
              showToast("Code: " + code);
            }
          );
        } else {
          showToast("Code: " + code);
        }
        return;
      }
    });

    function applyVariantSelect(sel) {
      var card = sel.closest("[data-st11-card]");
      if (!card || card.getAttribute("data-st11-mode") !== "select") return;
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(opt.getAttribute("data-compare"), 10) || 0;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", price);
      card.setAttribute("data-st11-compare", compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      if (nowEl) nowEl.textContent = money(price);
      var compareEl = card.querySelector("[data-st11-compare-display]");
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : "";
      var data = cardData(card);
      var touched = false;
      for (var si = 0; si < selected.length; si++) {
        if (selected[si].el === card) {
          selected[si] = data;
          touched = true;
        }
      }
      if (touched) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      applyVariantSelect(sel);
    });

    function onStickyCtaClick(e) {
      e.preventDefault();
      if (selected.length === MAX_SELECT) {
        openModal();
      } else {
        scrollToShopSection(shop);
      }
    }

    if (root.dataset.st11StickyDocClick !== "1") {
      root.dataset.st11StickyDocClick = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lp-sticky-cta]")) return;
        var bar = e.target.closest("[data-lp-sticky]");
        if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
        onStickyCtaClick(e);
      });
    }

    function onScrollUpdate() {
      updateSticky();
    }
    var scrollOpts = { passive: true };
    window.addEventListener("scroll", onScrollUpdate, scrollOpts);
    document.addEventListener("scroll", onScrollUpdate, scrollOpts);
    if (document.documentElement) {
      document.documentElement.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }
    var scrollRoot = document.getElementById("MainContent");
    if (scrollRoot) {
      scrollRoot.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }

    if (typeof stickyMqCompact.addEventListener === "function") {
      stickyMqCompact.addEventListener("change", updateSticky);
    } else if (typeof stickyMqCompact.addListener === "function") {
      stickyMqCompact.addListener(updateSticky);
    }

    // Year auto-fill (footer copyright is server-rendered; this is a safety net)
    root.querySelectorAll("[data-st11-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });

    initCountdown();
    updateSticky();
    requestAnimationFrame(updateSticky);
  }

  function boot() {
    document.querySelectorAll("[data-st11-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector("[data-st11-root]")
      : null;
    if (root) {
      root.dataset.st11Bound = "";
      init(root);
    }
  });
})();

/* ---- Collection sort (client-side reorder by data-st11-price) ---- */
(function(){
  function sortGrid(select){
    var scope = select.closest('.lp-col-bogo-st-14') || document;
    var grid = scope.querySelector('[data-lp-shop-grid] .lp-grid--products') || scope.querySelector('.lp-grid--products');
    if(!grid){ return; }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.lp-collection-card:not(.lp-collection-card--placeholder)'));
    cards.forEach(function(c, i){ if(!c.dataset.st14Order){ c.dataset.st14Order = String(i); } });
    var mode = select.value;
    cards.sort(function(a, b){
      if(mode === 'best'){ return (parseInt(a.dataset.st14Order, 10) || 0) - (parseInt(b.dataset.st14Order, 10) || 0); }
      var pa = parseInt(a.getAttribute('data-st11-price'), 10); if(isNaN(pa)){ pa = 0; }
      var pb = parseInt(b.getAttribute('data-st11-price'), 10); if(isNaN(pb)){ pb = 0; }
      return mode === 'priceAsc' ? pa - pb : pb - pa;
    });
    cards.forEach(function(c){ grid.appendChild(c); });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-sort]'), function(sel){
    sortGrid(sel);
    sel.addEventListener('change', function(){ sortGrid(sel); });
  });
})();

/* ---- In-page shade quiz (standalone; independent of locked shade-picker/popup) ---- */
(function(){
  var QUESTIONS = [
    { q: "Does your skin burn easily?", a: [["Yes, very easily", "light"], ["Sometimes", "medium"], ["Rarely \u2014 I tan", "dark"]] },
    { q: "What's your natural skin tone?", a: [["Fair / porcelain", "light"], ["Light to medium", "medium"], ["Olive / dark", "dark"]] },
    { q: "How much color are you after?", a: [["Just a subtle hint", "light"], ["A natural, sun-kissed glow", "medium"], ["A dark, back-from-vacation tan", "dark"]] },
    { q: "How often do you use Self Tanner?", a: [["I'm a first-timer", "light"], ["Every now and then", "medium"], ["It's part of my routine", "dark"]] },
    { q: "Your dream result is\u2026", a: [["Barely-there radiance", "light"], ["Believable bronze", "medium"], ["Bold, dark color", "dark"]] }
  ];
  function initQuiz(card){
    var stage = card.querySelector('[data-st14-quiz-stage]');
    var result = card.querySelector('[data-st14-quiz-result]');
    var dots = card.querySelector('[data-st14-quiz-dots]');
    var shadeEls = card.querySelectorAll('[data-st14-quiz-shade], [data-st14-quiz-shade-2]');
    var restart = card.querySelector('[data-st14-quiz-restart]');
    if(!stage || !result){ return; }
    var step = 0, scores = { light: 0, medium: 0, dark: 0 };
    function renderDots(){
      if(!dots){ return; }
      dots.innerHTML = '';
      for(var i = 0; i < QUESTIONS.length; i++){
        var d = document.createElement('span');
        d.className = 'st14-quiz__dot' + (i === step ? ' is-active' : '');
        dots.appendChild(d);
      }
    }
    function renderStep(){
      var item = QUESTIONS[step];
      var html = '<p class="st14-quiz__step-count">Question ' + (step + 1) + ' of ' + QUESTIONS.length + '</p>';
      html += '<h2 class="st14-quiz__q">' + item.q + '</h2><div class="st14-quiz__options">';
      item.a.forEach(function(opt, idx){
        html += '<button type="button" class="st14-quiz__opt" data-shade="' + opt[1] + '"><span class="st14-quiz__opt-index">' + String.fromCharCode(65 + idx) + '</span><span>' + opt[0] + '</span></button>';
      });
      html += '</div>';
      stage.innerHTML = html;
      stage.hidden = false;
      if(dots){ dots.hidden = false; }
      renderDots();
      Array.prototype.forEach.call(stage.querySelectorAll('.st14-quiz__opt'), function(btn){
        btn.addEventListener('click', function(){
          var s = btn.getAttribute('data-shade');
          if(scores[s] !== undefined){ scores[s]++; }
          step++;
          if(step >= QUESTIONS.length){ showResult(); } else { renderStep(); }
        });
      });
    }
    function bestShade(){
      var best = 'medium', bestN = -1;
      ['light', 'medium', 'dark'].forEach(function(k){ if(scores[k] > bestN){ bestN = scores[k]; best = k; } });
      return best.charAt(0).toUpperCase() + best.slice(1);
    }
    function showResult(){
      var shade = bestShade();
      Array.prototype.forEach.call(shadeEls, function(el){ el.textContent = shade; });
      stage.hidden = true;
      if(dots){ dots.hidden = true; }
      result.hidden = false;
    }
    if(restart){
      restart.addEventListener('click', function(){
        step = 0; scores = { light: 0, medium: 0, dark: 0 };
        result.hidden = true;
        renderStep();
      });
    }
    renderStep();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-quiz]'), initQuiz);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-bogo-st-15"] && !Shopify.designMode) return;
  try {
    
/* =============================================================================
   lp-col-bogo-st-15 (inline section JS) — advertorial BOGO LP behavior (st-11 + st-12).
   Dependency-free, idempotent. Reuses the shared framework button-loading
   helper (window.BBELP.setLoading) from lp-scripts.js. Scoped per [data-st11-root].

   Behaviors: select-2 BOGO grid, sticky selection bar, 2-step upsell modal
   (add-on + free gift), checkout (POST /cart/add.js then discount redirect chain),
   tap-to-copy code, and toast. Core content + product links work without JS.
============================================================================= */
(function () {
  "use strict";

  var SCROLL_THRESHOLD = 200;
  var MAX_SELECT = 2;

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function scrollY() {
    var api = stickyApi();
    if (api) return api.scrollY();
    return Math.max(window.scrollY || 0, window.pageYOffset || 0);
  }

  function scrollThreshold() {
    var api = stickyApi();
    if (api) return api.scrollThreshold(80, SCROLL_THRESHOLD);
    return window.matchMedia("(max-width: 767px)").matches ? 80 : SCROLL_THRESHOLD;
  }

  function scrollToShopSection(el) {
    var api = stickyApi();
    if (api) {
      api.scrollTo(el);
      return;
    }
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.reveal(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.hide(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    sticky.hidden = true;
    sticky.setAttribute("hidden", "");
  }

  function setLoading(el, on) {
    if (window.BBELP && typeof window.BBELP.setLoading === "function") {
      window.BBELP.setLoading(el, on);
    } else if (el) {
      el.classList.toggle("is-loading", on !== false);
    }
  }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function cardData(card) {
    return {
      el: card,
      id: card.getAttribute("data-st11-id"),
      variant: card.getAttribute("data-st11-variant"),
      price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
      title: card.getAttribute("data-st11-title") || "",
      img: card.getAttribute("data-st11-img") || "",
      available: card.getAttribute("data-st11-available") === "true",
    };
  }

  function init(root) {
    if (root.dataset.st11Bound === "1") return;
    root.dataset.st11Bound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-st11-config") || "{}");
    } catch (e) {
      config = {};
    }
    var discountCode = config.discountCode || "BOGO";
    var offerCopy = config.offerCopy || "Buy 1, Get 1 Free";

    var selected = []; // grid cards (max 2)

    var rootId = root.id || "";
    var stickyApiFn = stickyApi();
    var sticky = stickyApiFn ? stickyApiFn.resolve(root, rootId) : root.querySelector("[data-lp-sticky]");
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCta = sticky ? sticky.querySelector("[data-lp-sticky-cta]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;
    var stickyThumbsWrap = sticky ? sticky.querySelector(".lp-sticky__thumbs") : null;
    var gridStatus = root.querySelector("[data-st11-grid-status]");
    var tooltip = sticky ? sticky.querySelector("[data-lp-sticky-tooltip]") : null;

    function anchorStickyTooltip() {
      if (!tooltip || !stickyCta) return;
      if (tooltip.parentElement !== stickyCta) {
        stickyCta.appendChild(tooltip);
      }
    }

    anchorStickyTooltip();

    var shop = root.querySelector("#shop") || root.querySelector("[data-st11-sticky-anchor]");
    var toast = root.querySelector("[data-st11-toast]");
    var toastText = root.querySelector("[data-st11-toast-text]");
    var toastTimer = null;
    var stickyMqCompact = window.matchMedia("(max-width: 767px)");

    function showToast(msg, opts) {
      if (!toast) return;
      opts = opts || {};
      var tone = opts.tone === "success" ? "success" : "info";
      if (toastText && msg) toastText.textContent = msg;
      toast.classList.toggle("is-success", tone === "success");
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
          toast.classList.remove("is-success");
        }, 240);
      }, 3000);
    }

    function selectionProgressCopy(count) {
      if (count === 0) return "0 of 2 selected";
      if (count === 1) return "1 more to unlock BOGO";
      return "BOGO unlocked!";
    }

    function variantLabelFromCard(card) {
      if (!card) return "";
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || !sel.options.length) return "";
      var opt = sel.options[sel.selectedIndex];
      var variantLabel = (opt.getAttribute("data-variant-label") || opt.textContent || "")
        .replace(/\s*-\s*[^-]+$/, "")
        .replace(/\s*—\s*Sold out\s*$/, "")
        .trim();
      if (!variantLabel || variantLabel === "Default Title") return "";
      return variantLabel;
    }

    function selectionLabelFromCard(card) {
      if (!card) return "";
      var title = card.getAttribute("data-st11-title") || "";
      var variant = variantLabelFromCard(card);
      return variant ? title + " (" + variant + ")" : title;
    }

    function buildTooltipMessage(triggerCard) {
      if (selected.length >= MAX_SELECT) {
        return (
          "Selected: " +
          selectionLabelFromCard(selected[0].el) +
          " + " +
          selectionLabelFromCard(selected[1].el)
        );
      }
      if (triggerCard) {
        return "Selected: " + selectionLabelFromCard(triggerCard);
      }
      if (!selected.length) return "";
      return "Selected: " + selectionLabelFromCard(selected[0].el);
    }

    var tooltipTimer = null;

    function stickyStatusCopy(count) {
      if (count < MAX_SELECT) return offerCopy;
      if (stickyMqCompact.matches) return "";
      return "1 item free with code " + discountCode;
    }

    function updateStickyStatusPresentation(count) {
      if (!stickyStatus) return;
      var isReady = count >= MAX_SELECT;
      stickyStatus.classList.toggle("is-offer-pulse", count < MAX_SELECT);
      stickyStatus.hidden = isReady && stickyMqCompact.matches;
    }

    function updateGridStatus(count) {
      if (!gridStatus) return;
      gridStatus.textContent = selectionProgressCopy(count);
      gridStatus.classList.toggle("is-unlocked", count >= MAX_SELECT);
    }

    function updateSticky() {
      var count = selected.length;
      var isReady = count >= MAX_SELECT;
      if (sticky) sticky.classList.toggle("is-bogo-ready", isReady);
      if (stickyCta) stickyCta.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbsWrap) stickyThumbsWrap.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        selected.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) {
        stickyEmpty.hidden = count > 0;
      }
      if (stickyBadge) {
        stickyBadge.textContent = String(count);
        stickyBadge.classList.toggle("is-active", count > 0);
      }

      if (count === 0) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(0);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select products";
      } else if (count === 1) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(1);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select 1 More";
      } else {
        var total = selected[0].price + selected[1].price;
        var freeAmt = Math.min(selected[0].price, selected[1].price);
        var pay = total - freeAmt;
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(2);
        if (stickyPrice) {
          stickyPrice.hidden = false;
          if (stickyNow) stickyNow.textContent = money(pay);
          if (stickyWas) stickyWas.textContent = money(total);
        }
        if (stickyCtaText) stickyCtaText.textContent = "CLAIM NOW";
      }

      updateStickyStatusPresentation(count);
      updateGridStatus(count);

      function shopSectionVisible() {
        if (!shop) return false;
        var r = shop.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      var show = count >= 1 || scrollY() > scrollThreshold() || shopSectionVisible();
      if (sticky) {
        if (show) {
          revealSticky(sticky, root);
        } else {
          hideSticky(sticky, root);
        }
      }
    }

    function showTooltip(triggerCard) {
      if (!tooltip) return;
      anchorStickyTooltip();
      var msg = buildTooltipMessage(triggerCard);
      if (!msg) return;
      tooltip.textContent = msg;
      tooltip.hidden = false;
      if (tooltipTimer) clearTimeout(tooltipTimer);
      tooltipTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
      }, 3200);
    }

    function filterReviews(key) {
      var chips = root.querySelectorAll("[data-st11-rev-filter]");
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute(
          "aria-pressed",
          chips[i].getAttribute("data-st11-rev-filter") === key ? "true" : "false"
        );
      }
      var cards = root.querySelectorAll("[data-st11-review]");
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var match = key === "all" || cards[j].getAttribute("data-st11-skin") === key;
        cards[j].hidden = !match;
        if (match) shown++;
      }
      var countEl = root.querySelector("[data-st11-rev-count]");
      if (countEl) {
        countEl.textContent = "Showing " + shown + " review" + (shown === 1 ? "" : "s");
      }
    }

    function initCountdown() {
      var el = root.querySelector('[data-st11-countdown]');
      if (!el) return;
      var timeEl = el.querySelector('[data-st11-countdown-time]');
      if (!timeEl) return;
      var mins = parseInt(el.getAttribute('data-st11-countdown-mins'), 10) || 120;
      var totalSecs = mins * 60;
      var remaining = totalSecs;
      var timerId = null;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function render() {
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      function tick() {
        render();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (remaining <= 0) {
          remaining = totalSecs;
        } else {
          remaining -= 1;
        }
        timerId = setTimeout(tick, 1000);
      }
      tick();
    }

    function selectionIndicesForCard(card) {
      var indices = [];
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].el === card) indices.push(i);
      }
      return indices;
    }

    function cardSelectionCount(card) {
      return selectionIndicesForCard(card).length;
    }

    function removeLastSelectionForCard(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].el === card) {
          selected.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function addSelectionForCard(card) {
      if (card.getAttribute("data-st11-available") !== "true") return false;
      var cardCount = cardSelectionCount(card);
      if (cardCount >= 2) return false;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return false;
      }
      selected.push(cardData(card));
      if (cardCount === 0) {
        card.setAttribute("data-st11-bogo-phase", "first");
      } else if (selected.length === MAX_SELECT) {
        card.setAttribute("data-st11-bogo-phase", "both");
      }
      return true;
    }

    function decrementCard(card) {
      if (!removeLastSelectionForCard(card)) return;
      var cardCount = cardSelectionCount(card);
      if (cardCount === 0) {
        card.removeAttribute("data-st11-bogo-phase");
      } else if (cardCount === 1 && card.getAttribute("data-st11-bogo-phase") === "both") {
        card.setAttribute("data-st11-bogo-phase", "one-after-both");
      }
      refreshGridCards();
      updateSticky();
    }

    function incrementCard(card) {
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function refreshGridCards() {
      var cards = root.querySelectorAll('[data-st11-card][data-st11-mode="select"]');
      cards.forEach(function (card) {
        var slotIndices = selectionIndicesForCard(card);
        var cardCount = slotIndices.length;
        var isSel = cardCount > 0;
        var isFree = slotIndices.indexOf(1) > -1;
        card.classList.toggle("is-selected", isSel);
        card.classList.toggle("is-free", isFree);
        card.setAttribute("aria-pressed", isSel ? "true" : "false");
        if (!isSel) card.removeAttribute("data-st11-bogo-phase");

        var btn = card.querySelector("[data-st11-toggle]");
        var txt = card.querySelector("[data-st11-btn-text]");
        var btnCheck = card.querySelector("[data-st11-btn-check]");
        var qtyWrap = card.querySelector("[data-st11-qty]");
        var qtyCount = card.querySelector("[data-st11-qty-count]");
        var qtyMinus = card.querySelector("[data-st11-qty-minus]");
        var qtyPlus = card.querySelector("[data-st11-qty-plus]");
        var slotsFullElsewhere = selected.length >= MAX_SELECT && cardCount < 2;

        if (btn) {
          btn.hidden = isSel;
          btn.setAttribute("aria-pressed", isSel ? "true" : "false");
        }
        if (qtyWrap) {
          qtyWrap.hidden = !isSel;
          qtyWrap.setAttribute("aria-hidden", isSel ? "false" : "true");
        }
        if (qtyCount) qtyCount.textContent = String(cardCount);
        if (qtyMinus) qtyMinus.disabled = cardCount <= 0;
        if (qtyPlus) {
          qtyPlus.disabled = cardCount >= 2 || slotsFullElsewhere;
        }
        if (btnCheck) btnCheck.hidden = !isSel;
        if (txt && btn && !isSel) {
          txt.textContent = btn.getAttribute("data-st11-base-label") || "Select";
        }

        var label = card.querySelector("[data-st11-selected-label]");
        if (label) {
          if (!isSel) {
            label.textContent = "";
          } else if (cardCount >= 2) {
            label.textContent = "\u00d72";
          } else {
            label.textContent = String(slotIndices[0] + 1);
          }
        }

        var freeNow = card.querySelector("[data-st11-free-now]");
        if (freeNow) freeNow.hidden = !isFree;
      });
    }

    function toggleSelect(card) {
      if (card.getAttribute("data-st11-available") !== "true") return;
      var cardCount = cardSelectionCount(card);
      if (cardCount > 0) return;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return;
      }
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function selectionToCartItems(selections) {
      var qtyByVariant = {};
      selections.forEach(function (c) {
        var id = Number(c.variant);
        qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
      });
      return Object.keys(qtyByVariant).map(function (id) {
        return { id: Number(id), quantity: qtyByVariant[id] };
      });
    }

    var modalApi = null;

    function ensureModalApi() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) {
        return null;
      }
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selected.map(function (s) {
            return Number(s.variant);
          });
        },
        getParentProductIds: function () {
          return selected.map(function (s) {
            return Number(s.id);
          });
        },
        getParentCartItems: function () {
          return selectionToCartItems(selected);
        },
        canCheckout: function () {
          return selected.length >= MAX_SELECT;
        },
        onCheckoutBlocked: function () {
          showToast("Please select 2 products first");
        },
        onStickySuppress: function (on) {
          if (stickyApiFn) stickyApiFn.suppress(on);
        },
      });
      return modalApi;
    }

    function openModal() {
      var api = ensureModalApi();
      if (api && typeof api.open === "function") {
        api.open();
        return;
      }
      if (window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.open === "function") {
        ensureModalApi();
        window.BBELP.modal.open();
        return;
      }
      showToast("Please tap CLAIM NOW again");
    }

    window.setTimeout(function () {
      ensureModalApi();
    }, 0);

    root.addEventListener("bbe:lp-upsells:checkoutBlocked", function (e) {
      var reason = e.detail && e.detail.reason;
      if (reason === "upsell_required_for_gift" || reason === "upsell_required") {
        showToast("Please select an add-on item first");
        return;
      }
      if (reason === "free_gift_limit_reached") {
        showToast("You can only claim one free gift.");
        return;
      }
      showToast("Please select 2 products first");
    });

    /* ---- events ---- */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var card = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      e.preventDefault();
      toggleSelect(card);
    });

    root.addEventListener("click", function (e) {
      var qtyMinus = e.target.closest("[data-st11-qty-minus]");
      if (qtyMinus && root.contains(qtyMinus)) {
        var minusCard = qtyMinus.closest("[data-st11-card]");
        if (minusCard && minusCard.getAttribute("data-st11-mode") === "select") {
          decrementCard(minusCard);
        }
        return;
      }

      var qtyPlus = e.target.closest("[data-st11-qty-plus]");
      if (qtyPlus && root.contains(qtyPlus)) {
        var plusCard = qtyPlus.closest("[data-st11-card]");
        if (plusCard && plusCard.getAttribute("data-st11-mode") === "select") {
          incrementCard(plusCard);
        }
        return;
      }

      var toggle = e.target.closest("[data-st11-toggle]");
      if (toggle && root.contains(toggle)) {
        var card = toggle.closest("[data-st11-card]");
        if (!card) return;
        if (card.getAttribute("data-st11-mode") === "select") {
          toggleSelect(card);
        }
        return;
      }

      /* Main grid: entire card toggles selection (select mode only) */
      var gridCard = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (gridCard && root.contains(gridCard)) {
        if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
        e.preventDefault();
        toggleSelect(gridCard);
        return;
      }

      if (e.target.closest("[data-st11-cta-scroll], [data-lp-listicle-scroll]")) {
        if (selected.length === MAX_SELECT) {
          openModal();
        } else {
          scrollToShopSection(shop);
        }
        return;
      }

      var revFilter = e.target.closest("[data-st11-rev-filter]");
      if (revFilter && root.contains(revFilter)) {
        filterReviews(revFilter.getAttribute("data-st11-rev-filter"));
        return;
      }

      var copyBtn = e.target.closest("[data-st11-copy-code], [data-lp-copy-code]");
      if (copyBtn) {
        var code = copyBtn.getAttribute("data-st11-code") || copyBtn.getAttribute("data-lp-code") || discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              showToast("Code " + code + " copied", { tone: "success" });
            },
            function () {
              showToast("Code: " + code);
            }
          );
        } else {
          showToast("Code: " + code);
        }
        return;
      }
    });

    function applyVariantSelect(sel) {
      var card = sel.closest("[data-st11-card]");
      if (!card || card.getAttribute("data-st11-mode") !== "select") return;
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(opt.getAttribute("data-compare"), 10) || 0;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", price);
      card.setAttribute("data-st11-compare", compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      if (nowEl) nowEl.textContent = money(price);
      var compareEl = card.querySelector("[data-st11-compare-display]");
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : "";
      var data = cardData(card);
      var touched = false;
      for (var si = 0; si < selected.length; si++) {
        if (selected[si].el === card) {
          selected[si] = data;
          touched = true;
        }
      }
      if (touched) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      applyVariantSelect(sel);
    });

    function onStickyCtaClick(e) {
      e.preventDefault();
      if (selected.length === MAX_SELECT) {
        openModal();
      } else {
        scrollToShopSection(shop);
      }
    }

    if (root.dataset.st11StickyDocClick !== "1") {
      root.dataset.st11StickyDocClick = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lp-sticky-cta]")) return;
        var bar = e.target.closest("[data-lp-sticky]");
        if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
        onStickyCtaClick(e);
      });
    }

    function onScrollUpdate() {
      updateSticky();
    }
    var scrollOpts = { passive: true };
    window.addEventListener("scroll", onScrollUpdate, scrollOpts);
    document.addEventListener("scroll", onScrollUpdate, scrollOpts);
    if (document.documentElement) {
      document.documentElement.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }
    var scrollRoot = document.getElementById("MainContent");
    if (scrollRoot) {
      scrollRoot.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }

    if (typeof stickyMqCompact.addEventListener === "function") {
      stickyMqCompact.addEventListener("change", updateSticky);
    } else if (typeof stickyMqCompact.addListener === "function") {
      stickyMqCompact.addListener(updateSticky);
    }

    // Year auto-fill (footer copyright is server-rendered; this is a safety net)
    root.querySelectorAll("[data-st11-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });

    initCountdown();
    updateSticky();
    requestAnimationFrame(updateSticky);
  }

  function boot() {
    document.querySelectorAll("[data-st11-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector("[data-st11-root]")
      : null;
    if (root) {
      root.dataset.st11Bound = "";
      init(root);
    }
  });
})();

/* ---- Collection sort (client-side reorder by data-st11-price) ---- */
(function(){
  function sortGrid(select){
    var scope = select.closest('.lp-col-bogo-st-15') || document;
    var grid = scope.querySelector('[data-lp-shop-grid] .lp-grid--products') || scope.querySelector('.lp-grid--products');
    if(!grid){ return; }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.lp-collection-card:not(.lp-collection-card--placeholder)'));
    cards.forEach(function(c, i){ if(!c.dataset.st14Order){ c.dataset.st14Order = String(i); } });
    var mode = select.value;
    cards.sort(function(a, b){
      if(mode === 'best'){ return (parseInt(a.dataset.st14Order, 10) || 0) - (parseInt(b.dataset.st14Order, 10) || 0); }
      var pa = parseInt(a.getAttribute('data-st11-price'), 10); if(isNaN(pa)){ pa = 0; }
      var pb = parseInt(b.getAttribute('data-st11-price'), 10); if(isNaN(pb)){ pb = 0; }
      return mode === 'priceAsc' ? pa - pb : pb - pa;
    });
    cards.forEach(function(c){ grid.appendChild(c); });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-sort]'), function(sel){
    sortGrid(sel);
    sel.addEventListener('change', function(){ sortGrid(sel); });
  });
})();

/* ---- In-page shade quiz (standalone; independent of locked shade-picker/popup) ---- */
(function(){
  var QUESTIONS = [
    { q: "Does your skin burn easily?", a: [["Yes, very easily", "light"], ["Sometimes", "medium"], ["Rarely \u2014 I tan", "dark"]] },
    { q: "What's your natural skin tone?", a: [["Fair / porcelain", "light"], ["Light to medium", "medium"], ["Olive / dark", "dark"]] },
    { q: "How much color are you after?", a: [["Just a subtle hint", "light"], ["A natural, sun-kissed glow", "medium"], ["A dark, back-from-vacation tan", "dark"]] },
    { q: "How often do you use Self Tanner?", a: [["I'm a first-timer", "light"], ["Every now and then", "medium"], ["It's part of my routine", "dark"]] },
    { q: "Your dream result is\u2026", a: [["Barely-there radiance", "light"], ["Believable bronze", "medium"], ["Bold, dark color", "dark"]] }
  ];
  function initQuiz(card){
    var stage = card.querySelector('[data-st14-quiz-stage]');
    var result = card.querySelector('[data-st14-quiz-result]');
    var dots = card.querySelector('[data-st14-quiz-dots]');
    var shadeEls = card.querySelectorAll('[data-st14-quiz-shade], [data-st14-quiz-shade-2]');
    var restart = card.querySelector('[data-st14-quiz-restart]');
    if(!stage || !result){ return; }
    var step = 0, scores = { light: 0, medium: 0, dark: 0 };
    function renderDots(){
      if(!dots){ return; }
      dots.innerHTML = '';
      for(var i = 0; i < QUESTIONS.length; i++){
        var d = document.createElement('span');
        d.className = 'st14-quiz__dot' + (i === step ? ' is-active' : '');
        dots.appendChild(d);
      }
    }
    function renderStep(){
      var item = QUESTIONS[step];
      var html = '<p class="st14-quiz__step-count">Question ' + (step + 1) + ' of ' + QUESTIONS.length + '</p>';
      html += '<h2 class="st14-quiz__q">' + item.q + '</h2><div class="st14-quiz__options">';
      item.a.forEach(function(opt, idx){
        html += '<button type="button" class="st14-quiz__opt" data-shade="' + opt[1] + '"><span class="st14-quiz__opt-index">' + String.fromCharCode(65 + idx) + '</span><span>' + opt[0] + '</span></button>';
      });
      html += '</div>';
      stage.innerHTML = html;
      stage.hidden = false;
      if(dots){ dots.hidden = false; }
      renderDots();
      Array.prototype.forEach.call(stage.querySelectorAll('.st14-quiz__opt'), function(btn){
        btn.addEventListener('click', function(){
          var s = btn.getAttribute('data-shade');
          if(scores[s] !== undefined){ scores[s]++; }
          step++;
          if(step >= QUESTIONS.length){ showResult(); } else { renderStep(); }
        });
      });
    }
    function bestShade(){
      var best = 'medium', bestN = -1;
      ['light', 'medium', 'dark'].forEach(function(k){ if(scores[k] > bestN){ bestN = scores[k]; best = k; } });
      return best.charAt(0).toUpperCase() + best.slice(1);
    }
    function showResult(){
      var shade = bestShade();
      Array.prototype.forEach.call(shadeEls, function(el){ el.textContent = shade; });
      stage.hidden = true;
      if(dots){ dots.hidden = true; }
      result.hidden = false;
    }
    if(restart){
      restart.addEventListener('click', function(){
        step = 0; scores = { light: 0, medium: 0, dark: 0 };
        result.hidden = true;
        renderStep();
      });
    }
    renderStep();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-quiz]'), initQuiz);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-bogo-st-18"] && !Shopify.designMode) return;
  try {
    
/* =============================================================================
   lp-col-bogo-st-18 (inline section JS) — advertorial BOGO LP behavior (st-11 + st-12).
   Dependency-free, idempotent. Reuses the shared framework button-loading
   helper (window.BBELP.setLoading) from lp-scripts.js. Scoped per [data-st11-root].

   Behaviors: select-2 BOGO grid, sticky selection bar, 2-step upsell modal
   (add-on + free gift), checkout (POST /cart/add.js then discount redirect chain),
   tap-to-copy code, and toast. Core content + product links work without JS.
============================================================================= */
(function () {
  "use strict";

  var SCROLL_THRESHOLD = 200;
  var MAX_SELECT = 2;

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function scrollY() {
    var api = stickyApi();
    if (api) return api.scrollY();
    return Math.max(window.scrollY || 0, window.pageYOffset || 0);
  }

  function scrollThreshold() {
    var api = stickyApi();
    if (api) return api.scrollThreshold(80, SCROLL_THRESHOLD);
    return window.matchMedia("(max-width: 767px)").matches ? 80 : SCROLL_THRESHOLD;
  }

  function scrollToShopSection(el) {
    var api = stickyApi();
    if (api) {
      api.scrollTo(el);
      return;
    }
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.reveal(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.hide(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    sticky.hidden = true;
    sticky.setAttribute("hidden", "");
  }

  function setLoading(el, on) {
    if (window.BBELP && typeof window.BBELP.setLoading === "function") {
      window.BBELP.setLoading(el, on);
    } else if (el) {
      el.classList.toggle("is-loading", on !== false);
    }
  }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function cardData(card) {
    return {
      el: card,
      id: card.getAttribute("data-st11-id"),
      variant: card.getAttribute("data-st11-variant"),
      price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
      title: card.getAttribute("data-st11-title") || "",
      img: card.getAttribute("data-st11-img") || "",
      available: card.getAttribute("data-st11-available") === "true",
    };
  }

  function init(root) {
    if (root.dataset.st11Bound === "1") return;
    root.dataset.st11Bound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-st11-config") || "{}");
    } catch (e) {
      config = {};
    }
    var discountCode = config.discountCode || "BOGO";
    var offerCopy = config.offerCopy || "Buy 1, Get 1 Free";

    var selected = []; // grid cards (max 2)

    var rootId = root.id || "";
    var stickyApiFn = stickyApi();
    var sticky = stickyApiFn ? stickyApiFn.resolve(root, rootId) : root.querySelector("[data-lp-sticky]");
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCta = sticky ? sticky.querySelector("[data-lp-sticky-cta]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;
    var stickyThumbsWrap = sticky ? sticky.querySelector(".lp-sticky__thumbs") : null;
    var gridStatus = root.querySelector("[data-st11-grid-status]");
    var tooltip = sticky ? sticky.querySelector("[data-lp-sticky-tooltip]") : null;

    function anchorStickyTooltip() {
      if (!tooltip || !stickyCta) return;
      if (tooltip.parentElement !== stickyCta) {
        stickyCta.appendChild(tooltip);
      }
    }

    anchorStickyTooltip();

    var shop = root.querySelector("#shop") || root.querySelector("[data-st11-sticky-anchor]");
    var toast = root.querySelector("[data-st11-toast]");
    var toastText = root.querySelector("[data-st11-toast-text]");
    var toastTimer = null;
    var stickyMqCompact = window.matchMedia("(max-width: 767px)");

    function showToast(msg, opts) {
      if (!toast) return;
      opts = opts || {};
      var tone = opts.tone === "success" ? "success" : "info";
      if (toastText && msg) toastText.textContent = msg;
      toast.classList.toggle("is-success", tone === "success");
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
          toast.classList.remove("is-success");
        }, 240);
      }, 3000);
    }

    function selectionProgressCopy(count) {
      if (count === 0) return "0 of 2 selected";
      if (count === 1) return "1 more to unlock BOGO";
      return "BOGO unlocked!";
    }

    function variantLabelFromCard(card) {
      if (!card) return "";
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || !sel.options.length) return "";
      var opt = sel.options[sel.selectedIndex];
      var variantLabel = (opt.getAttribute("data-variant-label") || opt.textContent || "")
        .replace(/\s*-\s*[^-]+$/, "")
        .replace(/\s*—\s*Sold out\s*$/, "")
        .trim();
      if (!variantLabel || variantLabel === "Default Title") return "";
      return variantLabel;
    }

    function selectionLabelFromCard(card) {
      if (!card) return "";
      var title = card.getAttribute("data-st11-title") || "";
      var variant = variantLabelFromCard(card);
      return variant ? title + " (" + variant + ")" : title;
    }

    function buildTooltipMessage(triggerCard) {
      if (selected.length >= MAX_SELECT) {
        return (
          "Selected: " +
          selectionLabelFromCard(selected[0].el) +
          " + " +
          selectionLabelFromCard(selected[1].el)
        );
      }
      if (triggerCard) {
        return "Selected: " + selectionLabelFromCard(triggerCard);
      }
      if (!selected.length) return "";
      return "Selected: " + selectionLabelFromCard(selected[0].el);
    }

    var tooltipTimer = null;

    function stickyStatusCopy(count) {
      if (count < MAX_SELECT) return offerCopy;
      if (stickyMqCompact.matches) return "";
      return "1 item free with code " + discountCode;
    }

    function updateStickyStatusPresentation(count) {
      if (!stickyStatus) return;
      var isReady = count >= MAX_SELECT;
      stickyStatus.classList.toggle("is-offer-pulse", count < MAX_SELECT);
      stickyStatus.hidden = isReady && stickyMqCompact.matches;
    }

    function updateGridStatus(count) {
      if (!gridStatus) return;
      gridStatus.textContent = selectionProgressCopy(count);
      gridStatus.classList.toggle("is-unlocked", count >= MAX_SELECT);
    }

    function updateSticky() {
      var count = selected.length;
      var isReady = count >= MAX_SELECT;
      if (sticky) sticky.classList.toggle("is-bogo-ready", isReady);
      if (stickyCta) stickyCta.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbsWrap) stickyThumbsWrap.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        selected.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) {
        stickyEmpty.hidden = count > 0;
      }
      if (stickyBadge) {
        stickyBadge.textContent = String(count);
        stickyBadge.classList.toggle("is-active", count > 0);
      }

      if (count === 0) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(0);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select products";
      } else if (count === 1) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(1);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select 1 More";
      } else {
        var total = selected[0].price + selected[1].price;
        var freeAmt = Math.min(selected[0].price, selected[1].price);
        var pay = total - freeAmt;
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(2);
        if (stickyPrice) {
          stickyPrice.hidden = false;
          if (stickyNow) stickyNow.textContent = money(pay);
          if (stickyWas) stickyWas.textContent = money(total);
        }
        if (stickyCtaText) stickyCtaText.textContent = "CLAIM NOW";
      }

      updateStickyStatusPresentation(count);
      updateGridStatus(count);

      function shopSectionVisible() {
        if (!shop) return false;
        var r = shop.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      var show = count >= 1 || scrollY() > scrollThreshold() || shopSectionVisible();
      if (sticky) {
        if (show) {
          revealSticky(sticky, root);
        } else {
          hideSticky(sticky, root);
        }
      }
    }

    function showTooltip(triggerCard) {
      if (!tooltip) return;
      anchorStickyTooltip();
      var msg = buildTooltipMessage(triggerCard);
      if (!msg) return;
      tooltip.textContent = msg;
      tooltip.hidden = false;
      if (tooltipTimer) clearTimeout(tooltipTimer);
      tooltipTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
      }, 3200);
    }

    function filterReviews(key) {
      var chips = root.querySelectorAll("[data-st11-rev-filter]");
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute(
          "aria-pressed",
          chips[i].getAttribute("data-st11-rev-filter") === key ? "true" : "false"
        );
      }
      var cards = root.querySelectorAll("[data-st11-review]");
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var match = key === "all" || cards[j].getAttribute("data-st11-skin") === key;
        cards[j].hidden = !match;
        if (match) shown++;
      }
      var countEl = root.querySelector("[data-st11-rev-count]");
      if (countEl) {
        countEl.textContent = "Showing " + shown + " review" + (shown === 1 ? "" : "s");
      }
    }

    function initCountdown() {
      var el = root.querySelector('[data-st11-countdown]');
      if (!el) return;
      var timeEl = el.querySelector('[data-st11-countdown-time]');
      if (!timeEl) return;
      var mins = parseInt(el.getAttribute('data-st11-countdown-mins'), 10) || 120;
      var totalSecs = mins * 60;
      var remaining = totalSecs;
      var timerId = null;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function render() {
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      function tick() {
        render();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (remaining <= 0) {
          remaining = totalSecs;
        } else {
          remaining -= 1;
        }
        timerId = setTimeout(tick, 1000);
      }
      tick();
    }

    function selectionIndicesForCard(card) {
      var indices = [];
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].el === card) indices.push(i);
      }
      return indices;
    }

    function cardSelectionCount(card) {
      return selectionIndicesForCard(card).length;
    }

    function removeLastSelectionForCard(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].el === card) {
          selected.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function addSelectionForCard(card) {
      if (card.getAttribute("data-st11-available") !== "true") return false;
      var cardCount = cardSelectionCount(card);
      if (cardCount >= 2) return false;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return false;
      }
      selected.push(cardData(card));
      if (cardCount === 0) {
        card.setAttribute("data-st11-bogo-phase", "first");
      } else if (selected.length === MAX_SELECT) {
        card.setAttribute("data-st11-bogo-phase", "both");
      }
      return true;
    }

    function decrementCard(card) {
      if (!removeLastSelectionForCard(card)) return;
      var cardCount = cardSelectionCount(card);
      if (cardCount === 0) {
        card.removeAttribute("data-st11-bogo-phase");
      } else if (cardCount === 1 && card.getAttribute("data-st11-bogo-phase") === "both") {
        card.setAttribute("data-st11-bogo-phase", "one-after-both");
      }
      refreshGridCards();
      updateSticky();
    }

    function incrementCard(card) {
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function refreshGridCards() {
      var cards = root.querySelectorAll('[data-st11-card][data-st11-mode="select"]');
      cards.forEach(function (card) {
        var slotIndices = selectionIndicesForCard(card);
        var cardCount = slotIndices.length;
        var isSel = cardCount > 0;
        var isFree = slotIndices.indexOf(1) > -1;
        card.classList.toggle("is-selected", isSel);
        card.classList.toggle("is-free", isFree);
        card.setAttribute("aria-pressed", isSel ? "true" : "false");
        if (!isSel) card.removeAttribute("data-st11-bogo-phase");

        var btn = card.querySelector("[data-st11-toggle]");
        var txt = card.querySelector("[data-st11-btn-text]");
        var btnCheck = card.querySelector("[data-st11-btn-check]");
        var qtyWrap = card.querySelector("[data-st11-qty]");
        var qtyCount = card.querySelector("[data-st11-qty-count]");
        var qtyMinus = card.querySelector("[data-st11-qty-minus]");
        var qtyPlus = card.querySelector("[data-st11-qty-plus]");
        var slotsFullElsewhere = selected.length >= MAX_SELECT && cardCount < 2;

        if (btn) {
          btn.hidden = isSel;
          btn.setAttribute("aria-pressed", isSel ? "true" : "false");
        }
        if (qtyWrap) {
          qtyWrap.hidden = !isSel;
          qtyWrap.setAttribute("aria-hidden", isSel ? "false" : "true");
        }
        if (qtyCount) qtyCount.textContent = String(cardCount);
        if (qtyMinus) qtyMinus.disabled = cardCount <= 0;
        if (qtyPlus) {
          qtyPlus.disabled = cardCount >= 2 || slotsFullElsewhere;
        }
        if (btnCheck) btnCheck.hidden = !isSel;
        if (txt && btn && !isSel) {
          txt.textContent = btn.getAttribute("data-st11-base-label") || "Select";
        }

        var label = card.querySelector("[data-st11-selected-label]");
        if (label) {
          if (!isSel) {
            label.textContent = "";
          } else if (cardCount >= 2) {
            label.textContent = "\u00d72";
          } else {
            label.textContent = String(slotIndices[0] + 1);
          }
        }

        var freeNow = card.querySelector("[data-st11-free-now]");
        if (freeNow) freeNow.hidden = !isFree;
      });
    }

    function toggleSelect(card) {
      if (card.getAttribute("data-st11-available") !== "true") return;
      var cardCount = cardSelectionCount(card);
      if (cardCount > 0) return;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return;
      }
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function selectionToCartItems(selections) {
      var qtyByVariant = {};
      selections.forEach(function (c) {
        var id = Number(c.variant);
        qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
      });
      return Object.keys(qtyByVariant).map(function (id) {
        return { id: Number(id), quantity: qtyByVariant[id] };
      });
    }

    var modalApi = null;

    function ensureModalApi() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) {
        return null;
      }
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selected.map(function (s) {
            return Number(s.variant);
          });
        },
        getParentProductIds: function () {
          return selected.map(function (s) {
            return Number(s.id);
          });
        },
        getParentCartItems: function () {
          return selectionToCartItems(selected);
        },
        canCheckout: function () {
          return selected.length >= MAX_SELECT;
        },
        onCheckoutBlocked: function () {
          showToast("Please select 2 products first");
        },
        onStickySuppress: function (on) {
          if (stickyApiFn) stickyApiFn.suppress(on);
        },
      });
      return modalApi;
    }

    function openModal() {
      var api = ensureModalApi();
      if (api && typeof api.open === "function") {
        api.open();
        return;
      }
      if (window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.open === "function") {
        ensureModalApi();
        window.BBELP.modal.open();
        return;
      }
      showToast("Please tap CLAIM NOW again");
    }

    window.setTimeout(function () {
      ensureModalApi();
    }, 0);

    root.addEventListener("bbe:lp-upsells:checkoutBlocked", function (e) {
      var reason = e.detail && e.detail.reason;
      if (reason === "upsell_required_for_gift" || reason === "upsell_required") {
        showToast("Please select an add-on item first");
        return;
      }
      if (reason === "free_gift_limit_reached") {
        showToast("You can only claim one free gift.");
        return;
      }
      showToast("Please select 2 products first");
    });

    /* ---- events ---- */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var card = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      e.preventDefault();
      toggleSelect(card);
    });

    root.addEventListener("click", function (e) {
      var qtyMinus = e.target.closest("[data-st11-qty-minus]");
      if (qtyMinus && root.contains(qtyMinus)) {
        var minusCard = qtyMinus.closest("[data-st11-card]");
        if (minusCard && minusCard.getAttribute("data-st11-mode") === "select") {
          decrementCard(minusCard);
        }
        return;
      }

      var qtyPlus = e.target.closest("[data-st11-qty-plus]");
      if (qtyPlus && root.contains(qtyPlus)) {
        var plusCard = qtyPlus.closest("[data-st11-card]");
        if (plusCard && plusCard.getAttribute("data-st11-mode") === "select") {
          incrementCard(plusCard);
        }
        return;
      }

      var toggle = e.target.closest("[data-st11-toggle]");
      if (toggle && root.contains(toggle)) {
        var card = toggle.closest("[data-st11-card]");
        if (!card) return;
        if (card.getAttribute("data-st11-mode") === "select") {
          toggleSelect(card);
        }
        return;
      }

      /* Main grid: entire card toggles selection (select mode only) */
      var gridCard = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (gridCard && root.contains(gridCard)) {
        if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
        e.preventDefault();
        toggleSelect(gridCard);
        return;
      }

      if (e.target.closest("[data-st11-cta-scroll], [data-lp-listicle-scroll]")) {
        if (selected.length === MAX_SELECT) {
          openModal();
        } else {
          scrollToShopSection(shop);
        }
        return;
      }

      var revFilter = e.target.closest("[data-st11-rev-filter]");
      if (revFilter && root.contains(revFilter)) {
        filterReviews(revFilter.getAttribute("data-st11-rev-filter"));
        return;
      }

      var copyBtn = e.target.closest("[data-st11-copy-code], [data-lp-copy-code]");
      if (copyBtn) {
        var code = copyBtn.getAttribute("data-st11-code") || copyBtn.getAttribute("data-lp-code") || discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              showToast("Code " + code + " copied", { tone: "success" });
            },
            function () {
              showToast("Code: " + code);
            }
          );
        } else {
          showToast("Code: " + code);
        }
        return;
      }
    });

    function applyVariantSelect(sel) {
      var card = sel.closest("[data-st11-card]");
      if (!card || card.getAttribute("data-st11-mode") !== "select") return;
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(opt.getAttribute("data-compare"), 10) || 0;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", price);
      card.setAttribute("data-st11-compare", compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      if (nowEl) nowEl.textContent = money(price);
      var compareEl = card.querySelector("[data-st11-compare-display]");
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : "";
      var data = cardData(card);
      var touched = false;
      for (var si = 0; si < selected.length; si++) {
        if (selected[si].el === card) {
          selected[si] = data;
          touched = true;
        }
      }
      if (touched) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      applyVariantSelect(sel);
    });

    function onStickyCtaClick(e) {
      e.preventDefault();
      if (selected.length === MAX_SELECT) {
        openModal();
      } else {
        scrollToShopSection(shop);
      }
    }

    if (root.dataset.st11StickyDocClick !== "1") {
      root.dataset.st11StickyDocClick = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lp-sticky-cta]")) return;
        var bar = e.target.closest("[data-lp-sticky]");
        if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
        onStickyCtaClick(e);
      });
    }

    function onScrollUpdate() {
      updateSticky();
    }
    var scrollOpts = { passive: true };
    window.addEventListener("scroll", onScrollUpdate, scrollOpts);
    document.addEventListener("scroll", onScrollUpdate, scrollOpts);
    if (document.documentElement) {
      document.documentElement.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }
    var scrollRoot = document.getElementById("MainContent");
    if (scrollRoot) {
      scrollRoot.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }

    if (typeof stickyMqCompact.addEventListener === "function") {
      stickyMqCompact.addEventListener("change", updateSticky);
    } else if (typeof stickyMqCompact.addListener === "function") {
      stickyMqCompact.addListener(updateSticky);
    }

    // Year auto-fill (footer copyright is server-rendered; this is a safety net)
    root.querySelectorAll("[data-st11-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });

    initCountdown();
    updateSticky();
    requestAnimationFrame(updateSticky);
  }

  function boot() {
    document.querySelectorAll("[data-st11-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector("[data-st11-root]")
      : null;
    if (root) {
      root.dataset.st11Bound = "";
      init(root);
    }
  });
})();

/* ---- Collection sort (client-side reorder by data-st11-price) ---- */
(function(){
  function sortGrid(select){
    var scope = select.closest('.lp-col-bogo-st-18') || document;
    var grid = scope.querySelector('[data-lp-shop-grid] .lp-grid--products') || scope.querySelector('.lp-grid--products');
    if(!grid){ return; }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.lp-collection-card:not(.lp-collection-card--placeholder)'));
    cards.forEach(function(c, i){ if(!c.dataset.st14Order){ c.dataset.st14Order = String(i); } });
    var mode = select.value;
    cards.sort(function(a, b){
      if(mode === 'best'){ return (parseInt(a.dataset.st14Order, 10) || 0) - (parseInt(b.dataset.st14Order, 10) || 0); }
      var pa = parseInt(a.getAttribute('data-st11-price'), 10); if(isNaN(pa)){ pa = 0; }
      var pb = parseInt(b.getAttribute('data-st11-price'), 10); if(isNaN(pb)){ pb = 0; }
      return mode === 'priceAsc' ? pa - pb : pb - pa;
    });
    cards.forEach(function(c){ grid.appendChild(c); });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-sort]'), function(sel){
    sortGrid(sel);
    sel.addEventListener('change', function(){ sortGrid(sel); });
  });
})();

/* ---- In-page shade quiz (standalone; independent of locked shade-picker/popup) ---- */
(function(){
  var QUESTIONS = [
    { q: "Does your skin burn easily?", a: [["Yes, very easily", "light"], ["Sometimes", "medium"], ["Rarely \u2014 I tan", "dark"]] },
    { q: "What's your natural skin tone?", a: [["Fair / porcelain", "light"], ["Light to medium", "medium"], ["Olive / dark", "dark"]] },
    { q: "How much color are you after?", a: [["Just a subtle hint", "light"], ["A natural, sun-kissed glow", "medium"], ["A dark, back-from-vacation tan", "dark"]] },
    { q: "How often do you use Self Tanner?", a: [["I'm a first-timer", "light"], ["Every now and then", "medium"], ["It's part of my routine", "dark"]] },
    { q: "Your dream result is\u2026", a: [["Barely-there radiance", "light"], ["Believable bronze", "medium"], ["Bold, dark color", "dark"]] }
  ];
  function initQuiz(card){
    var stage = card.querySelector('[data-st14-quiz-stage]');
    var result = card.querySelector('[data-st14-quiz-result]');
    var dots = card.querySelector('[data-st14-quiz-dots]');
    var shadeEls = card.querySelectorAll('[data-st14-quiz-shade], [data-st14-quiz-shade-2]');
    var restart = card.querySelector('[data-st14-quiz-restart]');
    if(!stage || !result){ return; }
    var step = 0, scores = { light: 0, medium: 0, dark: 0 };
    function renderDots(){
      if(!dots){ return; }
      dots.innerHTML = '';
      for(var i = 0; i < QUESTIONS.length; i++){
        var d = document.createElement('span');
        d.className = 'st14-quiz__dot' + (i === step ? ' is-active' : '');
        dots.appendChild(d);
      }
    }
    function renderStep(){
      var item = QUESTIONS[step];
      var html = '<p class="st14-quiz__step-count">Question ' + (step + 1) + ' of ' + QUESTIONS.length + '</p>';
      html += '<h2 class="st14-quiz__q">' + item.q + '</h2><div class="st14-quiz__options">';
      item.a.forEach(function(opt, idx){
        html += '<button type="button" class="st14-quiz__opt" data-shade="' + opt[1] + '"><span class="st14-quiz__opt-index">' + String.fromCharCode(65 + idx) + '</span><span>' + opt[0] + '</span></button>';
      });
      html += '</div>';
      stage.innerHTML = html;
      stage.hidden = false;
      if(dots){ dots.hidden = false; }
      renderDots();
      Array.prototype.forEach.call(stage.querySelectorAll('.st14-quiz__opt'), function(btn){
        btn.addEventListener('click', function(){
          var s = btn.getAttribute('data-shade');
          if(scores[s] !== undefined){ scores[s]++; }
          step++;
          if(step >= QUESTIONS.length){ showResult(); } else { renderStep(); }
        });
      });
    }
    function bestShade(){
      var best = 'medium', bestN = -1;
      ['light', 'medium', 'dark'].forEach(function(k){ if(scores[k] > bestN){ bestN = scores[k]; best = k; } });
      return best.charAt(0).toUpperCase() + best.slice(1);
    }
    function showResult(){
      var shade = bestShade();
      Array.prototype.forEach.call(shadeEls, function(el){ el.textContent = shade; });
      stage.hidden = true;
      if(dots){ dots.hidden = true; }
      result.hidden = false;
    }
    if(restart){
      restart.addEventListener('click', function(){
        step = 0; scores = { light: 0, medium: 0, dark: 0 };
        result.hidden = true;
        renderStep();
      });
    }
    renderStep();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-quiz]'), initQuiz);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-bogo-st-21"] && !Shopify.designMode) return;
  try {
    
/* =============================================================================
   lp-col-bogo-st-21 (inline section JS) — advertorial BOGO LP behavior (st-11 + st-12).
   Dependency-free, idempotent. Reuses the shared framework button-loading
   helper (window.BBELP.setLoading) from lp-scripts.js. Scoped per [data-st11-root].

   Behaviors: select-2 BOGO grid, sticky selection bar, 2-step upsell modal
   (add-on + free gift), checkout (POST /cart/add.js then discount redirect chain),
   tap-to-copy code, and toast. Core content + product links work without JS.
============================================================================= */
(function () {
  "use strict";

  var SCROLL_THRESHOLD = 200;
  var MAX_SELECT = 2;

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function scrollY() {
    var api = stickyApi();
    if (api) return api.scrollY();
    return Math.max(window.scrollY || 0, window.pageYOffset || 0);
  }

  function scrollThreshold() {
    var api = stickyApi();
    if (api) return api.scrollThreshold(80, SCROLL_THRESHOLD);
    return window.matchMedia("(max-width: 767px)").matches ? 80 : SCROLL_THRESHOLD;
  }

  function scrollToShopSection(el) {
    var api = stickyApi();
    if (api) {
      api.scrollTo(el);
      return;
    }
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.reveal(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.hide(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    sticky.hidden = true;
    sticky.setAttribute("hidden", "");
  }

  function setLoading(el, on) {
    if (window.BBELP && typeof window.BBELP.setLoading === "function") {
      window.BBELP.setLoading(el, on);
    } else if (el) {
      el.classList.toggle("is-loading", on !== false);
    }
  }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function cardData(card) {
    return {
      el: card,
      id: card.getAttribute("data-st11-id"),
      variant: card.getAttribute("data-st11-variant"),
      price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
      title: card.getAttribute("data-st11-title") || "",
      img: card.getAttribute("data-st11-img") || "",
      available: card.getAttribute("data-st11-available") === "true",
    };
  }

  function init(root) {
    if (root.dataset.st11Bound === "1") return;
    root.dataset.st11Bound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-st11-config") || "{}");
    } catch (e) {
      config = {};
    }
    var discountCode = config.discountCode || "BOGO";
    var offerCopy = config.offerCopy || "Buy 1, Get 1 Free";

    var selected = []; // grid cards (max 2)

    var rootId = root.id || "";
    var stickyApiFn = stickyApi();
    var sticky = stickyApiFn ? stickyApiFn.resolve(root, rootId) : root.querySelector("[data-lp-sticky]");
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCta = sticky ? sticky.querySelector("[data-lp-sticky-cta]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;
    var stickyThumbsWrap = sticky ? sticky.querySelector(".lp-sticky__thumbs") : null;
    var gridStatus = root.querySelector("[data-st11-grid-status]");
    var tooltip = sticky ? sticky.querySelector("[data-lp-sticky-tooltip]") : null;

    function anchorStickyTooltip() {
      if (!tooltip || !stickyCta) return;
      if (tooltip.parentElement !== stickyCta) {
        stickyCta.appendChild(tooltip);
      }
    }

    anchorStickyTooltip();

    var shop = root.querySelector("#shop") || root.querySelector("[data-st11-sticky-anchor]");
    var toast = root.querySelector("[data-st11-toast]");
    var toastText = root.querySelector("[data-st11-toast-text]");
    var toastTimer = null;
    var stickyMqCompact = window.matchMedia("(max-width: 767px)");

    function showToast(msg, opts) {
      if (!toast) return;
      opts = opts || {};
      var tone = opts.tone === "success" ? "success" : "info";
      if (toastText && msg) toastText.textContent = msg;
      toast.classList.toggle("is-success", tone === "success");
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
          toast.classList.remove("is-success");
        }, 240);
      }, 3000);
    }

    function selectionProgressCopy(count) {
      if (count === 0) return "0 of 2 selected";
      if (count === 1) return "1 more to unlock BOGO";
      return "BOGO unlocked!";
    }

    function variantLabelFromCard(card) {
      if (!card) return "";
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || !sel.options.length) return "";
      var opt = sel.options[sel.selectedIndex];
      var variantLabel = (opt.getAttribute("data-variant-label") || opt.textContent || "")
        .replace(/\s*-\s*[^-]+$/, "")
        .replace(/\s*—\s*Sold out\s*$/, "")
        .trim();
      if (!variantLabel || variantLabel === "Default Title") return "";
      return variantLabel;
    }

    function selectionLabelFromCard(card) {
      if (!card) return "";
      var title = card.getAttribute("data-st11-title") || "";
      var variant = variantLabelFromCard(card);
      return variant ? title + " (" + variant + ")" : title;
    }

    function buildTooltipMessage(triggerCard) {
      if (selected.length >= MAX_SELECT) {
        return (
          "Selected: " +
          selectionLabelFromCard(selected[0].el) +
          " + " +
          selectionLabelFromCard(selected[1].el)
        );
      }
      if (triggerCard) {
        return "Selected: " + selectionLabelFromCard(triggerCard);
      }
      if (!selected.length) return "";
      return "Selected: " + selectionLabelFromCard(selected[0].el);
    }

    var tooltipTimer = null;

    function stickyStatusCopy(count) {
      if (count < MAX_SELECT) return offerCopy;
      if (stickyMqCompact.matches) return "";
      return "1 item free with code " + discountCode;
    }

    function updateStickyStatusPresentation(count) {
      if (!stickyStatus) return;
      var isReady = count >= MAX_SELECT;
      stickyStatus.classList.toggle("is-offer-pulse", count < MAX_SELECT);
      stickyStatus.hidden = isReady && stickyMqCompact.matches;
    }

    function updateGridStatus(count) {
      if (!gridStatus) return;
      gridStatus.textContent = selectionProgressCopy(count);
      gridStatus.classList.toggle("is-unlocked", count >= MAX_SELECT);
    }

    function updateSticky() {
      var count = selected.length;
      var isReady = count >= MAX_SELECT;
      if (sticky) sticky.classList.toggle("is-bogo-ready", isReady);
      if (stickyCta) stickyCta.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbsWrap) stickyThumbsWrap.classList.toggle("is-bogo-ready", isReady);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        selected.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) {
        stickyEmpty.hidden = count > 0;
      }
      if (stickyBadge) {
        stickyBadge.textContent = String(count);
        stickyBadge.classList.toggle("is-active", count > 0);
      }

      if (count === 0) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(0);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select products";
      } else if (count === 1) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(1);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = "Select 1 More";
      } else {
        var total = selected[0].price + selected[1].price;
        var freeAmt = Math.min(selected[0].price, selected[1].price);
        var pay = total - freeAmt;
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(2);
        if (stickyPrice) {
          stickyPrice.hidden = false;
          if (stickyNow) stickyNow.textContent = money(pay);
          if (stickyWas) stickyWas.textContent = money(total);
        }
        if (stickyCtaText) stickyCtaText.textContent = "CLAIM NOW";
      }

      updateStickyStatusPresentation(count);
      updateGridStatus(count);

      function shopSectionVisible() {
        if (!shop) return false;
        var r = shop.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      var show = count >= 1 || scrollY() > scrollThreshold() || shopSectionVisible();
      if (sticky) {
        if (show) {
          revealSticky(sticky, root);
        } else {
          hideSticky(sticky, root);
        }
      }
    }

    function showTooltip(triggerCard) {
      if (!tooltip) return;
      anchorStickyTooltip();
      var msg = buildTooltipMessage(triggerCard);
      if (!msg) return;
      tooltip.textContent = msg;
      tooltip.hidden = false;
      if (tooltipTimer) clearTimeout(tooltipTimer);
      tooltipTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
      }, 3200);
    }

    function filterReviews(key) {
      var chips = root.querySelectorAll("[data-st11-rev-filter]");
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute(
          "aria-pressed",
          chips[i].getAttribute("data-st11-rev-filter") === key ? "true" : "false"
        );
      }
      var cards = root.querySelectorAll("[data-st11-review]");
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var match = key === "all" || cards[j].getAttribute("data-st11-skin") === key;
        cards[j].hidden = !match;
        if (match) shown++;
      }
      var countEl = root.querySelector("[data-st11-rev-count]");
      if (countEl) {
        countEl.textContent = "Showing " + shown + " review" + (shown === 1 ? "" : "s");
      }
    }

    function initCountdown() {
      var el = root.querySelector('[data-st11-countdown]');
      if (!el) return;
      var timeEl = el.querySelector('[data-st11-countdown-time]');
      if (!timeEl) return;
      var mins = parseInt(el.getAttribute('data-st11-countdown-mins'), 10) || 120;
      var totalSecs = mins * 60;
      var remaining = totalSecs;
      var timerId = null;
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function render() {
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      function tick() {
        render();
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (remaining <= 0) {
          remaining = totalSecs;
        } else {
          remaining -= 1;
        }
        timerId = setTimeout(tick, 1000);
      }
      tick();
    }

    function selectionIndicesForCard(card) {
      var indices = [];
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].el === card) indices.push(i);
      }
      return indices;
    }

    function cardSelectionCount(card) {
      return selectionIndicesForCard(card).length;
    }

    function removeLastSelectionForCard(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].el === card) {
          selected.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function addSelectionForCard(card) {
      if (card.getAttribute("data-st11-available") !== "true") return false;
      var cardCount = cardSelectionCount(card);
      if (cardCount >= 2) return false;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return false;
      }
      selected.push(cardData(card));
      if (cardCount === 0) {
        card.setAttribute("data-st11-bogo-phase", "first");
      } else if (selected.length === MAX_SELECT) {
        card.setAttribute("data-st11-bogo-phase", "both");
      }
      return true;
    }

    function decrementCard(card) {
      if (!removeLastSelectionForCard(card)) return;
      var cardCount = cardSelectionCount(card);
      if (cardCount === 0) {
        card.removeAttribute("data-st11-bogo-phase");
      } else if (cardCount === 1 && card.getAttribute("data-st11-bogo-phase") === "both") {
        card.setAttribute("data-st11-bogo-phase", "one-after-both");
      }
      refreshGridCards();
      updateSticky();
    }

    function incrementCard(card) {
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function refreshGridCards() {
      var cards = root.querySelectorAll('[data-st11-card][data-st11-mode="select"]');
      cards.forEach(function (card) {
        var slotIndices = selectionIndicesForCard(card);
        var cardCount = slotIndices.length;
        var isSel = cardCount > 0;
        var isFree = slotIndices.indexOf(1) > -1;
        card.classList.toggle("is-selected", isSel);
        card.classList.toggle("is-free", isFree);
        card.setAttribute("aria-pressed", isSel ? "true" : "false");
        if (!isSel) card.removeAttribute("data-st11-bogo-phase");

        var btn = card.querySelector("[data-st11-toggle]");
        var txt = card.querySelector("[data-st11-btn-text]");
        var btnCheck = card.querySelector("[data-st11-btn-check]");
        var qtyWrap = card.querySelector("[data-st11-qty]");
        var qtyCount = card.querySelector("[data-st11-qty-count]");
        var qtyMinus = card.querySelector("[data-st11-qty-minus]");
        var qtyPlus = card.querySelector("[data-st11-qty-plus]");
        var slotsFullElsewhere = selected.length >= MAX_SELECT && cardCount < 2;

        if (btn) {
          btn.hidden = isSel;
          btn.setAttribute("aria-pressed", isSel ? "true" : "false");
        }
        if (qtyWrap) {
          qtyWrap.hidden = !isSel;
          qtyWrap.setAttribute("aria-hidden", isSel ? "false" : "true");
        }
        if (qtyCount) qtyCount.textContent = String(cardCount);
        if (qtyMinus) qtyMinus.disabled = cardCount <= 0;
        if (qtyPlus) {
          qtyPlus.disabled = cardCount >= 2 || slotsFullElsewhere;
        }
        if (btnCheck) btnCheck.hidden = !isSel;
        if (txt && btn && !isSel) {
          txt.textContent = btn.getAttribute("data-st11-base-label") || "Select";
        }

        var label = card.querySelector("[data-st11-selected-label]");
        if (label) {
          if (!isSel) {
            label.textContent = "";
          } else if (cardCount >= 2) {
            label.textContent = "\u00d72";
          } else {
            label.textContent = String(slotIndices[0] + 1);
          }
        }

        var freeNow = card.querySelector("[data-st11-free-now]");
        if (freeNow) freeNow.hidden = !isFree;
      });
    }

    function toggleSelect(card) {
      if (card.getAttribute("data-st11-available") !== "true") return;
      var cardCount = cardSelectionCount(card);
      if (cardCount > 0) return;
      if (selected.length >= MAX_SELECT) {
        showToast("Deselect an item to swap your pick");
        return;
      }
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function selectionToCartItems(selections) {
      var qtyByVariant = {};
      selections.forEach(function (c) {
        var id = Number(c.variant);
        qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
      });
      return Object.keys(qtyByVariant).map(function (id) {
        return { id: Number(id), quantity: qtyByVariant[id] };
      });
    }

    var modalApi = null;

    function ensureModalApi() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) {
        return null;
      }
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selected.map(function (s) {
            return Number(s.variant);
          });
        },
        getParentProductIds: function () {
          return selected.map(function (s) {
            return Number(s.id);
          });
        },
        getParentCartItems: function () {
          return selectionToCartItems(selected);
        },
        canCheckout: function () {
          return selected.length >= MAX_SELECT;
        },
        onCheckoutBlocked: function () {
          showToast("Please select 2 products first");
        },
        onStickySuppress: function (on) {
          if (stickyApiFn) stickyApiFn.suppress(on);
        },
      });
      return modalApi;
    }

    function openModal() {
      var api = ensureModalApi();
      if (api && typeof api.open === "function") {
        api.open();
        return;
      }
      if (window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.open === "function") {
        ensureModalApi();
        window.BBELP.modal.open();
        return;
      }
      showToast("Please tap CLAIM NOW again");
    }

    window.setTimeout(function () {
      ensureModalApi();
    }, 0);

    root.addEventListener("bbe:lp-upsells:checkoutBlocked", function (e) {
      var reason = e.detail && e.detail.reason;
      if (reason === "upsell_required_for_gift" || reason === "upsell_required") {
        showToast("Please select an add-on item first");
        return;
      }
      if (reason === "free_gift_limit_reached") {
        showToast("You can only claim one free gift.");
        return;
      }
      showToast("Please select 2 products first");
    });

    /* ---- events ---- */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var card = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      e.preventDefault();
      toggleSelect(card);
    });

    root.addEventListener("click", function (e) {
      var qtyMinus = e.target.closest("[data-st11-qty-minus]");
      if (qtyMinus && root.contains(qtyMinus)) {
        var minusCard = qtyMinus.closest("[data-st11-card]");
        if (minusCard && minusCard.getAttribute("data-st11-mode") === "select") {
          decrementCard(minusCard);
        }
        return;
      }

      var qtyPlus = e.target.closest("[data-st11-qty-plus]");
      if (qtyPlus && root.contains(qtyPlus)) {
        var plusCard = qtyPlus.closest("[data-st11-card]");
        if (plusCard && plusCard.getAttribute("data-st11-mode") === "select") {
          incrementCard(plusCard);
        }
        return;
      }

      var toggle = e.target.closest("[data-st11-toggle]");
      if (toggle && root.contains(toggle)) {
        var card = toggle.closest("[data-st11-card]");
        if (!card) return;
        if (card.getAttribute("data-st11-mode") === "select") {
          toggleSelect(card);
        }
        return;
      }

      /* Main grid: entire card toggles selection (select mode only) */
      var gridCard = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (gridCard && root.contains(gridCard)) {
        if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
        e.preventDefault();
        toggleSelect(gridCard);
        return;
      }

      if (e.target.closest("[data-st11-cta-scroll], [data-lp-listicle-scroll]")) {
        if (selected.length === MAX_SELECT) {
          openModal();
        } else {
          scrollToShopSection(shop);
        }
        return;
      }

      var revFilter = e.target.closest("[data-st11-rev-filter]");
      if (revFilter && root.contains(revFilter)) {
        filterReviews(revFilter.getAttribute("data-st11-rev-filter"));
        return;
      }

      var copyBtn = e.target.closest("[data-st11-copy-code], [data-lp-copy-code]");
      if (copyBtn) {
        var code = copyBtn.getAttribute("data-st11-code") || copyBtn.getAttribute("data-lp-code") || discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              showToast("Code " + code + " copied", { tone: "success" });
            },
            function () {
              showToast("Code: " + code);
            }
          );
        } else {
          showToast("Code: " + code);
        }
        return;
      }
    });

    function applyVariantSelect(sel) {
      var card = sel.closest("[data-st11-card]");
      if (!card || card.getAttribute("data-st11-mode") !== "select") return;
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(opt.getAttribute("data-compare"), 10) || 0;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", price);
      card.setAttribute("data-st11-compare", compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      if (nowEl) nowEl.textContent = money(price);
      var compareEl = card.querySelector("[data-st11-compare-display]");
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : "";
      var data = cardData(card);
      var touched = false;
      for (var si = 0; si < selected.length; si++) {
        if (selected[si].el === card) {
          selected[si] = data;
          touched = true;
        }
      }
      if (touched) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      applyVariantSelect(sel);
    });

    function onStickyCtaClick(e) {
      e.preventDefault();
      if (selected.length === MAX_SELECT) {
        openModal();
      } else {
        scrollToShopSection(shop);
      }
    }

    if (root.dataset.st11StickyDocClick !== "1") {
      root.dataset.st11StickyDocClick = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lp-sticky-cta]")) return;
        var bar = e.target.closest("[data-lp-sticky]");
        if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
        onStickyCtaClick(e);
      });
    }

    function onScrollUpdate() {
      updateSticky();
    }
    var scrollOpts = { passive: true };
    window.addEventListener("scroll", onScrollUpdate, scrollOpts);
    document.addEventListener("scroll", onScrollUpdate, scrollOpts);
    if (document.documentElement) {
      document.documentElement.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }
    var scrollRoot = document.getElementById("MainContent");
    if (scrollRoot) {
      scrollRoot.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }

    if (typeof stickyMqCompact.addEventListener === "function") {
      stickyMqCompact.addEventListener("change", updateSticky);
    } else if (typeof stickyMqCompact.addListener === "function") {
      stickyMqCompact.addListener(updateSticky);
    }

    // Year auto-fill (footer copyright is server-rendered; this is a safety net)
    root.querySelectorAll("[data-st11-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });

    initCountdown();
    updateSticky();
    requestAnimationFrame(updateSticky);
  }

  function boot() {
    document.querySelectorAll("[data-st11-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector("[data-st11-root]")
      : null;
    if (root) {
      root.dataset.st11Bound = "";
      init(root);
    }
  });
})();

/* ---- Collection sort (client-side reorder by data-st11-price) ---- */
(function(){
  function sortGrid(select){
    var scope = select.closest('.lp-col-bogo-st-21') || document;
    var grid = scope.querySelector('[data-lp-shop-grid] .lp-grid--products') || scope.querySelector('.lp-grid--products');
    if(!grid){ return; }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.lp-collection-card:not(.lp-collection-card--placeholder)'));
    cards.forEach(function(c, i){ if(!c.dataset.st14Order){ c.dataset.st14Order = String(i); } });
    var mode = select.value;
    cards.sort(function(a, b){
      if(mode === 'best'){ return (parseInt(a.dataset.st14Order, 10) || 0) - (parseInt(b.dataset.st14Order, 10) || 0); }
      var pa = parseInt(a.getAttribute('data-st11-price'), 10); if(isNaN(pa)){ pa = 0; }
      var pb = parseInt(b.getAttribute('data-st11-price'), 10); if(isNaN(pb)){ pb = 0; }
      return mode === 'priceAsc' ? pa - pb : pb - pa;
    });
    cards.forEach(function(c){ grid.appendChild(c); });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-sort]'), function(sel){
    sortGrid(sel);
    sel.addEventListener('change', function(){ sortGrid(sel); });
  });
})();

/* ---- In-page shade quiz (standalone; independent of locked shade-picker/popup) ---- */
(function(){
  var QUESTIONS = [
    { q: "Does your skin burn easily?", a: [["Yes, very easily", "light"], ["Sometimes", "medium"], ["Rarely \u2014 I tan", "dark"]] },
    { q: "What's your natural skin tone?", a: [["Fair / porcelain", "light"], ["Light to medium", "medium"], ["Olive / dark", "dark"]] },
    { q: "How much color are you after?", a: [["Just a subtle hint", "light"], ["A natural, sun-kissed glow", "medium"], ["A dark, back-from-vacation tan", "dark"]] },
    { q: "How often do you use Self Tanner?", a: [["I'm a first-timer", "light"], ["Every now and then", "medium"], ["It's part of my routine", "dark"]] },
    { q: "Your dream result is\u2026", a: [["Barely-there radiance", "light"], ["Believable bronze", "medium"], ["Bold, dark color", "dark"]] }
  ];
  function initQuiz(card){
    var stage = card.querySelector('[data-st14-quiz-stage]');
    var result = card.querySelector('[data-st14-quiz-result]');
    var dots = card.querySelector('[data-st14-quiz-dots]');
    var shadeEls = card.querySelectorAll('[data-st14-quiz-shade], [data-st14-quiz-shade-2]');
    var restart = card.querySelector('[data-st14-quiz-restart]');
    if(!stage || !result){ return; }
    var step = 0, scores = { light: 0, medium: 0, dark: 0 };
    function renderDots(){
      if(!dots){ return; }
      dots.innerHTML = '';
      for(var i = 0; i < QUESTIONS.length; i++){
        var d = document.createElement('span');
        d.className = 'st14-quiz__dot' + (i === step ? ' is-active' : '');
        dots.appendChild(d);
      }
    }
    function renderStep(){
      var item = QUESTIONS[step];
      var html = '<p class="st14-quiz__step-count">Question ' + (step + 1) + ' of ' + QUESTIONS.length + '</p>';
      html += '<h2 class="st14-quiz__q">' + item.q + '</h2><div class="st14-quiz__options">';
      item.a.forEach(function(opt, idx){
        html += '<button type="button" class="st14-quiz__opt" data-shade="' + opt[1] + '"><span class="st14-quiz__opt-index">' + String.fromCharCode(65 + idx) + '</span><span>' + opt[0] + '</span></button>';
      });
      html += '</div>';
      stage.innerHTML = html;
      stage.hidden = false;
      if(dots){ dots.hidden = false; }
      renderDots();
      Array.prototype.forEach.call(stage.querySelectorAll('.st14-quiz__opt'), function(btn){
        btn.addEventListener('click', function(){
          var s = btn.getAttribute('data-shade');
          if(scores[s] !== undefined){ scores[s]++; }
          step++;
          if(step >= QUESTIONS.length){ showResult(); } else { renderStep(); }
        });
      });
    }
    function bestShade(){
      var best = 'medium', bestN = -1;
      ['light', 'medium', 'dark'].forEach(function(k){ if(scores[k] > bestN){ bestN = scores[k]; best = k; } });
      return best.charAt(0).toUpperCase() + best.slice(1);
    }
    function showResult(){
      var shade = bestShade();
      Array.prototype.forEach.call(shadeEls, function(el){ el.textContent = shade; });
      stage.hidden = true;
      if(dots){ dots.hidden = true; }
      result.hidden = false;
    }
    if(restart){
      restart.addEventListener('click', function(){
        step = 0; scores = { light: 0, medium: 0, dark: 0 };
        result.hidden = true;
        renderStep();
      });
    }
    renderStep();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-st14-quiz]'), initQuiz);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-bogo-st-24"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.querySelector('[data-st11-root]');
  if (!root) return;

  /* ---- Hero video play/mute ---- */
  var bubble = root.querySelector('[data-ag-hero-bubble]');
  if (bubble) {
    var vid = bubble.querySelector('video');
    if (vid) {
      bubble.classList.add('is-muted');
      vid.muted = true;
      var playBtn = bubble.querySelector('[data-ag-play-toggle]');
      var muteBtn = bubble.querySelector('[data-ag-mute-toggle]');
      if (playBtn) {
        playBtn.addEventListener('click', function() {
          if (vid.paused) { vid.play().catch(function(){}); bubble.classList.add('is-playing'); }
          else { vid.pause(); bubble.classList.remove('is-playing'); }
        });
      }
      if (muteBtn) {
        muteBtn.addEventListener('click', function() {
          vid.muted = !vid.muted;
          bubble.classList.toggle('is-muted', vid.muted);
        });
      }
    }
  }

  /* ---- Shop: category chips + toolbar + sort + filters ---- */
  var catBar = root.querySelector('[data-ag-shop-cats]');
  var grid = root.querySelector('[data-lp-shop-grid] .lp-grid--products') || root.querySelector('.st11-grid');
  var sortSelect = root.querySelector('[data-ag-sort]');
  var filterToggle = root.querySelector('[data-ag-filter-toggle]');
  var filterDrawer = root.querySelector('[data-ag-filter-drawer]');
  var shopLayout = root.querySelector('[data-ag-shop-layout]');
  var countEl = root.querySelector('[data-ag-product-count]');
  var activeChipsWrap = root.querySelector('[data-ag-active-chips]');

  var _activeCat = 'all';
  var _activeFilters = {};
  var _activeSort = 'featured';
  var _filtersOpen = false;

  function getAllCards() {
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll('.lp-collection-card'));
  }

  function cardHay(card) {
    return ((card.getAttribute('data-st11-title') || '') + ' ' +
            (card.getAttribute('data-product-type') || '') + ' ' +
            (card.textContent || '')).toLowerCase();
  }

  function catMatch(card, cat) {
    if (cat === 'all') return true;
    var hay = cardHay(card);
    if (cat === 'best') return card.querySelector('.lp-collection-card__badge') != null || hay.indexOf('best') >= 0 || hay.indexOf('bestseller') >= 0;
    if (cat === 'tanners') return hay.indexOf('lotion') >= 0 || hay.indexOf('mousse') >= 0 || hay.indexOf('spray') >= 0 || hay.indexOf('drops') >= 0 || hay.indexOf('tanner') >= 0 || hay.indexOf('tanning') >= 0;
    if (cat === 'tools') return hay.indexOf('tool') >= 0 || hay.indexOf('mitt') >= 0 || hay.indexOf('brush') >= 0 || hay.indexOf('applicator') >= 0;
    if (cat === 'face') return hay.indexOf('face') >= 0;
    if (cat === 'hair') return hay.indexOf('hair') >= 0;
    if (cat === 'lips') return hay.indexOf('lip') >= 0;
    return hay.indexOf(cat) >= 0;
  }

  function filterMatch(card) {
    var keys = Object.keys(_activeFilters);
    for (var k = 0; k < keys.length; k++) {
      var vals = _activeFilters[keys[k]];
      if (!vals || vals.length === 0) continue;
      var hay = cardHay(card);
      var matched = false;
      for (var v = 0; v < vals.length; v++) {
        if (hay.indexOf(vals[v].toLowerCase()) >= 0) { matched = true; break; }
      }
      if (!matched) return false;
    }
    return true;
  }

  function isMysteryBox(card) {
    var hay = cardHay(card);
    return hay.indexOf('mystery') >= 0 && hay.indexOf('box') >= 0;
  }

  function applyFilters() {
    var cards = getAllCards();
    var visible = [];
    cards.forEach(function(card) {
      if (isMysteryBox(card)) { card.style.display = 'none'; return; }
      var show = catMatch(card, _activeCat) && filterMatch(card);
      card.style.display = show ? '' : 'none';
      if (show) visible.push(card);
    });
    if (countEl) countEl.innerHTML = '<strong>' + visible.length + '</strong> products';
    applySort(visible);
    renderActiveChips();
  }

  function applySort(cards) {
    if (!grid || _activeSort === 'featured') return;
    var sorted = cards.slice().sort(function(a, b) {
      var pa = parseInt(a.getAttribute('data-st11-price') || '0', 10);
      var pb = parseInt(b.getAttribute('data-st11-price') || '0', 10);
      if (_activeSort === 'pricelow') return pa - pb;
      if (_activeSort === 'pricehigh') return pb - pa;
      return 0;
    });
    sorted.forEach(function(c) { grid.appendChild(c); });
  }

  function renderActiveChips() {
    if (!activeChipsWrap) return;
    var chips = [];
    Object.keys(_activeFilters).forEach(function(key) {
      (_activeFilters[key] || []).forEach(function(val) {
        chips.push({ key: key, val: val });
      });
    });
    if (chips.length === 0) { activeChipsWrap.hidden = true; return; }
    activeChipsWrap.hidden = false;
    var html = '';
    chips.forEach(function(c) {
      html += '<button type="button" class="ag-active-chip" data-ag-remove-filter="' + c.key + ':' + c.val + '">' + c.val +
        ' <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#2F4B6E" stroke-width="2.6"><path d="M18 6L6 18M6 6l12 12"/></svg></button>';
    });
    html += '<button type="button" class="ag-active-chips__clear" data-ag-clear-filters>Clear all</button>';
    activeChipsWrap.innerHTML = html;
    activeChipsWrap.querySelectorAll('[data-ag-remove-filter]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var parts = btn.getAttribute('data-ag-remove-filter').split(':');
        toggleFilter(parts[0], parts[1]);
      });
    });
    var clearBtn = activeChipsWrap.querySelector('[data-ag-clear-filters]');
    if (clearBtn) clearBtn.addEventListener('click', function() { _activeFilters = {}; buildFilterOpts(); applyFilters(); });
  }

  function toggleFilter(key, val) {
    if (!_activeFilters[key]) _activeFilters[key] = [];
    var idx = _activeFilters[key].indexOf(val);
    if (idx >= 0) _activeFilters[key].splice(idx, 1);
    else _activeFilters[key].push(val);
    buildFilterOpts();
    applyFilters();
  }

  function buildFilterOpts() {
    if (!filterDrawer) return;
    var groups = filterDrawer.querySelectorAll('[data-ag-filter-group]');
    groups.forEach(function(g) {
      var key = g.getAttribute('data-ag-filter-group');
      var optsWrap = g.querySelector('.ag-filter-group__opts');
      if (!optsWrap) return;
      var optMap = {};
      getAllCards().forEach(function(card) {
        if (isMysteryBox(card)) return;
        var hay = cardHay(card);
        var items = [];
        if (key === 'type') items = ['Lotion', 'Mousse', 'Drops', 'Spray', 'Face', 'Kit', 'Tools', 'Body Care', 'Hair', 'Lips'];
        else if (key === 'shade') items = ['Light', 'Medium', 'Dark'];
        else if (key === 'concern') items = ['Muscle Definition', 'Brightening', 'Sensitive'];
        items.forEach(function(item) {
          if (hay.indexOf(item.toLowerCase()) >= 0) {
            optMap[item] = (optMap[item] || 0) + 1;
          }
        });
      });
      var html = '';
      Object.keys(optMap).forEach(function(opt) {
        var isActive = (_activeFilters[key] || []).indexOf(opt) >= 0;
        html += '<button type="button" class="ag-filter-opt' + (isActive ? ' is-active' : '') + '" data-ag-filter="' + key + ':' + opt + '">' +
          '<span class="ag-filter-opt__check"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="' + (isActive ? '#fff' : 'transparent') + '" stroke-width="3.2"><path d="M20 6L9 17l-5-5"/></svg></span>' +
          '<span class="ag-filter-opt__label">' + opt + '</span>' +
          '<span class="ag-filter-opt__count">' + optMap[opt] + '</span>' +
          '</button>';
      });
      optsWrap.innerHTML = html;
      optsWrap.querySelectorAll('[data-ag-filter]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var parts = btn.getAttribute('data-ag-filter').split(':');
          toggleFilter(parts[0], parts[1]);
        });
      });
    });
  }

  if (catBar) {
    var catBtns = catBar.querySelectorAll('[data-ag-cat]');
    catBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        _activeCat = btn.getAttribute('data-ag-cat');
        catBtns.forEach(function(b) {
          var on = b.getAttribute('data-ag-cat') === _activeCat;
          b.classList.toggle('ag-chip--active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilters();
      });
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function() { _activeSort = sortSelect.value; applyFilters(); });
  }

  if (filterToggle && filterDrawer && shopLayout) {
    filterToggle.addEventListener('click', function() {
      _filtersOpen = !_filtersOpen;
      filterDrawer.hidden = !_filtersOpen;
      shopLayout.classList.toggle('has-filters', _filtersOpen);
      filterToggle.classList.toggle('is-open', _filtersOpen);
      if (_filtersOpen) buildFilterOpts();
    });
  }

  /* Initial: hide Mystery Box, set count */
  applyFilters();

  /* BOGO progress: locked assets/lp-bogo-progress.js */

  /* ---- Formula Finder ---- */
  var formulaWrap = root.querySelector('[data-ag-formula]');
  if (!formulaWrap) return;

  var tabs = formulaWrap.querySelectorAll('[data-ag-formula-tab]');
  var panels = formulaWrap.querySelectorAll('[data-ag-formula-panel]');
  var skinChips = formulaWrap.querySelectorAll('[data-ag-skin]');

  function openActiveIngredients() {
    panels.forEach(function(p) {
      var details = p.querySelector('.ag-formula__ingredients');
      if (!details) return;
      if (p.classList.contains('ag-formula__panel--active')) {
        details.open = true;
      } else {
        details.open = false;
      }
    });
  }

  function showFormula(idx, openIngredients) {
    tabs.forEach(function(t) { t.classList.toggle('ag-formula__tab--active', t.getAttribute('data-ag-formula-tab') === String(idx)); });
    panels.forEach(function(p) { p.classList.toggle('ag-formula__panel--active', p.getAttribute('data-ag-formula-panel') === String(idx)); });
    if (openIngredients) openActiveIngredients();
  }

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      showFormula(parseInt(tab.getAttribute('data-ag-formula-tab'), 10), true);
    });
  });

  /* Formula "Shop {name}" → scroll to #shop + activate matching chip */
  root.querySelectorAll('[data-ag-formula-shop]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var handle = btn.getAttribute('data-ag-formula-shop') || '';
      if (catBar) {
        var chipMap = {
          'body-lotion': 'tanners', 'mousse': 'tanners', 'drops': 'tanners',
          'face-lotion': 'face', 'face-mist': 'face'
        };
        var target = chipMap[handle] || 'all';
        var matchBtn = catBar.querySelector('[data-ag-cat="' + target + '"]');
        if (matchBtn) matchBtn.click();
      }
      var shopEl = document.getElementById('shop');
      if (shopEl) shopEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  function skinTokens(attr) {
    return String(attr || '')
      .toLowerCase()
      .split(/[,\s]+/)
      .map(function(t) { return t.trim(); })
      .filter(Boolean);
  }

  function formulaMatchesSkin(skinsAttr, skin) {
    if (skin === 'all') return true;
    var tokens = skinTokens(skinsAttr);
    /* "all" in CSV = available under the All chip only — not every filter */
    return tokens.indexOf(skin) >= 0;
  }

  function filterBySkin(skin) {
    skinChips.forEach(function(c) {
      var active = c.getAttribute('data-ag-skin') === skin;
      c.classList.toggle('ag-chip--active', active);
      c.classList.toggle('is-active', active);
    });
    if (skin === 'all') {
      tabs.forEach(function(t) { t.style.display = ''; });
      showFormula(0, true);
      return;
    }
    var firstVisible = -1;
    var recommendedVisible = -1;
    tabs.forEach(function(t, i) {
      var match = formulaMatchesSkin(t.getAttribute('data-ag-skins'), skin);
      t.style.display = match ? '' : 'none';
      if (match && firstVisible < 0) firstVisible = i;
      if (match && recommendedVisible < 0 && t.querySelector('[data-ag-rec]')) recommendedVisible = i;
    });
    var pick = recommendedVisible >= 0 ? recommendedVisible : firstVisible;
    if (pick >= 0) showFormula(pick, true);
  }

  skinChips.forEach(function(chip) {
    chip.addEventListener('click', function() {
      filterBySkin(chip.getAttribute('data-ag-skin'));
    });
  });
})();

/* ---- Sticky BOGO progress strip (mock layout; no locked sticky edits) ---- */
(function(){
  var root = document.querySelector('.lp-col-bogo-st-24[data-st11-root]');
  if (!root) return;
  var rootId = root.id;
  if (!rootId) return;

  function resolveSticky() {
    return document.querySelector('body > .lp-sticky[data-lp-sticky-root-id="' + rootId + '"]')
      || root.querySelector('[data-lp-sticky]');
  }

  function ensureStrip(sticky) {
    if (!sticky) return null;
    sticky.classList.add('ag-sticky--aruba');
    var existing = sticky.querySelector('[data-ag-sticky-progress]');
    if (existing) return existing;
    var strip = document.createElement('div');
    strip.className = 'ag-sticky-progress';
    strip.setAttribute('data-ag-sticky-progress', '');
    strip.setAttribute('aria-hidden', 'true');
    strip.innerHTML =
      '<div class="ag-sticky-progress__track">' +
        '<div class="ag-sticky-progress__step" data-ag-sticky-step="1">1</div>' +
        '<div class="ag-sticky-progress__bar"><div class="ag-sticky-progress__fill" data-ag-sticky-fill></div></div>' +
        '<div class="ag-sticky-progress__step" data-ag-sticky-step="2">2</div>' +
        '<div class="ag-sticky-progress__label" data-ag-sticky-label>Select 2 products to unlock BOGO</div>' +
      '</div>';
    sticky.insertBefore(strip, sticky.firstChild);
    return strip;
  }

  function updateStrip() {
    var sticky = resolveSticky();
    var strip = ensureStrip(sticky);
    if (!strip) return;
    var selected = root.querySelectorAll('.lp-collection-card.is-selected');
    var n = selected ? selected.length : 0;
    if (n > 2) n = 2;
    var fill = strip.querySelector('[data-ag-sticky-fill]');
    var label = strip.querySelector('[data-ag-sticky-label]');
    var s1 = strip.querySelector('[data-ag-sticky-step="1"]');
    var s2 = strip.querySelector('[data-ag-sticky-step="2"]');
    if (fill) fill.style.width = (n / 2 * 100) + '%';
    if (s1) s1.classList.toggle('is-done', n >= 1);
    if (s2) s2.classList.toggle('is-done', n >= 2);
    if (label) {
      if (n === 0) label.textContent = 'Select 2 products to unlock BOGO';
      else if (n === 1) label.textContent = 'Add 1 more to unlock free item!';
      else label.textContent = 'BOGO unlocked — claim now!';
    }
  }

  var grid = root.querySelector('.lp-grid--products') || root.querySelector('#shop');
  if (grid) {
    new MutationObserver(updateStrip).observe(grid, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }
  document.addEventListener('shopify:section:load', updateStrip);
  setTimeout(updateStrip, 0);
  setTimeout(updateStrip, 400);
})();

/* ---- In-page shade quiz (st14 UX; independent of locked shade-picker) ---- */
(function(){
  var QUESTIONS = [
    { q: "Does your skin burn easily?", a: [["Yes, very easily", "light"], ["Sometimes", "medium"], ["Rarely — I tan", "dark"]] },
    { q: "What's your natural skin tone?", a: [["Fair / porcelain", "light"], ["Light to medium", "medium"], ["Olive / dark", "dark"]] },
    { q: "How much color are you after?", a: [["Just a subtle hint", "light"], ["A natural, sun-kissed glow", "medium"], ["A dark, back-from-vacation tan", "dark"]] },
    { q: "How often do you use Self Tanner?", a: [["I'm a first-timer", "light"], ["Every now and then", "medium"], ["It's part of my routine", "dark"]] },
    { q: "Your dream result is…", a: [["Barely-there radiance", "light"], ["Believable bronze", "medium"], ["Bold, dark color", "dark"]] }
  ];
  function initQuiz(card){
    if(card._agQuizInit) return;
    card._agQuizInit = true;
    var stage = card.querySelector('[data-ag-shade-quiz-stage]');
    var result = card.querySelector('[data-ag-shade-quiz-result]');
    var dots = card.querySelector('[data-ag-shade-quiz-dots]');
    var shadeEls = card.querySelectorAll('[data-ag-shade-quiz-shade], [data-ag-shade-quiz-shade-2]');
    var restart = card.querySelector('[data-ag-shade-quiz-restart]');
    var cta = card.querySelector('[data-ag-shade-quiz-cta]');
    if(!stage || !result){ return; }
    var step = 0, scores = { light: 0, medium: 0, dark: 0 };
    var resultTier = '';
    var resultTitle = '';

    function applyShadeToShopCards(tier, title){
      var detail = {
        tier: tier,
        title: title || (tier.charAt(0).toUpperCase() + tier.slice(1)),
        shade: tier
      };
      var scope = card.closest('[data-st11-root]') || document.querySelector('.lp-col-bogo-st-24[data-st11-root]');
      /* Prefer scoped sync so only this LP's tanner selects update (lp-scripts matching). */
      if (window.BBELP && typeof window.BBELP.syncShadeQuizToVariantSelects === 'function') {
        window.BBELP.syncShadeQuizToVariantSelects(detail, scope || undefined);
        return;
      }
      document.dispatchEvent(new CustomEvent('bbe:shade-quiz:select', { detail: detail, bubbles: true }));
    }

    function renderDots(){
      if(!dots){ return; }
      dots.innerHTML = '';
      for(var i = 0; i < QUESTIONS.length; i++){
        var d = document.createElement('span');
        d.className = 'ag-shade-quiz__dot' + (i === step ? ' is-active' : '');
        dots.appendChild(d);
      }
    }
    function renderStep(){
      var item = QUESTIONS[step];
      var html = '<p class="ag-shade-quiz__step-count">Question ' + (step + 1) + ' of ' + QUESTIONS.length + '</p>';
      html += '<h2 class="ag-shade-quiz__q">' + item.q + '</h2><div class="ag-shade-quiz__options">';
      item.a.forEach(function(opt, idx){
        html += '<button type="button" class="ag-shade-quiz__opt" data-shade="' + opt[1] + '"><span class="ag-shade-quiz__opt-index">' + String.fromCharCode(65 + idx) + '</span><span>' + opt[0] + '</span></button>';
      });
      html += '</div>';
      stage.innerHTML = html;
      stage.hidden = false;
      if(dots){ dots.hidden = false; }
      renderDots();
      Array.prototype.forEach.call(stage.querySelectorAll('.ag-shade-quiz__opt'), function(btn){
        btn.addEventListener('click', function(){
          var s = btn.getAttribute('data-shade');
          if(scores[s] !== undefined){ scores[s]++; }
          step++;
          if(step >= QUESTIONS.length){ showResult(); } else { renderStep(); }
        });
      });
    }
    function bestShadeTier(){
      var best = 'medium', bestN = -1;
      ['light', 'medium', 'dark'].forEach(function(k){ if(scores[k] > bestN){ bestN = scores[k]; best = k; } });
      return best;
    }
    function showResult(){
      resultTier = bestShadeTier();
      resultTitle = resultTier.charAt(0).toUpperCase() + resultTier.slice(1);
      Array.prototype.forEach.call(shadeEls, function(el){ el.textContent = resultTitle; });
      stage.hidden = true;
      if(dots){ dots.hidden = true; }
      result.hidden = false;
    }
    if(cta && !cta._agShadeCtaBound){
      cta._agShadeCtaBound = true;
      cta.addEventListener('click', function(){
        if(!resultTier){ return; }
        applyShadeToShopCards(resultTier, resultTitle);
      });
    }
    if(restart){
      restart.addEventListener('click', function(){
        step = 0; scores = { light: 0, medium: 0, dark: 0 };
        resultTier = '';
        resultTitle = '';
        result.hidden = true;
        renderStep();
      });
    }
    renderStep();
  }
  function bootQuiz(){
    var cards = document.querySelectorAll('[data-ag-shade-quiz]');
    Array.prototype.forEach.call(cards, initQuiz);
  }
  bootQuiz();
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootQuiz);
  }
  document.addEventListener('shopify:section:load', bootQuiz);
})();

/* ---- Upsell modal: glowing urgency on the offer price ---- */
/*
  This block used to also rewrite card prices and swap labels to SWAP/ADD IT.
  Both were forks of framework behaviour that have since diverged from it:

  - The price rewrite applied the badge percentage to EVERY visible card
    without consulting data-st11-offer-pct, so an upsell the transform refuses
    to discount would still have been advertised at a discount. The framework
    card now prices per-card off its own eligibility.
  - SWAP announced single-pick. The upsell-only flow is multi-pick now, so the
    framework's own "Claim offer" / "Selected" labelling is correct and a SWAP
    label would actively mislead.

  What remains is the purely cosmetic glow, applied without touching text.
*/
(function () {
  var root = document.querySelector('.lp-col-bogo-st-24[data-st11-root]');
  if (!root) return;
  var rootId = root.id || '';

  function getModal() {
    return (
      document.querySelector(
        'body > [data-lp-upsells-root][data-st11-root-id="' + rootId + '"]'
      ) ||
      document.querySelector(
        'body > [data-st11-modal][data-st11-root-id="' + rootId + '"]'
      ) ||
      root.querySelector('[data-lp-upsells-root]')
    );
  }

  function markUpsellPrices(modal) {
    if (!modal) return;
    var cards = modal.querySelectorAll('[data-st11-card][data-st11-mode="upsell"]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.hidden) continue;

      var priceEl = card.querySelector('[data-st11-price-display]');
      var compareEl = card.querySelector('[data-st11-compare-display]');

      // Glow only where a discount is genuinely live, so the treatment never
      // draws the eye to a full-price line.
      var pct = parseInt(card.getAttribute('data-st11-offer-pct'), 10);
      if (!isFinite(pct) || pct < 1) continue;

      if (priceEl) priceEl.classList.add('ag-upsell-glow');
      if (compareEl && !compareEl.hidden) compareEl.classList.add('ag-upsell-compare');
    }
  }

  function onModalReady() {
    var modal = getModal();
    if (!modal) return;
    setTimeout(function () {
      markUpsellPrices(modal);
    }, 80);
  }

  root.addEventListener('bbe:lp-upsells:open', onModalReady);

  root.addEventListener('bbe:lp-upsells:variantSelect', function () {
    var modal = getModal();
    if (!modal) return;
    setTimeout(function () {
      markUpsellPrices(modal);
    }, 50);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-bogo-stbm-01"] && !Shopify.designMode) return;
  try {
    
/* =============================================================================
   lp-col-bogo-stbm-01 select-2 BOGO engine (copied from lp-col-bogo-st-11.js; root-scoped).
   Dependency-free, idempotent. Reuses the shared framework button-loading
   helper (window.BBELP.setLoading) from lp-scripts.js. Scoped per [data-st11-root].

   Behaviors: select-2 BOGO grid, sticky selection bar, 2-step upsell modal
   (add-on + free gift), checkout (POST /cart/add.js then discount redirect chain),
   tap-to-copy code, and toast. Core content + product links work without JS.
============================================================================= */
(function () {
  "use strict";

  if (window.__lpColBogoStbm01CoreLoaded) return;
  window.__lpColBogoStbm01CoreLoaded = true;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll(".lp-col-bogo-stbm-01 .stbm-hero__video").forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    if (reduceMotion) {
      video.removeAttribute("autoplay");
      video.pause();
      return;
    }
    var playAttempt = video.play();
    if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
  });

  var SCROLL_THRESHOLD = 200;
  /* One BOGO set = 2 picks. Up to 2 sets (4 picks, 2 free) per order. */
  var SET_SIZE = 2;
  var MAX_SELECT = 4;

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function scrollY() {
    var api = stickyApi();
    if (api) return api.scrollY();
    return Math.max(window.scrollY || 0, window.pageYOffset || 0);
  }

  function scrollThreshold() {
    var api = stickyApi();
    if (api) return api.scrollThreshold(80, SCROLL_THRESHOLD);
    return window.matchMedia("(max-width: 767px)").matches ? 80 : SCROLL_THRESHOLD;
  }

  function scrollToShopSection(el) {
    var api = stickyApi();
    if (api) {
      api.scrollTo(el);
      return;
    }
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.reveal(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.hide(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    sticky.hidden = true;
    sticky.setAttribute("hidden", "");
  }

  function setLoading(el, on) {
    if (window.BBELP && typeof window.BBELP.setLoading === "function") {
      window.BBELP.setLoading(el, on);
    } else if (el) {
      el.classList.toggle("is-loading", on !== false);
    }
  }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function cardData(card) {
    return {
      el: card,
      id: card.getAttribute("data-st11-id"),
      variant: card.getAttribute("data-st11-variant"),
      price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
      title: card.getAttribute("data-st11-title") || "",
      img: card.getAttribute("data-st11-img") || "",
      available: card.getAttribute("data-st11-available") === "true",
    };
  }

  function init(root) {
    if (root.dataset.st11Bound === "1") return;
    root.dataset.st11Bound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-st11-config") || "{}");
    } catch (e) {
      config = {};
    }
    var discountCode = config.discountCode || "BOGO";
    var offerCopy = config.offerCopy || "Buy 1, Get 1 Free";

    var selected = []; // grid picks in order (max MAX_SELECT)

    function isReady(count) {
      return count >= SET_SIZE;
    }

    /* Free picks: sort by price (high first); every second pick is free. */
    function freeIndices() {
      var order = selected
        .map(function (c, i) { return { i: i, price: c.price }; })
        .sort(function (a, b) { return b.price - a.price || a.i - b.i; });
      var free = [];
      for (var k = 1; k < order.length; k += 2) free.push(order[k].i);
      return free;
    }

    function pricing() {
      var total = 0;
      var freeAmt = 0;
      var free = freeIndices();
      selected.forEach(function (c, i) {
        total += c.price;
        if (free.indexOf(i) > -1) freeAmt += c.price;
      });
      return { total: total, free: freeAmt, pay: total - freeAmt, freeCount: free.length };
    }

    /* Headline-order test: ATC rate + revenue per visitor, split by source in GA4/Triple Whale. */
    function track(name, extra) {
      var qs = new URLSearchParams(window.location.search);
      var payload = {
        event: name,
        lp_slug: root.getAttribute("data-lp-slug") || "",
        lp_hero_variant: root.getAttribute("data-lp-hero-variant") || "offer",
        utm_source: qs.get("utm_source") || "",
        utm_medium: qs.get("utm_medium") || ""
      };
      if (extra) Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    var rootId = root.id || "";
    var stickyApiFn = stickyApi();
    var sticky = stickyApiFn ? stickyApiFn.resolve(root, rootId) : root.querySelector("[data-lp-sticky]");
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCta = sticky ? sticky.querySelector("[data-lp-sticky-cta]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;
    var stickyThumbsWrap = sticky ? sticky.querySelector(".lp-sticky__thumbs") : null;
    var gridStatus = root.querySelector("[data-st11-grid-status]");
    var tooltip = sticky ? sticky.querySelector("[data-lp-sticky-tooltip]") : null;

    function anchorStickyTooltip() {
      if (!tooltip || !stickyCta) return;
      if (tooltip.parentElement !== stickyCta) {
        stickyCta.appendChild(tooltip);
      }
    }

    anchorStickyTooltip();

    var shop = root.querySelector("#shop") || root.querySelector("[data-st11-sticky-anchor]");
    var toast = root.querySelector("[data-st11-toast]");
    var toastText = root.querySelector("[data-st11-toast-text]");
    var toastTimer = null;
    var stickyMqCompact = window.matchMedia("(max-width: 767px)");

    function showToast(msg, opts) {
      if (!toast) return;
      opts = opts || {};
      var tone = opts.tone === "success" ? "success" : "info";
      if (toastText && msg) toastText.textContent = msg;
      toast.classList.toggle("is-success", tone === "success");
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
          toast.classList.remove("is-success");
        }, 240);
      }, 3000);
    }

    function selectionProgressCopy(count) {
      if (count === 0) return "0 of 2 selected";
      if (count === 1) return "1 more to unlock BOGO";
      if (count === 2) return "1 free. Add 2 more for a second free item";
      if (count === 3) return "1 free. Add 1 more for a second free item";
      return "2 free items unlocked";
    }

    var unitCounter = root.querySelector("[data-stbm-units]");
    function paintUnitCounter(count) {
      if (!unitCounter) return;
      var marks = unitCounter.children;
      for (var u = 0; u < marks.length; u++) {
        marks[u].classList.toggle("is-selected", u < count);
      }
    }

    function variantLabelFromCard(card) {
      if (!card) return "";
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || !sel.options.length) return "";
      var opt = sel.options[sel.selectedIndex];
      var variantLabel = (opt.getAttribute("data-variant-label") || opt.textContent || "")
        .replace(/\s*-\s*[^-]+$/, "")
        .replace(/\s*—\s*Sold out\s*$/, "")
        .trim();
      if (!variantLabel || variantLabel === "Default Title") return "";
      return variantLabel;
    }

    function selectionLabelFromCard(card) {
      if (!card) return "";
      var title = card.getAttribute("data-st11-title") || "";
      var variant = variantLabelFromCard(card);
      return variant ? title + " (" + variant + ")" : title;
    }

    function buildTooltipMessage(triggerCard) {
      if (isReady(selected.length)) {
        return "Selected: " + selected.map(function (c) { return selectionLabelFromCard(c.el); }).join(" + ");
      }
      if (triggerCard) {
        return "Selected: " + selectionLabelFromCard(triggerCard);
      }
      if (!selected.length) return "";
      return "Selected: " + selectionLabelFromCard(selected[0].el);
    }

    var tooltipTimer = null;

    function stickyStatusCopy(count) {
      if (!isReady(count)) return offerCopy;
      if (stickyMqCompact.matches) return "";
      var freeCount = Math.min(Math.floor(count / SET_SIZE), MAX_SELECT / SET_SIZE);
      return freeCount + (freeCount === 1 ? " item" : " items") + " free, applied at checkout";
    }

    function updateStickyStatusPresentation(count) {
      if (!stickyStatus) return;
      var ready = isReady(count);
      stickyStatus.classList.toggle("is-offer-pulse", !ready);
      stickyStatus.hidden = ready && stickyMqCompact.matches;
    }

    function updateGridStatus(count) {
      paintUnitCounter(count);
      if (!gridStatus) return;
      gridStatus.textContent = selectionProgressCopy(count);
      gridStatus.classList.toggle("is-unlocked", isReady(count));
    }

    function updateSticky() {
      var count = selected.length;
      var ready = isReady(count);
      if (sticky) sticky.classList.toggle("is-bogo-ready", ready);
      if (stickyCta) stickyCta.classList.toggle("is-bogo-ready", ready);
      if (stickyThumbsWrap) stickyThumbsWrap.classList.toggle("is-bogo-ready", ready);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        selected.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) {
        stickyEmpty.hidden = count > 0;
      }
      if (stickyBadge) {
        stickyBadge.textContent = String(count);
        stickyBadge.classList.toggle("is-active", count > 0);
      }

      var stickyIdle =
        (root && root.getAttribute("data-st11-sticky-idle")) || "Select products";
      var stickyOne =
        (root && root.getAttribute("data-st11-sticky-one")) || "Select 1 More";
      var stickyReady =
        (root && root.getAttribute("data-st11-sticky-ready")) || "CLAIM NOW";

      if (count === 0) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(0);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = stickyIdle;
      } else if (count === 1) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(1);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = stickyOne;
      } else {
        var math = pricing();
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(count);
        if (stickyPrice) {
          stickyPrice.hidden = false;
          if (stickyNow) stickyNow.textContent = money(math.pay);
          if (stickyWas) stickyWas.textContent = money(math.total);
        }
        if (stickyCtaText) stickyCtaText.textContent = stickyReady;
      }

      updateStickyStatusPresentation(count);
      updateGridStatus(count);

      function shopSectionVisible() {
        if (!shop) return false;
        var r = shop.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      var show = count >= 1 || scrollY() > scrollThreshold() || shopSectionVisible();
      if (sticky) {
        if (show) {
          revealSticky(sticky, root);
        } else {
          hideSticky(sticky, root);
        }
      }
    }

    function showTooltip(triggerCard) {
      if (!tooltip) return;
      anchorStickyTooltip();
      var msg = buildTooltipMessage(triggerCard);
      if (!msg) return;
      tooltip.textContent = msg;
      tooltip.hidden = false;
      if (tooltipTimer) clearTimeout(tooltipTimer);
      tooltipTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
      }, 3200);
    }

    function filterReviews(key) {
      var chips = root.querySelectorAll("[data-st11-rev-filter]");
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute(
          "aria-pressed",
          chips[i].getAttribute("data-st11-rev-filter") === key ? "true" : "false"
        );
      }
      var cards = root.querySelectorAll("[data-st11-review]");
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var match = key === "all" || cards[j].getAttribute("data-st11-skin") === key;
        cards[j].hidden = !match;
        if (match) shown++;
      }
      var countEl = root.querySelector("[data-st11-rev-count]");
      if (countEl) {
        countEl.textContent = "Showing " + shown + " review" + (shown === 1 ? "" : "s");
      }
    }

    function initCountdown() {
      var el = root.querySelector("[data-st11-countdown]");
      if (!el) return;
      var timeEl = el.querySelector("[data-st11-countdown-time]");
      if (!timeEl) return;
      var mins = parseInt(el.getAttribute("data-st11-countdown-mins"), 10) || 15;
      var storeKey = "st11_cd_" + (root.id || "lp");
      var timerId = null;
      var now = Date.now();
      var end = parseInt(sessionStorage.getItem(storeKey), 10);
      if (!end || isNaN(end) || end < now) {
        end = now + mins * 60 * 1000;
        try {
          sessionStorage.setItem(storeKey, String(end));
        } catch (e) {}
      }
      function pad(n) {
        return n < 10 ? "0" + n : "" + n;
      }
      function render() {
        var diff = end - Date.now();
        if (diff <= 0) {
          timeEl.textContent = "00:00";
          return;
        }
        var total = Math.floor(diff / 1000);
        var h = Math.floor(total / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        timeEl.textContent = (h > 0 ? pad(h) + ":" : "") + pad(m) + ":" + pad(s);
      }
      function schedule() {
        if (timerId) clearTimeout(timerId);
        render();
        if (end - Date.now() <= 0) return;
        timerId = setTimeout(schedule, 1000);
      }
      render();
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        schedule();
      }
    }

    function selectionIndicesForCard(card) {
      var indices = [];
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].el === card) indices.push(i);
      }
      return indices;
    }

    function cardSelectionCount(card) {
      return selectionIndicesForCard(card).length;
    }

    function removeLastSelectionForCard(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].el === card) {
          selected.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function addSelectionForCard(card) {
      if (card.getAttribute("data-st11-available") !== "true") return false;
      var cardCount = cardSelectionCount(card);
      if (selected.length >= MAX_SELECT) {
        showToast("You have 4 picks, the most per order (2 free)");
        return false;
      }
      selected.push(cardData(card));
      track("lp_bogo_pick", { items: selected.length });
      if (cardCount === 0) {
        card.setAttribute("data-st11-bogo-phase", "first");
      } else if (isReady(selected.length)) {
        card.setAttribute("data-st11-bogo-phase", "both");
      }
      return true;
    }

    function decrementCard(card) {
      if (!removeLastSelectionForCard(card)) return;
      var cardCount = cardSelectionCount(card);
      if (cardCount === 0) {
        card.removeAttribute("data-st11-bogo-phase");
      } else if (cardCount === 1 && card.getAttribute("data-st11-bogo-phase") === "both") {
        card.setAttribute("data-st11-bogo-phase", "one-after-both");
      }
      refreshGridCards();
      updateSticky();
    }

    function incrementCard(card) {
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function refreshGridCards() {
      var cards = root.querySelectorAll('[data-st11-card][data-st11-mode="select"]');
      var free = freeIndices();
      cards.forEach(function (card) {
        var slotIndices = selectionIndicesForCard(card);
        var cardCount = slotIndices.length;
        var isSel = cardCount > 0;
        var isFree = slotIndices.some(function (i) { return free.indexOf(i) > -1; });
        card.classList.toggle("is-selected", isSel);
        card.classList.toggle("is-free", isFree);
        card.setAttribute("aria-pressed", isSel ? "true" : "false");
        if (!isSel) card.removeAttribute("data-st11-bogo-phase");

        var btn = card.querySelector("[data-st11-toggle]");
        var txt = card.querySelector("[data-st11-btn-text]");
        var btnCheck = card.querySelector("[data-st11-btn-check]");
        var qtyWrap = card.querySelector("[data-st11-qty]");
        var qtyCount = card.querySelector("[data-st11-qty-count]");
        var qtyMinus = card.querySelector("[data-st11-qty-minus]");
        var qtyPlus = card.querySelector("[data-st11-qty-plus]");
        var slotsFull = selected.length >= MAX_SELECT;

        if (btn) {
          btn.hidden = isSel;
          btn.setAttribute("aria-pressed", isSel ? "true" : "false");
        }
        if (qtyWrap) {
          qtyWrap.hidden = !isSel;
          qtyWrap.setAttribute("aria-hidden", isSel ? "false" : "true");
        }
        if (qtyCount) qtyCount.textContent = String(cardCount);
        if (qtyMinus) qtyMinus.disabled = cardCount <= 0;
        if (qtyPlus) {
          qtyPlus.disabled = slotsFull;
        }
        if (btnCheck) btnCheck.hidden = !isSel;
        if (txt && btn && !isSel) {
          txt.textContent = btn.getAttribute("data-st11-base-label") || "Select";
        }

        var label = card.querySelector("[data-st11-selected-label]");
        if (label) {
          if (!isSel) {
            label.textContent = "";
          } else if (cardCount >= 2) {
            label.textContent = "\u00d7" + cardCount;
          } else {
            label.textContent = String(slotIndices[0] + 1);
          }
        }

        var freeNow = card.querySelector("[data-st11-free-now]");
        if (freeNow) freeNow.hidden = !isFree;
      });
    }

    function toggleSelect(card) {
      if (card.getAttribute("data-st11-available") !== "true") return;
      var cardCount = cardSelectionCount(card);
      if (cardCount > 0) return;
      if (selected.length >= MAX_SELECT) {
        showToast("You have 4 picks, the most per order (2 free)");
        return;
      }
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function selectionToCartItems(selections) {
      var qtyByVariant = {};
      selections.forEach(function (c) {
        var id = Number(c.variant);
        qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
      });
      return Object.keys(qtyByVariant).map(function (id) {
        return { id: Number(id), quantity: qtyByVariant[id] };
      });
    }

    var modalApi = null;

    function ensureModalApi() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) {
        return null;
      }
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selected.map(function (s) {
            return Number(s.variant);
          });
        },
        getParentProductIds: function () {
          return selected.map(function (s) {
            return Number(s.id);
          });
        },
        getParentCartItems: function () {
          return selectionToCartItems(selected);
        },
        canCheckout: function () {
          return isReady(selected.length);
        },
        onCheckoutBlocked: function () {
          showToast("Please select 2 products first");
        },
        onStickySuppress: function (on) {
          if (stickyApiFn) stickyApiFn.suppress(on);
        },
      });
      return modalApi;
    }

    function openModal() {
      var pr = pricing();
      track("lp_bogo_checkout_intent", { items: selected.length, value: pr.pay / 100, free_items: pr.freeCount, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD" });
      var api = ensureModalApi();
      if (api && typeof api.open === "function") {
        api.open();
        return;
      }
      if (window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.open === "function") {
        ensureModalApi();
        window.BBELP.modal.open();
        return;
      }
      showToast("Please tap CLAIM NOW again");
    }

    window.setTimeout(function () {
      ensureModalApi();
    }, 0);

    root.addEventListener("bbe:lp-upsells:checkoutBlocked", function (e) {
      var reason = e.detail && e.detail.reason;
      if (reason === "upsell_required_for_gift" || reason === "upsell_required") {
        showToast("Please select an add-on item first");
        return;
      }
      showToast("Please select 2 products first");
    });

    /* ---- events ---- */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var card = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      e.preventDefault();
      toggleSelect(card);
    });

    root.addEventListener("click", function (e) {
      var qtyMinus = e.target.closest("[data-st11-qty-minus]");
      if (qtyMinus && root.contains(qtyMinus)) {
        var minusCard = qtyMinus.closest("[data-st11-card]");
        if (minusCard && minusCard.getAttribute("data-st11-mode") === "select") {
          decrementCard(minusCard);
        }
        return;
      }

      var qtyPlus = e.target.closest("[data-st11-qty-plus]");
      if (qtyPlus && root.contains(qtyPlus)) {
        var plusCard = qtyPlus.closest("[data-st11-card]");
        if (plusCard && plusCard.getAttribute("data-st11-mode") === "select") {
          incrementCard(plusCard);
        }
        return;
      }

      var toggle = e.target.closest("[data-st11-toggle]");
      if (toggle && root.contains(toggle)) {
        var card = toggle.closest("[data-st11-card]");
        if (!card) return;
        if (card.getAttribute("data-st11-mode") === "select") {
          toggleSelect(card);
        }
        return;
      }

      /* Main grid: entire card toggles selection (select mode only) */
      var gridCard = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (gridCard && root.contains(gridCard)) {
        if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus], [data-lp-learn-open], .lp-collection-card__media, .lp-collection-card__title")) return;
        e.preventDefault();
        toggleSelect(gridCard);
        return;
      }

      if (e.target.closest("[data-st11-cta-scroll], [data-lp-listicle-scroll]")) {
        e.preventDefault();
        if (isReady(selected.length)) {
          openModal();
        } else {
          scrollToShopSection(shop);
        }
        return;
      }

      var revFilter = e.target.closest("[data-st11-rev-filter]");
      if (revFilter && root.contains(revFilter)) {
        filterReviews(revFilter.getAttribute("data-st11-rev-filter"));
        return;
      }

      var copyBtn = e.target.closest("[data-st11-copy-code], [data-lp-copy-code]");
      if (copyBtn) {
        var code = copyBtn.getAttribute("data-st11-code") || copyBtn.getAttribute("data-lp-code") || discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              showToast("Code " + code + " copied", { tone: "success" });
            },
            function () {
              showToast("Code: " + code);
            }
          );
        } else {
          showToast("Code: " + code);
        }
        return;
      }
    });

    function applyVariantSelect(sel) {
      var card = sel.closest("[data-st11-card]");
      if (!card || card.getAttribute("data-st11-mode") !== "select") return;
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(opt.getAttribute("data-compare"), 10) || 0;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", price);
      card.setAttribute("data-st11-compare", compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      if (nowEl) nowEl.textContent = money(price);
      var compareEl = card.querySelector("[data-st11-compare-display]");
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : "";
      var data = cardData(card);
      var touched = false;
      for (var si = 0; si < selected.length; si++) {
        if (selected[si].el === card) {
          selected[si] = data;
          touched = true;
        }
      }
      if (touched) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      applyVariantSelect(sel);
    });

    function onStickyCtaClick(e) {
      e.preventDefault();
      if (isReady(selected.length)) {
        openModal();
      } else {
        scrollToShopSection(shop);
      }
    }

    if (root.dataset.st11StickyDocClick !== "1") {
      root.dataset.st11StickyDocClick = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lp-sticky-cta]")) return;
        var bar = e.target.closest("[data-lp-sticky]");
        if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
        onStickyCtaClick(e);
      });
    }

    function onScrollUpdate() {
      updateSticky();
    }
    var scrollOpts = { passive: true };
    window.addEventListener("scroll", onScrollUpdate, scrollOpts);
    document.addEventListener("scroll", onScrollUpdate, scrollOpts);
    if (document.documentElement) {
      document.documentElement.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }
    var scrollRoot = document.getElementById("MainContent");
    if (scrollRoot) {
      scrollRoot.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }

    if (typeof stickyMqCompact.addEventListener === "function") {
      stickyMqCompact.addEventListener("change", updateSticky);
    } else if (typeof stickyMqCompact.addListener === "function") {
      stickyMqCompact.addListener(updateSticky);
    }

    // Year auto-fill (footer copyright is server-rendered; this is a safety net)
    root.querySelectorAll("[data-st11-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });

    /* Never open a card on a sold-out variant (e.g. Light / 7.5oz). */
    root.querySelectorAll('[data-st11-card] [data-st11-variant-select]').forEach(function (sel) {
      var card = sel.closest("[data-st11-card]");
      var want = card ? card.getAttribute("data-st11-variant") : "";
      var current = sel.options[sel.selectedIndex];
      var match = null;
      for (var oi = 0; oi < sel.options.length; oi++) {
        if (sel.options[oi].value === want && !sel.options[oi].disabled) match = sel.options[oi];
      }
      if (!match) {
        for (var oj = 0; oj < sel.options.length; oj++) {
          if (!sel.options[oj].disabled) { match = sel.options[oj]; break; }
        }
      }
      if (!match) return;
      if (current !== match || current.disabled) {
        sel.value = match.value;
        applyVariantSelect(sel);
      } else if (want !== match.value) {
        applyVariantSelect(sel);
      }
    });

    /* FAQ rich-text links to #shade-quiz open the in-page shade quiz. */
    root.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#shade-quiz"]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var lb = document.getElementById("lp-shade-quiz-lb");
      if (lb && typeof lb.__lpOpenShadeQuiz === "function") {
        e.preventDefault();
        lb.__lpOpenShadeQuiz();
      } else if (shop) {
        e.preventDefault();
        scrollToShopSection(shop);
      }
    });

    track("lp_view");
    initCountdown();
    updateSticky();
    requestAnimationFrame(updateSticky);
  }

  function boot() {
    document.querySelectorAll(".lp-col-bogo-stbm-01[data-st11-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector(".lp-col-bogo-stbm-01[data-st11-root]")
      : null;
    if (root) {
      root.dataset.st11Bound = "";
      init(root);
    }
  });
})();

/* ---- lp-col-bogo-stbm-01 page behaviors: ticker pause, end-date countdown,
   ingredient slider, time-boxed step icon motion, INCI opener ---- */
(function () {
  "use strict";

  if (window.__lpColBogoStbm01PageLoaded) return;
  window.__lpColBogoStbm01PageLoaded = true;

  var ROOT_SEL = ".lp-col-bogo-stbm-01[data-st11-root]";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function initCountdown(root) {
    var bar = root.querySelector("[data-stbm-countdown]");
    if (!bar) return;
    var end = Date.parse(bar.getAttribute("data-stbm-countdown"));
    if (isNaN(end)) return;
    var cells = {};
    bar.querySelectorAll("[data-stbm-cd]").forEach(function (el) {
      cells[el.getAttribute("data-stbm-cd")] = el;
    });
    var timer = null;

    function paint() {
      var left = end - Date.now();
      if (left <= 0) {
        bar.setAttribute("data-ended", "");
        if (timer) window.clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      if (cells.d) cells.d.textContent = pad(Math.floor(s / 86400));
      if (cells.h) cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (cells.m) cells.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (cells.s) cells.s.textContent = pad(s % 60);
    }

    paint();
    timer = window.setInterval(paint, reduceMotion.matches ? 60000 : 1000);
  }

  function initTicker(root) {
    var ticker = root.querySelector("[data-stbm-ticker]");
    if (!ticker) return;
    var btn = ticker.querySelector("[data-stbm-ticker-toggle]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var paused = ticker.classList.toggle("is-paused");
      btn.setAttribute("aria-pressed", paused ? "true" : "false");
    });
  }

  function initSlider(slider) {
    var rail = slider.querySelector("[data-stbm-rail]");
    var prev = slider.querySelector("[data-stbm-prev]");
    var next = slider.querySelector("[data-stbm-next]");
    var dotsWrap = slider.querySelector("[data-stbm-dots]");
    if (!rail) return;
    var items = Array.prototype.slice.call(rail.children);
    if (!items.length) return;

    var dots = [];
    if (dotsWrap) {
      items.forEach(function () {
        var dot = document.createElement("i");
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function step() {
      var first = items[0];
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 16;
      return first.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      var idx = Math.round(rail.scrollLeft / step());
      dots.forEach(function (d, i) {
        d.classList.toggle("is-on", i === Math.min(idx, dots.length - 1));
      });
      var ctrl = slider.querySelector(".stbm-ctrl");
      if (ctrl) ctrl.hidden = max <= 2;
    }

    if (prev) prev.addEventListener("click", function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion.matches ? "auto" : "smooth" });
    });
    if (next) next.addEventListener("click", function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion.matches ? "auto" : "smooth" });
    });
    rail.addEventListener("scroll", function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initSteps(root) {
    var steps = root.querySelectorAll("[data-stbm-step]");
    if (!steps.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle("is-playing", entry.isIntersecting && !reduceMotion.matches);
      });
    }, { threshold: 0.5 });
    steps.forEach(function (el) {
      io.observe(el);
    });
  }

  function initInci(root) {
    root.addEventListener("click", function (e) {
      var link = e.target.closest("[data-stbm-open-inci]");
      if (!link || !root.contains(link)) return;
      var target = root.querySelector(link.getAttribute("href"));
      if (target && target.tagName === "DETAILS") target.open = true;
    });
  }

  function init(root) {
    if (!root || root.dataset.stbmPageBound === "1") return;
    root.dataset.stbmPageBound = "1";
    initCountdown(root);
    initTicker(root);
    root.querySelectorAll("[data-stbm-slider]").forEach(initSlider);
    initSteps(root);
    initInci(root);
  }

  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector ? e.target.querySelector(ROOT_SEL) : null;
    if (root) {
      root.dataset.stbmPageBound = "";
      init(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-bogo-stbm-btu-02"] && !Shopify.designMode) return;
  try {
    
/* =============================================================================
   lp-col-bogo-stbm-btu-02 select-2 BOGO engine (copied from lp-col-bogo-st-11.js; root-scoped).
   Dependency-free, idempotent. Reuses the shared framework button-loading
   helper (window.BBELP.setLoading) from lp-scripts.js. Scoped per [data-st11-root].

   Behaviors: select-2 BOGO grid, sticky selection bar, 2-step upsell modal
   (add-on + free gift), checkout (POST /cart/add.js then discount redirect chain),
   tap-to-copy code, and toast. Core content + product links work without JS.
============================================================================= */
(function () {
  "use strict";

  if (window.__lpColBogoStbm01CoreLoaded) return;
  window.__lpColBogoStbm01CoreLoaded = true;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll(".lp-col-bogo-stbm-btu-02 .stbm-hero__video").forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    if (reduceMotion) {
      video.removeAttribute("autoplay");
      video.pause();
      return;
    }
    var playAttempt = video.play();
    if (playAttempt && playAttempt.catch) playAttempt.catch(function () {});
  });

  var SCROLL_THRESHOLD = 200;
  /* One BOGO set = 2 picks. Up to 2 sets (4 picks, 2 free) per order. */
  var SET_SIZE = 2;
  var MAX_SELECT = 4;

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function scrollY() {
    var api = stickyApi();
    if (api) return api.scrollY();
    return Math.max(window.scrollY || 0, window.pageYOffset || 0);
  }

  function scrollThreshold() {
    var api = stickyApi();
    if (api) return api.scrollThreshold(80, SCROLL_THRESHOLD);
    return window.matchMedia("(max-width: 767px)").matches ? 80 : SCROLL_THRESHOLD;
  }

  function scrollToShopSection(el) {
    var api = stickyApi();
    if (api) {
      api.scrollTo(el);
      return;
    }
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function revealSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.reveal(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.removeAttribute("hidden");
    sticky.hidden = false;
    sticky.classList.add("is-visible");
    if (root) root.classList.add("lp-has-sticky");
  }

  function hideSticky(sticky, root) {
    var api = stickyApi();
    if (api) {
      api.hide(sticky, root);
      return;
    }
    if (!sticky) return;
    sticky.classList.remove("is-visible");
    if (root) root.classList.remove("lp-has-sticky");
    sticky.hidden = true;
    sticky.setAttribute("hidden", "");
  }

  function setLoading(el, on) {
    if (window.BBELP && typeof window.BBELP.setLoading === "function") {
      window.BBELP.setLoading(el, on);
    } else if (el) {
      el.classList.toggle("is-loading", on !== false);
    }
  }

  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    return "$" + n.toFixed(2);
  }

  function cardData(card) {
    return {
      el: card,
      id: card.getAttribute("data-st11-id"),
      variant: card.getAttribute("data-st11-variant"),
      price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
      title: card.getAttribute("data-st11-title") || "",
      img: card.getAttribute("data-st11-img") || "",
      available: card.getAttribute("data-st11-available") === "true",
    };
  }

  function init(root) {
    if (root.dataset.st11Bound === "1") return;
    root.dataset.st11Bound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-st11-config") || "{}");
    } catch (e) {
      config = {};
    }
    var discountCode = config.discountCode || "BOGO";
    var offerCopy = config.offerCopy || "Buy 1, Get 1 Free";

    var selected = []; // grid picks in order (max MAX_SELECT)

    function isReady(count) {
      return count >= SET_SIZE;
    }

    /* Free picks: sort by price (high first); every second pick is free. */
    function freeIndices() {
      var order = selected
        .map(function (c, i) { return { i: i, price: c.price }; })
        .sort(function (a, b) { return b.price - a.price || a.i - b.i; });
      var free = [];
      for (var k = 1; k < order.length; k += 2) free.push(order[k].i);
      return free;
    }

    function pricing() {
      var total = 0;
      var freeAmt = 0;
      var free = freeIndices();
      selected.forEach(function (c, i) {
        total += c.price;
        if (free.indexOf(i) > -1) freeAmt += c.price;
      });
      return { total: total, free: freeAmt, pay: total - freeAmt, freeCount: free.length };
    }

    /* Headline-order test: ATC rate + revenue per visitor, split by source in GA4/Triple Whale. */
    function track(name, extra) {
      var qs = new URLSearchParams(window.location.search);
      var payload = {
        event: name,
        lp_slug: root.getAttribute("data-lp-slug") || "",
        lp_hero_variant: root.getAttribute("data-lp-hero-variant") || "offer",
        utm_source: qs.get("utm_source") || "",
        utm_medium: qs.get("utm_medium") || ""
      };
      if (extra) Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    var rootId = root.id || "";
    var stickyApiFn = stickyApi();
    var sticky = stickyApiFn ? stickyApiFn.resolve(root, rootId) : root.querySelector("[data-lp-sticky]");
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCta = sticky ? sticky.querySelector("[data-lp-sticky-cta]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;
    var stickyThumbsWrap = sticky ? sticky.querySelector(".lp-sticky__thumbs") : null;
    var gridStatus = root.querySelector("[data-st11-grid-status]");
    var tooltip = sticky ? sticky.querySelector("[data-lp-sticky-tooltip]") : null;

    function anchorStickyTooltip() {
      if (!tooltip || !stickyCta) return;
      if (tooltip.parentElement !== stickyCta) {
        stickyCta.appendChild(tooltip);
      }
    }

    anchorStickyTooltip();

    var shop = root.querySelector("#shop") || root.querySelector("[data-st11-sticky-anchor]");
    var toast = root.querySelector("[data-st11-toast]");
    var toastText = root.querySelector("[data-st11-toast-text]");
    var toastTimer = null;
    var stickyMqCompact = window.matchMedia("(max-width: 767px)");

    function showToast(msg, opts) {
      if (!toast) return;
      opts = opts || {};
      var tone = opts.tone === "success" ? "success" : "info";
      if (toastText && msg) toastText.textContent = msg;
      toast.classList.toggle("is-success", tone === "success");
      toast.hidden = false;
      void toast.offsetWidth;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
          toast.classList.remove("is-success");
        }, 240);
      }, 3000);
    }

    function selectionProgressCopy(count) {
      if (count === 0) return "0 of 2 selected";
      if (count === 1) return "1 more to unlock BOGO";
      if (count === 2) return "1 free. Add 2 more for a second free item";
      if (count === 3) return "1 free. Add 1 more for a second free item";
      return "2 free items unlocked";
    }

    var unitCounter = root.querySelector("[data-stbm-units]");
    function paintUnitCounter(count) {
      if (!unitCounter) return;
      var marks = unitCounter.children;
      for (var u = 0; u < marks.length; u++) {
        marks[u].classList.toggle("is-selected", u < count);
      }
    }

    function variantLabelFromCard(card) {
      if (!card) return "";
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || !sel.options.length) return "";
      var opt = sel.options[sel.selectedIndex];
      var variantLabel = (opt.getAttribute("data-variant-label") || opt.textContent || "")
        .replace(/\s*-\s*[^-]+$/, "")
        .replace(/\s*—\s*Sold out\s*$/, "")
        .trim();
      if (!variantLabel || variantLabel === "Default Title") return "";
      return variantLabel;
    }

    function selectionLabelFromCard(card) {
      if (!card) return "";
      var title = card.getAttribute("data-st11-title") || "";
      var variant = variantLabelFromCard(card);
      return variant ? title + " (" + variant + ")" : title;
    }

    function buildTooltipMessage(triggerCard) {
      if (isReady(selected.length)) {
        return "Selected: " + selected.map(function (c) { return selectionLabelFromCard(c.el); }).join(" + ");
      }
      if (triggerCard) {
        return "Selected: " + selectionLabelFromCard(triggerCard);
      }
      if (!selected.length) return "";
      return "Selected: " + selectionLabelFromCard(selected[0].el);
    }

    var tooltipTimer = null;

    function stickyStatusCopy(count) {
      if (!isReady(count)) return offerCopy;
      if (stickyMqCompact.matches) return "";
      var freeCount = Math.min(Math.floor(count / SET_SIZE), MAX_SELECT / SET_SIZE);
      return freeCount + (freeCount === 1 ? " item" : " items") + " free, applied at checkout";
    }

    function updateStickyStatusPresentation(count) {
      if (!stickyStatus) return;
      var ready = isReady(count);
      stickyStatus.classList.toggle("is-offer-pulse", !ready);
      stickyStatus.hidden = ready && stickyMqCompact.matches;
    }

    function updateGridStatus(count) {
      paintUnitCounter(count);
      if (!gridStatus) return;
      gridStatus.textContent = selectionProgressCopy(count);
      gridStatus.classList.toggle("is-unlocked", isReady(count));
    }

    function updateSticky() {
      var count = selected.length;
      var ready = isReady(count);
      if (sticky) sticky.classList.toggle("is-bogo-ready", ready);
      if (stickyCta) stickyCta.classList.toggle("is-bogo-ready", ready);
      if (stickyThumbsWrap) stickyThumbsWrap.classList.toggle("is-bogo-ready", ready);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        selected.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) {
        stickyEmpty.hidden = count > 0;
      }
      if (stickyBadge) {
        stickyBadge.textContent = String(count);
        stickyBadge.classList.toggle("is-active", count > 0);
      }

      var stickyIdle =
        (root && root.getAttribute("data-st11-sticky-idle")) || "Select products";
      var stickyOne =
        (root && root.getAttribute("data-st11-sticky-one")) || "Select 1 More";
      var stickyReady =
        (root && root.getAttribute("data-st11-sticky-ready")) || "CLAIM NOW";

      if (count === 0) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(0);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = stickyIdle;
      } else if (count === 1) {
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(1);
        if (stickyPrice) stickyPrice.hidden = true;
        if (stickyCtaText) stickyCtaText.textContent = stickyOne;
      } else {
        var math = pricing();
        if (stickyStatus) stickyStatus.textContent = stickyStatusCopy(count);
        if (stickyPrice) {
          stickyPrice.hidden = false;
          if (stickyNow) stickyNow.textContent = money(math.pay);
          if (stickyWas) stickyWas.textContent = money(math.total);
        }
        if (stickyCtaText) stickyCtaText.textContent = stickyReady;
      }

      updateStickyStatusPresentation(count);
      updateGridStatus(count);

      function shopSectionVisible() {
        if (!shop) return false;
        var r = shop.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      }

      var show = count >= 1 || scrollY() > scrollThreshold() || shopSectionVisible();
      if (sticky) {
        if (show) {
          revealSticky(sticky, root);
        } else {
          hideSticky(sticky, root);
        }
      }
    }

    function showTooltip(triggerCard) {
      if (!tooltip) return;
      anchorStickyTooltip();
      var msg = buildTooltipMessage(triggerCard);
      if (!msg) return;
      tooltip.textContent = msg;
      tooltip.hidden = false;
      if (tooltipTimer) clearTimeout(tooltipTimer);
      tooltipTimer = setTimeout(function () {
        if (tooltip) tooltip.hidden = true;
      }, 3200);
    }

    function filterReviews(key) {
      var chips = root.querySelectorAll("[data-st11-rev-filter]");
      for (var i = 0; i < chips.length; i++) {
        chips[i].setAttribute(
          "aria-pressed",
          chips[i].getAttribute("data-st11-rev-filter") === key ? "true" : "false"
        );
      }
      var cards = root.querySelectorAll("[data-st11-review]");
      var shown = 0;
      for (var j = 0; j < cards.length; j++) {
        var match = key === "all" || cards[j].getAttribute("data-st11-skin") === key;
        cards[j].hidden = !match;
        if (match) shown++;
      }
      var countEl = root.querySelector("[data-st11-rev-count]");
      if (countEl) {
        countEl.textContent = "Showing " + shown + " review" + (shown === 1 ? "" : "s");
      }
    }

    function initCountdown() {
      var el = root.querySelector("[data-st11-countdown]");
      if (!el) return;
      var timeEl = el.querySelector("[data-st11-countdown-time]");
      if (!timeEl) return;
      var mins = parseInt(el.getAttribute("data-st11-countdown-mins"), 10) || 15;
      var storeKey = "st11_cd_" + (root.id || "lp");
      var timerId = null;
      var now = Date.now();
      var end = parseInt(sessionStorage.getItem(storeKey), 10);
      if (!end || isNaN(end) || end < now) {
        end = now + mins * 60 * 1000;
        try {
          sessionStorage.setItem(storeKey, String(end));
        } catch (e) {}
      }
      function pad(n) {
        return n < 10 ? "0" + n : "" + n;
      }
      function render() {
        var diff = end - Date.now();
        if (diff <= 0) {
          timeEl.textContent = "00:00";
          return;
        }
        var total = Math.floor(diff / 1000);
        var h = Math.floor(total / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        timeEl.textContent = (h > 0 ? pad(h) + ":" : "") + pad(m) + ":" + pad(s);
      }
      function schedule() {
        if (timerId) clearTimeout(timerId);
        render();
        if (end - Date.now() <= 0) return;
        timerId = setTimeout(schedule, 1000);
      }
      render();
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        schedule();
      }
    }

    function selectionIndicesForCard(card) {
      var indices = [];
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].el === card) indices.push(i);
      }
      return indices;
    }

    function cardSelectionCount(card) {
      return selectionIndicesForCard(card).length;
    }

    function removeLastSelectionForCard(card) {
      for (var i = selected.length - 1; i >= 0; i--) {
        if (selected[i].el === card) {
          selected.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    function addSelectionForCard(card) {
      if (card.getAttribute("data-st11-available") !== "true") return false;
      var cardCount = cardSelectionCount(card);
      if (selected.length >= MAX_SELECT) {
        showToast("You have 4 picks, the most per order (2 free)");
        return false;
      }
      selected.push(cardData(card));
      track("lp_bogo_pick", { items: selected.length });
      if (cardCount === 0) {
        card.setAttribute("data-st11-bogo-phase", "first");
      } else if (isReady(selected.length)) {
        card.setAttribute("data-st11-bogo-phase", "both");
      }
      return true;
    }

    function decrementCard(card) {
      if (!removeLastSelectionForCard(card)) return;
      var cardCount = cardSelectionCount(card);
      if (cardCount === 0) {
        card.removeAttribute("data-st11-bogo-phase");
      } else if (cardCount === 1 && card.getAttribute("data-st11-bogo-phase") === "both") {
        card.setAttribute("data-st11-bogo-phase", "one-after-both");
      }
      refreshGridCards();
      updateSticky();
    }

    function incrementCard(card) {
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function refreshGridCards() {
      var cards = root.querySelectorAll('[data-st11-card][data-st11-mode="select"]');
      var free = freeIndices();
      cards.forEach(function (card) {
        var slotIndices = selectionIndicesForCard(card);
        var cardCount = slotIndices.length;
        var isSel = cardCount > 0;
        var isFree = slotIndices.some(function (i) { return free.indexOf(i) > -1; });
        card.classList.toggle("is-selected", isSel);
        card.classList.toggle("is-free", isFree);
        card.setAttribute("aria-pressed", isSel ? "true" : "false");
        if (!isSel) card.removeAttribute("data-st11-bogo-phase");

        var btn = card.querySelector("[data-st11-toggle]");
        var txt = card.querySelector("[data-st11-btn-text]");
        var btnCheck = card.querySelector("[data-st11-btn-check]");
        var qtyWrap = card.querySelector("[data-st11-qty]");
        var qtyCount = card.querySelector("[data-st11-qty-count]");
        var qtyMinus = card.querySelector("[data-st11-qty-minus]");
        var qtyPlus = card.querySelector("[data-st11-qty-plus]");
        var slotsFull = selected.length >= MAX_SELECT;

        if (btn) {
          btn.hidden = isSel;
          btn.setAttribute("aria-pressed", isSel ? "true" : "false");
        }
        if (qtyWrap) {
          qtyWrap.hidden = !isSel;
          qtyWrap.setAttribute("aria-hidden", isSel ? "false" : "true");
        }
        if (qtyCount) qtyCount.textContent = String(cardCount);
        if (qtyMinus) qtyMinus.disabled = cardCount <= 0;
        if (qtyPlus) {
          qtyPlus.disabled = slotsFull;
        }
        if (btnCheck) btnCheck.hidden = !isSel;
        if (txt && btn && !isSel) {
          txt.textContent = btn.getAttribute("data-st11-base-label") || "Select";
        }

        var label = card.querySelector("[data-st11-selected-label]");
        if (label) {
          if (!isSel) {
            label.textContent = "";
          } else if (cardCount >= 2) {
            label.textContent = "\u00d7" + cardCount;
          } else {
            label.textContent = String(slotIndices[0] + 1);
          }
        }

        var freeNow = card.querySelector("[data-st11-free-now]");
        if (freeNow) freeNow.hidden = !isFree;
      });
    }

    function toggleSelect(card) {
      if (card.getAttribute("data-st11-available") !== "true") return;
      var cardCount = cardSelectionCount(card);
      if (cardCount > 0) return;
      if (selected.length >= MAX_SELECT) {
        showToast("You have 4 picks, the most per order (2 free)");
        return;
      }
      if (addSelectionForCard(card)) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    function selectionToCartItems(selections) {
      var qtyByVariant = {};
      selections.forEach(function (c) {
        var id = Number(c.variant);
        qtyByVariant[id] = (qtyByVariant[id] || 0) + 1;
      });
      return Object.keys(qtyByVariant).map(function (id) {
        return { id: Number(id), quantity: qtyByVariant[id] };
      });
    }

    var modalApi = null;

    function ensureModalApi() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) {
        return null;
      }
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selected.map(function (s) {
            return Number(s.variant);
          });
        },
        getParentProductIds: function () {
          return selected.map(function (s) {
            return Number(s.id);
          });
        },
        getParentCartItems: function () {
          return selectionToCartItems(selected);
        },
        canCheckout: function () {
          return isReady(selected.length);
        },
        onCheckoutBlocked: function () {
          showToast("Please select 2 products first");
        },
        onStickySuppress: function (on) {
          if (stickyApiFn) stickyApiFn.suppress(on);
        },
      });
      return modalApi;
    }

    function openModal() {
      var pr = pricing();
      track("lp_bogo_checkout_intent", { items: selected.length, value: pr.pay / 100, free_items: pr.freeCount, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD" });
      var api = ensureModalApi();
      if (api && typeof api.open === "function") {
        api.open();
        return;
      }
      if (window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.open === "function") {
        ensureModalApi();
        window.BBELP.modal.open();
        return;
      }
      showToast("Please tap CLAIM NOW again");
    }

    window.setTimeout(function () {
      ensureModalApi();
    }, 0);

    root.addEventListener("bbe:lp-upsells:checkoutBlocked", function (e) {
      var reason = e.detail && e.detail.reason;
      if (reason === "upsell_required_for_gift" || reason === "upsell_required") {
        showToast("Please select an add-on item first");
        return;
      }
      showToast("Please select 2 products first");
    });

    /* ---- events ---- */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var card = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      e.preventDefault();
      toggleSelect(card);
    });

    root.addEventListener("click", function (e) {
      var qtyMinus = e.target.closest("[data-st11-qty-minus]");
      if (qtyMinus && root.contains(qtyMinus)) {
        var minusCard = qtyMinus.closest("[data-st11-card]");
        if (minusCard && minusCard.getAttribute("data-st11-mode") === "select") {
          decrementCard(minusCard);
        }
        return;
      }

      var qtyPlus = e.target.closest("[data-st11-qty-plus]");
      if (qtyPlus && root.contains(qtyPlus)) {
        var plusCard = qtyPlus.closest("[data-st11-card]");
        if (plusCard && plusCard.getAttribute("data-st11-mode") === "select") {
          incrementCard(plusCard);
        }
        return;
      }

      var toggle = e.target.closest("[data-st11-toggle]");
      if (toggle && root.contains(toggle)) {
        var card = toggle.closest("[data-st11-card]");
        if (!card) return;
        if (card.getAttribute("data-st11-mode") === "select") {
          toggleSelect(card);
        }
        return;
      }

      /* Main grid: entire card toggles selection (select mode only) */
      var gridCard = e.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (gridCard && root.contains(gridCard)) {
        if (e.target.closest("select, button, [data-st11-variant-select], [data-st11-toggle], [data-st11-qty-minus], [data-st11-qty-plus], [data-lp-learn-open], .lp-collection-card__media, .lp-collection-card__title")) return;
        e.preventDefault();
        toggleSelect(gridCard);
        return;
      }

      if (e.target.closest("[data-st11-cta-scroll], [data-lp-listicle-scroll]")) {
        e.preventDefault();
        if (isReady(selected.length)) {
          openModal();
        } else {
          scrollToShopSection(shop);
        }
        return;
      }

      var revFilter = e.target.closest("[data-st11-rev-filter]");
      if (revFilter && root.contains(revFilter)) {
        filterReviews(revFilter.getAttribute("data-st11-rev-filter"));
        return;
      }

      var copyBtn = e.target.closest("[data-st11-copy-code], [data-lp-copy-code]");
      if (copyBtn) {
        var code = copyBtn.getAttribute("data-st11-code") || copyBtn.getAttribute("data-lp-code") || discountCode;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(
            function () {
              showToast("Code " + code + " copied", { tone: "success" });
            },
            function () {
              showToast("Code: " + code);
            }
          );
        } else {
          showToast("Code: " + code);
        }
        return;
      }
    });

    function applyVariantSelect(sel) {
      var card = sel.closest("[data-st11-card]");
      if (!card || card.getAttribute("data-st11-mode") !== "select") return;
      var opt = sel.options[sel.selectedIndex];
      var price = parseInt(opt.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(opt.getAttribute("data-compare"), 10) || 0;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", price);
      card.setAttribute("data-st11-compare", compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      if (nowEl) nowEl.textContent = money(price);
      var compareEl = card.querySelector("[data-st11-compare-display]");
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : "";
      var data = cardData(card);
      var touched = false;
      for (var si = 0; si < selected.length; si++) {
        if (selected[si].el === card) {
          selected[si] = data;
          touched = true;
        }
      }
      if (touched) {
        refreshGridCards();
        updateSticky();
        showTooltip(card);
      }
    }

    root.addEventListener("change", function (e) {
      var sel = e.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      applyVariantSelect(sel);
    });

    function onStickyCtaClick(e) {
      e.preventDefault();
      if (isReady(selected.length)) {
        openModal();
      } else {
        scrollToShopSection(shop);
      }
    }

    if (root.dataset.st11StickyDocClick !== "1") {
      root.dataset.st11StickyDocClick = "1";
      document.addEventListener("click", function (e) {
        if (!e.target.closest("[data-lp-sticky-cta]")) return;
        var bar = e.target.closest("[data-lp-sticky]");
        if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
        onStickyCtaClick(e);
      });
    }

    function onScrollUpdate() {
      updateSticky();
    }
    var scrollOpts = { passive: true };
    window.addEventListener("scroll", onScrollUpdate, scrollOpts);
    document.addEventListener("scroll", onScrollUpdate, scrollOpts);
    if (document.documentElement) {
      document.documentElement.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }
    var scrollRoot = document.getElementById("MainContent");
    if (scrollRoot) {
      scrollRoot.addEventListener("scroll", onScrollUpdate, scrollOpts);
    }

    if (typeof stickyMqCompact.addEventListener === "function") {
      stickyMqCompact.addEventListener("change", updateSticky);
    } else if (typeof stickyMqCompact.addListener === "function") {
      stickyMqCompact.addListener(updateSticky);
    }

    // Year auto-fill (footer copyright is server-rendered; this is a safety net)
    root.querySelectorAll("[data-st11-year]").forEach(function (el) {
      el.textContent = String(new Date().getFullYear());
    });

    /* Never open a card on a sold-out variant (e.g. Light / 7.5oz). */
    root.querySelectorAll('[data-st11-card] [data-st11-variant-select]').forEach(function (sel) {
      var card = sel.closest("[data-st11-card]");
      var want = card ? card.getAttribute("data-st11-variant") : "";
      var current = sel.options[sel.selectedIndex];
      var match = null;
      for (var oi = 0; oi < sel.options.length; oi++) {
        if (sel.options[oi].value === want && !sel.options[oi].disabled) match = sel.options[oi];
      }
      if (!match) {
        for (var oj = 0; oj < sel.options.length; oj++) {
          if (!sel.options[oj].disabled) { match = sel.options[oj]; break; }
        }
      }
      if (!match) return;
      if (current !== match || current.disabled) {
        sel.value = match.value;
        applyVariantSelect(sel);
      } else if (want !== match.value) {
        applyVariantSelect(sel);
      }
    });

    /* FAQ rich-text links to #shade-quiz open the in-page shade quiz. */
    root.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#shade-quiz"]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var lb = document.getElementById("lp-shade-quiz-lb");
      if (lb && typeof lb.__lpOpenShadeQuiz === "function") {
        e.preventDefault();
        lb.__lpOpenShadeQuiz();
      } else if (shop) {
        e.preventDefault();
        scrollToShopSection(shop);
      }
    });

    track("lp_view");
    initCountdown();
    updateSticky();
    requestAnimationFrame(updateSticky);
  }

  function boot() {
    document.querySelectorAll(".lp-col-bogo-stbm-btu-02[data-st11-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Re-init in Shopify theme editor when the section is re-rendered.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector
      ? e.target.querySelector(".lp-col-bogo-stbm-btu-02[data-st11-root]")
      : null;
    if (root) {
      root.dataset.st11Bound = "";
      init(root);
    }
  });
})();

/* ---- lp-col-bogo-stbm-btu-02 page behaviors: ticker pause, end-date countdown,
   ingredient slider, time-boxed step icon motion, INCI opener ---- */
(function () {
  "use strict";

  if (window.__lpColBogoStbm01PageLoaded) return;
  window.__lpColBogoStbm01PageLoaded = true;

  var ROOT_SEL = ".lp-col-bogo-stbm-btu-02[data-st11-root]";
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function initCountdown(root) {
    var bar = root.querySelector("[data-stbm-countdown]");
    if (!bar) return;
    var end = Date.parse(bar.getAttribute("data-stbm-countdown"));
    if (isNaN(end)) return;
    var cells = {};
    bar.querySelectorAll("[data-stbm-cd]").forEach(function (el) {
      cells[el.getAttribute("data-stbm-cd")] = el;
    });
    var timer = null;

    var WINDOW_MS = 7 * 60 * 60 * 1000;

    function paint() {
      var left = end - Date.now();
      if (left <= 0) {
        bar.setAttribute("data-ended", "");
        if (timer) window.clearInterval(timer);
        return;
      }
      var shown = left;
      if (left > WINDOW_MS) {
        shown = left % WINDOW_MS;
        if (shown === 0) shown = WINDOW_MS;
      }
      var s = Math.floor(shown / 1000);
      if (cells.d) cells.d.textContent = pad(Math.floor(s / 86400));
      if (cells.h) cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (cells.m) cells.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (cells.s) cells.s.textContent = pad(s % 60);
    }

    paint();
    timer = window.setInterval(paint, reduceMotion.matches ? 60000 : 1000);
  }

  function initTicker(root) {
    var ticker = root.querySelector("[data-stbm-ticker]");
    if (!ticker) return;
    var btn = ticker.querySelector("[data-stbm-ticker-toggle]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var paused = ticker.classList.toggle("is-paused");
      btn.setAttribute("aria-pressed", paused ? "true" : "false");
    });
  }

  function initSlider(slider) {
    var rail = slider.querySelector("[data-stbm-rail]");
    var prev = slider.querySelector("[data-stbm-prev]");
    var next = slider.querySelector("[data-stbm-next]");
    var dotsWrap = slider.querySelector("[data-stbm-dots]");
    if (!rail) return;
    var items = Array.prototype.slice.call(rail.children);
    if (!items.length) return;

    var dots = [];
    if (dotsWrap) {
      items.forEach(function () {
        var dot = document.createElement("i");
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function step() {
      var first = items[0];
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 16;
      return first.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      var idx = Math.round(rail.scrollLeft / step());
      dots.forEach(function (d, i) {
        d.classList.toggle("is-on", i === Math.min(idx, dots.length - 1));
      });
      var ctrl = slider.querySelector(".stbm-ctrl");
      if (ctrl) ctrl.hidden = max <= 2;
    }

    if (prev) prev.addEventListener("click", function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion.matches ? "auto" : "smooth" });
    });
    if (next) next.addEventListener("click", function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion.matches ? "auto" : "smooth" });
    });
    rail.addEventListener("scroll", function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initSteps(root) {
    var steps = root.querySelectorAll("[data-stbm-step]");
    if (!steps.length || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle("is-playing", entry.isIntersecting && !reduceMotion.matches);
      });
    }, { threshold: 0.5 });
    steps.forEach(function (el) {
      io.observe(el);
    });
  }

  function initInci(root) {
    root.addEventListener("click", function (e) {
      var link = e.target.closest("[data-stbm-open-inci]");
      if (!link || !root.contains(link)) return;
      var target = root.querySelector(link.getAttribute("href"));
      if (target && target.tagName === "DETAILS") target.open = true;
    });
  }

  function vimeoPost(iframe, method, value) {
    if (!iframe || !iframe.contentWindow) return;
    var msg = { method: method };
    if (value != null) msg.value = value;
    try {
      iframe.contentWindow.postMessage(JSON.stringify(msg), "https://player.vimeo.com");
    } catch (e) {}
  }

  function initVimeo(root) {
    if (!root || root.dataset.stbmVimeoBound === "1") return;
    var nodes = root.querySelectorAll("[data-stbm-vimeo]");
    if (!nodes.length) return;
    root.dataset.stbmVimeoBound = "1";

    var reduce = false;
    try {
      reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (e) {}
    if (reduce) return;

    function srcFor(id) {
      return "https://player.vimeo.com/video/" + encodeURIComponent(id)
        + "?autoplay=1&muted=1&loop=1&autopause=0&playsinline=1&title=0&byline=0&portrait=0&controls=0&background=1&dnt=1";
    }

    function markPlaying(iframe) {
      var wrap = iframe.closest("[data-stbm-vimeo]");
      if (wrap) wrap.classList.add("is-playing");
    }

    function mount(el) {
      var existing = el.querySelector("iframe");
      if (existing) return existing;
      var id = el.getAttribute("data-stbm-vimeo");
      var media = el.querySelector(".lp-listicle__reason-media");
      if (!id || !media) return null;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("title", "");
      iframe.setAttribute("aria-hidden", "true");
      iframe.setAttribute("tabindex", "-1");
      iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture; encrypted-media");
      iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
      iframe.src = srcFor(id);
      iframe.addEventListener("load", function () {
        vimeoPost(iframe, "setVolume", 0);
        vimeoPost(iframe, "setMuted", true);
        vimeoPost(iframe, "setLoop", true);
        vimeoPost(iframe, "play");
        vimeoPost(iframe, "addEventListener", "play");
        vimeoPost(iframe, "addEventListener", "playing");
        vimeoPost(iframe, "addEventListener", "timeupdate");
      });
      media.appendChild(iframe);
      return iframe;
    }

    window.addEventListener("message", function (event) {
      if (!event.origin || event.origin.indexOf("vimeo.com") === -1) return;
      var data = event.data;
      if (typeof data === "string") {
        try { data = JSON.parse(data); } catch (err) { return; }
      }
      if (!data) return;
      var name = data.event || "";
      var seconds = data.data && typeof data.data.seconds === "number" ? data.data.seconds : 0;
      if (name !== "playing" && !(name === "timeupdate" && seconds > 0.04)) return;
      var frames = root.querySelectorAll("[data-stbm-vimeo] iframe");
      for (var i = 0; i < frames.length; i++) {
        if (frames[i].contentWindow === event.source) markPlaying(frames[i]);
      }
    });

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(mount);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target.closest("[data-stbm-vimeo]");
        if (!el) return;
        var iframe = el.querySelector("iframe");
        if (entry.isIntersecting) {
          iframe = iframe || mount(el);
          if (iframe) vimeoPost(iframe, "play");
        } else if (iframe) {
          vimeoPost(iframe, "pause");
        }
      });
    }, { threshold: 0.45, rootMargin: "0px" });

    nodes.forEach(function (el) {
      var media = el.querySelector(".lp-listicle__reason-media");
      io.observe(media || el);
    });
  }

  function init(root) {
    if (!root || root.dataset.stbmPageBound === "1") return;
    root.dataset.stbmPageBound = "1";
    initCountdown(root);
    initTicker(root);
    root.querySelectorAll("[data-stbm-slider]").forEach(initSlider);
    initSteps(root);
    initInci(root);
    initVimeo(root);
  }

  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector ? e.target.querySelector(ROOT_SEL) : null;
    if (root) {
      root.dataset.stbmPageBound = "";
      root.dataset.stbmVimeoBound = "";
      init(root);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-sale-e30-01"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_QTY = 6;

  function money(cents) {
    var n = Math.max(0, cents) / 100;
    return "$" + n.toFixed(2);
  }

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function init(root) {
    if (!root || root.dataset.e30Bound === "1") return;
    root.dataset.e30Bound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-e30-config") || "{}");
    } catch (err) {
      config = {};
    }

    var code = String(config.discountCode || "EARLY30");
    var percent = parseInt(config.percent, 10);
    if (!isFinite(percent) || percent < 0 || percent > 90) percent = 30;
    var idleLabel = config.idleLabel || "Add to bag";
    var readyLabel = config.readyLabel || "Add to bag";
    var rootId = root.id || "";
    var shop = root.querySelector("[data-e30-shop]");
    var toast = root.querySelector("[data-e30-toast]");
    var toastText = root.querySelector("[data-e30-toast-text]");
    var toastTimer = null;
    var codeSent = false;
    var modalApi = null;

    var api = null;
    var sticky = root.querySelector("[data-lp-sticky]");
    function paintStickySkin() {
      if (!sticky) return;
      sticky.classList.add("e30-sticky", "e30-sticky--empty");
      sticky.style.setProperty("--lp-sticky-muted", "#f3ebdd");
      sticky.style.setProperty("--lp-btn-bg", "#f6f1e8");
      sticky.style.setProperty("--lp-btn-fg", "#1c2128");
      sticky.style.setProperty("--lp-btn-hover-bg", "#e4c56b");
      sticky.style.setProperty("--lp-btn-hover-fg", "#1c2128");
    }
    paintStickySkin();
    var stickyStatus = sticky ? sticky.querySelector("[data-lp-sticky-status]") : null;
    if (stickyStatus) {
      stickyStatus.classList.remove("is-offer-pulse");
      stickyStatus.style.color = "#e4c56b";
    }
    var stickyThumbs = sticky ? sticky.querySelector("[data-lp-sticky-thumbs]") : null;
    var stickyEmpty = sticky ? sticky.querySelector("[data-lp-sticky-empty]") : null;
    var stickyBadge = sticky ? sticky.querySelector("[data-lp-sticky-badge]") : null;
    var stickyPrice = sticky ? sticky.querySelector("[data-lp-sticky-price]") : null;
    var stickyNow = sticky ? sticky.querySelector("[data-lp-sticky-price-now]") : null;
    var stickyWas = sticky ? sticky.querySelector("[data-lp-sticky-price-was]") : null;
    var stickyCtaText = sticky ? sticky.querySelector("[data-lp-sticky-cta-text]") : null;

    function showToast(msg) {
      if (!toast) return;
      if (toastText) toastText.textContent = msg;
      toast.hidden = false;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
        }, 200);
      }, 2800);
    }

    function applyCode() {
      if (!code || code === "x") return;
      var ok = function () {
        showToast("Code " + code + " applied");
      };
      var fallback = function () {
        showToast("Code " + code + " will apply at checkout");
      };
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === "function") {
        window.liquidAjaxCart.update({ discount: code }, { lastCallback: ok });
        return;
      }
      var url = config.cartUpdateUrl || "/cart/update.js";
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount: code }),
      })
        .then(function (res) {
          if (res && res.ok) ok();
          else fallback();
        })
        .catch(fallback);
    }

    function ensureCode() {
      if (codeSent) return;
      codeSent = true;
      applyCode();
    }

    function qtyOf(card) {
      return parseInt(card.getAttribute("data-e30-qty") || "0", 10) || 0;
    }

    function selectedCards() {
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-st11-card][data-st11-mode="select"]'))
        .filter(function (card) {
          return qtyOf(card) > 0 && card.getAttribute("data-st11-available") === "true";
        })
        .map(function (card) {
          return {
            el: card,
            id: Number(card.getAttribute("data-st11-id")),
            variant: Number(card.getAttribute("data-st11-variant")),
            price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
            img: card.getAttribute("data-st11-img") || "",
            qty: qtyOf(card),
          };
        });
    }

    function paintPrices(card) {
      var list = parseInt(card.getAttribute("data-st11-price"), 10) || 0;
      var compare = parseInt(card.getAttribute("data-st11-compare"), 10) || 0;
      var sale = Math.round(list * (100 - percent) / 100);
      var strike = compare > sale ? compare : 0;
      if (strike <= sale && list > sale) strike = list;
      var nowEl = card.querySelector("[data-st11-price-display]");
      var wasEl = card.querySelector("[data-st11-compare-display]");
      var priceRow = card.querySelector(".lp-collection-card__price");
      if (nowEl) nowEl.textContent = money(sale);
      if (strike > sale) {
        if (!wasEl && priceRow) {
          wasEl = document.createElement("s");
          wasEl.className = "lp-collection-card__price-was";
          wasEl.setAttribute("data-st11-compare-display", "");
          priceRow.appendChild(wasEl);
        }
        if (wasEl) {
          wasEl.hidden = false;
          wasEl.textContent = money(strike);
        }
      } else if (wasEl) {
        wasEl.hidden = true;
      }
    }

    function paintCard(card) {
      paintPrices(card);
      var qty = qtyOf(card);
      var on = qty > 0;
      card.classList.toggle("is-selected", on);
      var btn = card.querySelector("[data-st11-toggle]");
      var qtyWrap = card.querySelector("[data-st11-qty]");
      var count = card.querySelector("[data-st11-qty-count]");
      var minus = card.querySelector("[data-st11-qty-minus]");
      var plus = card.querySelector("[data-st11-qty-plus]");
      if (btn) {
        btn.hidden = on;
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      }
      if (qtyWrap) {
        qtyWrap.hidden = !on;
        qtyWrap.setAttribute("aria-hidden", on ? "false" : "true");
      }
      if (count) count.textContent = String(Math.max(qty, 1));
      if (minus) minus.disabled = !on;
      if (plus) plus.disabled = qty >= MAX_QTY;
    }

    function setQty(card, next, opts) {
      if (!card || card.getAttribute("data-st11-available") !== "true") return;
      var qty = Math.max(0, Math.min(MAX_QTY, next));
      var was = qtyOf(card);
      card.setAttribute("data-e30-qty", String(qty));
      paintCard(card);
      if (qty > 0 && was === 0) ensureCode();
      if (!opts || !opts.silent) updateSticky();
    }

    function updateSticky() {
      var picks = selectedCards();
      var units = 0;
      var total = 0;
      picks.forEach(function (c) {
        units += c.qty;
        total += c.price * c.qty;
      });
      var sale = Math.round(total * (100 - percent) / 100);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        picks.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) stickyEmpty.hidden = units > 0;
      if (stickyBadge) {
        stickyBadge.textContent = String(units);
        stickyBadge.classList.toggle("is-active", units > 0);
      }
      if (stickyStatus) {
        stickyStatus.textContent = units > 0 ? code + " applied" : code + " auto-applies";
      }
      if (stickyPrice) {
        stickyPrice.hidden = units < 1;
        if (stickyNow) stickyNow.textContent = money(sale);
        if (stickyWas) stickyWas.textContent = total > sale ? money(total) : "";
      }
      if (stickyCtaText) stickyCtaText.textContent = units > 0 ? readyLabel : idleLabel;
      if (sticky) sticky.classList.toggle("e30-sticky--empty", units < 1);

      if (sticky && api) {
        var threshold = api.scrollThreshold(160, 240);
        if (units > 0 || api.scrollY() > threshold) api.reveal(sticky, root);
        else api.hide(sticky, root);
      }
    }

    function filterReviews(key) {
      var reviewRoot = root.querySelector("[data-e30-reviews]");
      if (!reviewRoot) return;
      var shown = 0;
      var visibleCards = [];
      reviewRoot.querySelectorAll(".lp-featured-reviews__card").forEach(function (card) {
        var label = "";
        var product = card.querySelector(".lp-featured-reviews__product");
        if (product) label = product.textContent.toLowerCase();
        var match = key === "all" || label.indexOf(key) !== -1;
        card.hidden = !match;
        card.classList.remove("e30-review--solo");
        if (match) {
          shown += 1;
          visibleCards.push(card);
        }
      });
      if (visibleCards.length === 1) visibleCards[0].classList.add("e30-review--solo");
      var live = reviewRoot.querySelector("[data-e30-rev-count]");
      if (live) live.textContent = shown + (shown === 1 ? " review" : " reviews");
    }

    function placeReviewFilters() {
      var reviewRoot = root.querySelector("[data-e30-reviews]");
      if (!reviewRoot) return;
      var filters = reviewRoot.querySelector("[data-e30-review-filters]");
      var head = reviewRoot.querySelector(".lp-featured-reviews__head");
      if (filters && head) head.insertAdjacentElement("afterend", filters);
    }

    function scrollToShop() {
      if (!shop) return;
      if (api) api.scrollTo(shop);
      else shop.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function ensureModal() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) return null;
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selectedCards().map(function (c) { return c.variant; });
        },
        getParentProductIds: function () {
          return selectedCards().map(function (c) { return c.id; });
        },
        getParentCartItems: function () {
          return selectedCards().map(function (c) {
            return { id: c.variant, quantity: c.qty };
          });
        },
        canCheckout: function () {
          return selectedCards().length > 0;
        },
        onCheckoutBlocked: function () {
          showToast("Choose a product first");
          scrollToShop();
        },
        onStickySuppress: function (on) {
          if (api) api.suppress(on);
        },
      });
      return modalApi;
    }

    function openCheckout() {
      ensureCode();
      var modal = ensureModal();
      if (modal && typeof modal.open === "function") {
        modal.open();
        return;
      }
      showToast("Tap Add to bag once more");
    }

    function onStickyClick(event) {
      var bar = event.target.closest("[data-lp-sticky]");
      if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
      if (!event.target.closest("[data-lp-sticky-cta]")) return;
      event.preventDefault();
      if (selectedCards().length > 0) openCheckout();
      else scrollToShop();
    }

    root.addEventListener("click", function (event) {
      var chip = event.target.closest("[data-e30-rev-filter]");
      if (chip && root.contains(chip)) {
        var key = chip.getAttribute("data-e30-rev-filter") || "all";
        root.querySelectorAll("[data-e30-rev-filter]").forEach(function (el) {
          el.setAttribute("aria-pressed", el === chip ? "true" : "false");
        });
        filterReviews(key);
        return;
      }

      if (event.target.closest("[data-e30-scroll]")) {
        event.preventDefault();
        scrollToShop();
        return;
      }

      var copyBtn = event.target.closest("[data-e30-copy]");
      if (copyBtn && root.contains(copyBtn)) {
        ensureCode();
        var copyCode = copyBtn.getAttribute("data-e30-code") || code;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(copyCode).catch(function () {});
        }
        return;
      }

      var minus = event.target.closest("[data-st11-qty-minus]");
      if (minus && root.contains(minus)) {
        var minusCard = minus.closest("[data-st11-card]");
        if (minusCard) setQty(minusCard, qtyOf(minusCard) - 1);
        return;
      }

      var plus = event.target.closest("[data-st11-qty-plus]");
      if (plus && root.contains(plus)) {
        var plusCard = plus.closest("[data-st11-card]");
        if (plusCard) setQty(plusCard, Math.max(qtyOf(plusCard), 0) + 1);
        return;
      }

      var card = event.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (event.target.closest("select, [data-st11-qty-minus], [data-st11-qty-plus]")) return;
      if (qtyOf(card) > 0 && !event.target.closest("[data-st11-toggle]")) return;
      if (qtyOf(card) > 0) return;
      event.preventDefault();
      setQty(card, 1);
    });

    root.addEventListener("change", function (event) {
      var sel = event.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      var card = sel.closest("[data-st11-card]");
      if (!card) return;
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", opt.getAttribute("data-price") || "0");
      card.setAttribute("data-st11-compare", opt.getAttribute("data-compare") || "0");
      paintPrices(card);
      if (qtyOf(card) > 0) updateSticky();
    });

    if (root.dataset.e30StickyDoc !== "1") {
      root.dataset.e30StickyDoc = "1";
      document.addEventListener("click", onStickyClick);
    }

    var onScroll = function () { updateSticky(); };
    window.addEventListener("scroll", onScroll, { passive: true });

    var clock = root.querySelector("[data-e30-countdown]");
    if (clock) {
      var span = 11 * 60 * 60 * 1000;
      var storeKey = "bbe-e30-offer";
      var timeEl = clock.querySelector("[data-e30-countdown-time]");
      var liveEl = clock.querySelector("[data-e30-countdown-live]");
      var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var readEnd = function () {
        var stored = 0;
        try { stored = parseInt(window.sessionStorage.getItem(storeKey), 10) || 0; } catch (e) {}
        if (!stored || stored <= Date.now()) {
          stored = Date.now() + span;
          try { window.sessionStorage.setItem(storeKey, String(stored)); } catch (e) {}
        }
        return stored;
      };
      var end = readEnd();
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) {
          end = Date.now() + span;
          try { window.sessionStorage.setItem(storeKey, String(end)); } catch (e) {}
          left = span;
        }
        var totalSec = Math.floor(left / 1000);
        var hours = Math.floor(totalSec / 3600);
        var mins = Math.floor((totalSec % 3600) / 60);
        var secs = totalSec % 60;
        var face = pad(hours) + ":" + pad(mins) + ":" + pad(secs);
        if (timeEl) timeEl.textContent = face;
        if (liveEl && (secs === 0 || reduce)) liveEl.textContent = face;
      };
      tick();
      if (!reduce) window.setInterval(tick, 1000);
    }

    function attachSticky() {
      api = stickyApi();
      if (!api) return false;
      sticky = api.resolve(root, rootId) || sticky;
      paintStickySkin();
      updateSticky();
      return true;
    }

    root.querySelectorAll("[data-st11-card]").forEach(paintCard);
    window.setTimeout(ensureModal, 0);
    placeReviewFilters();
    filterReviews("all");
    if (!attachSticky()) {
      var stickyTries = 0;
      var stickyWait = window.setInterval(function () {
        stickyTries += 1;
        if (attachSticky() || stickyTries > 40) window.clearInterval(stickyWait);
      }, 50);
    }
  }

  function boot() {
    document.querySelectorAll("[data-e30-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var next = event.target && event.target.querySelector ? event.target.querySelector("[data-e30-root]") : null;
    if (!next) return;
    delete next.dataset.e30Bound;
    init(next);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-sale-e30-02"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_QTY = 6;

  function money(cents) {
    return "$" + (Math.max(0, cents) / 100).toFixed(2);
  }

  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function init(root) {
    if (!root || root.dataset.lphBound === "1") return;
    root.dataset.lphBound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-lph-config") || "{}");
    } catch (err) {
      config = {};
    }

    var code = String(config.discountCode || "EARLY30");
    var percent = parseInt(config.percent, 10);
    if (!isFinite(percent) || percent < 0 || percent > 90) percent = 30;
    var idleLabel = config.idleLabel || "Shop now";
    var readyLabel = config.readyLabel || "Add to bag";
    var rootId = root.id || "";
    var shop = root.querySelector("[data-lph-shop]");
    var toast = root.querySelector("[data-lph-toast]");
    var toastText = root.querySelector("[data-lph-toast-text]");
    var toastTimer = null;
    var codeSent = false;
    var modalApi = null;
    var api = null;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var sticky = root.querySelector("[data-lp-sticky]");
    var stickyStatus, stickyThumbs, stickyEmpty, stickyBadge, stickyPrice, stickyNow, stickyWas, stickyCtaText;
    function bindSticky() {
      if (!sticky) return;
      sticky.classList.add("lph-sticky");
      stickyStatus = sticky.querySelector("[data-lp-sticky-status]");
      stickyThumbs = sticky.querySelector("[data-lp-sticky-thumbs]");
      stickyEmpty = sticky.querySelector("[data-lp-sticky-empty]");
      stickyBadge = sticky.querySelector("[data-lp-sticky-badge]");
      stickyPrice = sticky.querySelector("[data-lp-sticky-price]");
      stickyNow = sticky.querySelector("[data-lp-sticky-price-now]");
      stickyWas = sticky.querySelector("[data-lp-sticky-price-was]");
      stickyCtaText = sticky.querySelector("[data-lp-sticky-cta-text]");
      if (stickyStatus) stickyStatus.classList.remove("is-offer-pulse");
    }
    bindSticky();

    function showToast(msg) {
      if (!toast) return;
      if (toastText) toastText.textContent = msg;
      toast.hidden = false;
      window.requestAnimationFrame(function () {
        toast.classList.add("is-visible");
      });
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          toast.hidden = true;
        }, 200);
      }, 2800);
    }

    function applyCode() {
      var ok = function () {
        showToast("Code " + code + " applied");
      };
      var fallback = function () {
        showToast("Code " + code + " will apply at checkout");
      };
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === "function") {
        window.liquidAjaxCart.update({ discount: code }, { lastCallback: ok });
        return;
      }
      fetch(config.cartUpdateUrl || "/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount: code }),
      })
        .then(function (res) {
          if (res && res.ok) ok();
          else fallback();
        })
        .catch(fallback);
    }

    function ensureCode() {
      if (codeSent) return;
      codeSent = true;
      applyCode();
    }

    function qtyOf(card) {
      return parseInt(card.getAttribute("data-lph-qty") || "0", 10) || 0;
    }

    function selectedCards() {
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-st11-card][data-st11-mode="select"]'))
        .filter(function (card) {
          return qtyOf(card) > 0 && card.getAttribute("data-st11-available") === "true";
        })
        .map(function (card) {
          var list = parseInt(card.getAttribute("data-st11-price"), 10) || 0;
          var compare = parseInt(card.getAttribute("data-st11-compare"), 10) || 0;
          var offer = offerFor(list, compare);
          return {
            id: Number(card.getAttribute("data-st11-id")),
            variant: Number(card.getAttribute("data-st11-variant")),
            price: list,
            sale: offer.sale,
            anchor: offer.anchor,
            img: card.getAttribute("data-st11-img") || "",
            title: card.getAttribute("data-st11-title") || "",
            qty: qtyOf(card),
          };
        });
    }

    function offerFor(list, compare) {
      var sale = Math.round((list * (100 - percent)) / 100);
      var anchor = compare > list ? compare : list;
      if (anchor < sale) anchor = sale;
      return { sale: sale, anchor: anchor, saved: Math.max(0, anchor - sale) };
    }

    function paintPrices(card) {
      var list = parseInt(card.getAttribute("data-st11-price"), 10) || 0;
      var compare = parseInt(card.getAttribute("data-st11-compare"), 10) || 0;
      var offer = offerFor(list, compare);
      var nowEl = card.querySelector("[data-st11-price-display]");
      var wasEl = card.querySelector("[data-st11-compare-display]");
      var priceRow = card.querySelector(".lp-collection-card__price");
      if (nowEl) nowEl.textContent = money(offer.sale);
      if (offer.anchor > offer.sale) {
        if (!wasEl && priceRow) {
          wasEl = document.createElement("s");
          wasEl.className = "lp-collection-card__price-was";
          wasEl.setAttribute("data-st11-compare-display", "");
          priceRow.appendChild(wasEl);
        }
        if (wasEl) {
          wasEl.hidden = false;
          wasEl.innerHTML = '<span class="lp-sr-only">Was </span>' + money(offer.anchor);
        }
      } else if (wasEl) {
        wasEl.hidden = true;
      }
      var saveEl = card.querySelector("[data-lph-save]");
      if (offer.saved > 0) {
        if (!saveEl && priceRow) {
          saveEl = document.createElement("p");
          saveEl.className = "lph-save";
          saveEl.setAttribute("data-lph-save", "");
          priceRow.insertAdjacentElement("afterend", saveEl);
        }
        if (saveEl) {
          saveEl.hidden = false;
          saveEl.textContent = "Save " + money(offer.saved) + " with " + code;
        }
      } else if (saveEl) {
        saveEl.hidden = true;
      }
    }

    function reviewCount(card) {
      var el = card.querySelector(".lp-collection-card__reviews-ct");
      if (!el) return 0;
      var n = parseInt(String(el.textContent).replace(/[^\d]/g, ""), 10);
      return isFinite(n) ? n : 0;
    }

    function normalizeBadge(card) {
      var badge = card.querySelector(".lp-collection-card__badge");
      if (!badge) return;
      var label = badge.textContent.replace(/\s+/g, " ").trim();
      if (label !== "Best Seller" && label !== "Top Rated") {
        label = reviewCount(card) > 0 ? "Top Rated" : "";
      }
      if (!label) {
        badge.textContent = "";
        badge.classList.add("is-lph-hidden");
      } else {
        badge.textContent = label;
        badge.classList.remove("is-lph-hidden");
      }
      badge.classList.add("is-lph-ready");
    }

    function paintCard(card) {
      paintPrices(card);
      normalizeBadge(card);
      var qty = qtyOf(card);
      var on = qty > 0;
      card.classList.toggle("is-selected", on);
      if (card.hasAttribute("aria-pressed")) card.setAttribute("aria-pressed", on ? "true" : "false");
      var btn = card.querySelector("[data-st11-toggle]");
      var qtyWrap = card.querySelector("[data-st11-qty]");
      var count = card.querySelector("[data-st11-qty-count]");
      var minus = card.querySelector("[data-st11-qty-minus]");
      var plus = card.querySelector("[data-st11-qty-plus]");
      if (btn) {
        btn.hidden = on;
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      }
      if (qtyWrap) {
        qtyWrap.hidden = !on;
        qtyWrap.setAttribute("aria-hidden", on ? "false" : "true");
      }
      if (count) count.textContent = String(Math.max(qty, 1));
      if (minus) minus.disabled = !on;
      if (plus) plus.disabled = qty >= MAX_QTY;
    }

    function setQty(card, next) {
      if (!card || card.getAttribute("data-st11-available") !== "true") return;
      var qty = Math.max(0, Math.min(MAX_QTY, next));
      var was = qtyOf(card);
      var toggleHadFocus = card.contains(document.activeElement);
      card.setAttribute("data-lph-qty", String(qty));
      paintCard(card);
      if (qty > 0 && was === 0) {
        ensureCode();
        var plusBtn = card.querySelector("[data-st11-qty-plus]");
        if (toggleHadFocus && plusBtn) plusBtn.focus({ preventScroll: true });
      }
      if (qty === 0 && was > 0) {
        var toggle = card.querySelector("[data-st11-toggle]");
        if (toggle) toggle.focus();
      }
      updateSticky();
    }

    function updateSticky() {
      var picks = selectedCards();
      var units = 0;
      var sale = 0;
      var anchor = 0;
      picks.forEach(function (c) {
        units += c.qty;
        sale += c.sale * c.qty;
        anchor += c.anchor * c.qty;
      });
      var saved = Math.max(0, anchor - sale);
      if (stickyThumbs) {
        stickyThumbs.innerHTML = "";
        picks.forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = c.title || "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) stickyEmpty.hidden = units > 0;
      if (stickyBadge) {
        stickyBadge.textContent = String(units);
        stickyBadge.classList.toggle("is-active", units > 0);
      }
      var statusText = units > 0 && saved > 0
        ? "Save " + money(saved) + " with " + code
        : units > 0
          ? code + " applied"
          : "Code " + code + " auto-applies";
      if (stickyStatus) stickyStatus.textContent = statusText;
      var bagLive = root.querySelector("[data-lph-bag-live]");
      var bagText = "";
      if (units > 0) {
        bagText = units + (units === 1 ? " item in your bag. " : " items in your bag. ");
        bagText += saved > 0 ? "Save " + money(saved) + " with " + code + "." : code + " applied.";
      }
      if (bagLive && bagLive.textContent !== bagText) bagLive.textContent = bagText;
      if (stickyPrice) {
        stickyPrice.hidden = units < 1;
        if (stickyNow) stickyNow.textContent = money(sale);
        if (stickyWas) stickyWas.textContent = anchor > sale ? money(anchor) : "";
      }
      if (stickyCtaText) stickyCtaText.textContent = units > 0 ? readyLabel : idleLabel;
      if (sticky) sticky.classList.toggle("lph-sticky--empty", units < 1);

      if (sticky && api) {
        var threshold = api.scrollThreshold(160, 240);
        if (units > 0 || api.scrollY() > threshold) api.reveal(sticky, root);
        else api.hide(sticky, root);
      }
    }

    var reviewRoot = root.querySelector("[data-lph-reviews]");
    var reviewRail = reviewRoot ? reviewRoot.querySelector(".lp-featured-reviews__grid") : null;

    function syncRail() {
      if (!reviewRail) return;
      if (reviewRail.scrollWidth > reviewRail.clientWidth + 2) {
        reviewRail.setAttribute("tabindex", "0");
        reviewRail.setAttribute("aria-label", "Customer reviews. Scroll sideways for more.");
      } else {
        reviewRail.removeAttribute("tabindex");
        reviewRail.removeAttribute("aria-label");
      }
    }

    function filterReviews(key) {
      if (!reviewRoot) return;
      var shown = 0;
      reviewRoot.querySelectorAll(".lp-featured-reviews__card").forEach(function (card) {
        var product = card.querySelector(".lp-featured-reviews__product");
        var label = product ? product.textContent.toLowerCase() : "";
        var match = key === "all" || label.indexOf(key) !== -1;
        card.hidden = !match;
        if (match) shown += 1;
      });
      var live = reviewRoot.querySelector("[data-lph-rev-count]");
      if (live) live.textContent = shown + (shown === 1 ? " review shown" : " reviews shown");
      if (reviewRail) reviewRail.scrollLeft = 0;
      syncRail();
    }

    function placeReviewFilters() {
      if (!reviewRoot) return;
      var filters = reviewRoot.querySelector("[data-lph-review-filters]");
      var head = reviewRoot.querySelector(".lp-featured-reviews__head");
      if (!filters || !head) return;
      head.insertAdjacentElement("afterend", filters);
      filters.hidden = false;
    }

    function scrollToShop() {
      if (!shop) return;
      if (api && typeof api.scrollTo === "function") api.scrollTo(shop);
      else shop.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
      try {
        shop.focus({ preventScroll: true });
      } catch (err) {}
    }

    function ensureModal() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) return null;
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () {
          return selectedCards().map(function (c) { return c.variant; });
        },
        getParentProductIds: function () {
          return selectedCards().map(function (c) { return c.id; });
        },
        getParentCartItems: function () {
          return selectedCards().map(function (c) {
            return { id: c.variant, quantity: c.qty };
          });
        },
        canCheckout: function () {
          return selectedCards().length > 0;
        },
        onCheckoutBlocked: function () {
          showToast("Choose a product first");
          scrollToShop();
        },
        onStickySuppress: function (on) {
          if (api) api.suppress(on);
        },
      });
      return modalApi;
    }

    function openCheckout() {
      ensureCode();
      var modal = ensureModal();
      if (modal && typeof modal.open === "function") {
        modal.open();
        return;
      }
      showToast("One moment, then tap again");
    }

    function onStickyClick(event) {
      var bar = event.target.closest("[data-lp-sticky]");
      if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
      if (!event.target.closest("[data-lp-sticky-cta]")) return;
      event.preventDefault();
      if (selectedCards().length > 0) openCheckout();
      else scrollToShop();
    }

    root.addEventListener("click", function (event) {
      var chip = event.target.closest("[data-lph-rev-filter]");
      if (chip && root.contains(chip)) {
        var key = chip.getAttribute("data-lph-rev-filter") || "all";
        root.querySelectorAll("[data-lph-rev-filter]").forEach(function (el) {
          el.setAttribute("aria-pressed", el === chip ? "true" : "false");
        });
        filterReviews(key);
        return;
      }

      if (event.target.closest("[data-lph-scroll]")) {
        event.preventDefault();
        scrollToShop();
        return;
      }

      var toggleTicker = event.target.closest("[data-lph-ticker-toggle]");
      if (toggleTicker && root.contains(toggleTicker)) {
        var ticker = toggleTicker.closest("[data-lph-ticker]");
        var paused = !ticker.classList.contains("is-paused");
        ticker.classList.toggle("is-paused", paused);
        toggleTicker.setAttribute("aria-pressed", paused ? "true" : "false");
        return;
      }

      var minus = event.target.closest("[data-st11-qty-minus]");
      if (minus && root.contains(minus)) {
        var minusCard = minus.closest("[data-st11-card]");
        if (minusCard) setQty(minusCard, qtyOf(minusCard) - 1);
        return;
      }

      var plus = event.target.closest("[data-st11-qty-plus]");
      if (plus && root.contains(plus)) {
        var plusCard = plus.closest("[data-st11-card]");
        if (plusCard) setQty(plusCard, qtyOf(plusCard) + 1);
        return;
      }

      var card = event.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      var learnOpener = event.target.closest("[data-lp-learn-open], .lp-collection-card__media, .lp-collection-card__title");
      if (learnOpener && root.contains(learnOpener)) return;
      if (event.target.closest("select, [data-st11-qty]")) return;
      if (qtyOf(card) > 0) return;
      event.preventDefault();
      setQty(card, 1);
    });

    root.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      var card = event.target;
      if (!card.matches || !card.matches('[data-st11-card][data-st11-mode="select"]')) return;
      event.preventDefault();
      if (qtyOf(card) === 0) setQty(card, 1);
    });

    root.addEventListener("change", function (event) {
      var sel = event.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      var card = sel.closest("[data-st11-card]");
      var opt = sel.options[sel.selectedIndex];
      if (!card || !opt) return;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", opt.getAttribute("data-price") || "0");
      card.setAttribute("data-st11-compare", opt.getAttribute("data-compare") || "0");
      paintPrices(card);
      if (qtyOf(card) > 0) updateSticky();
    });

    if (root.dataset.lphStickyDoc !== "1") {
      root.dataset.lphStickyDoc = "1";
      document.addEventListener("click", onStickyClick);
    }

    window.addEventListener("scroll", updateSticky, { passive: true });

    var resizeTimer = null;
    window.addEventListener("resize", function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncRail, 150);
    });

    var clock = root.querySelector("[data-lph-countdown]");
    var end = Date.parse(config.countdownEnd || "");
    if (clock && isFinite(end)) {
      var boxes = [
        clock.querySelector("[data-lph-cd-a]"),
        clock.querySelector("[data-lph-cd-b]"),
        clock.querySelector("[data-lph-cd-c]"),
      ];
      var timer = null;
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) {
          clock.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        var totalSec = Math.floor(left / 1000);
        var days = Math.floor(totalSec / 86400);
        var hours = Math.floor((totalSec % 86400) / 3600);
        var mins = Math.floor((totalSec % 3600) / 60);
        var parts = days > 0
          ? [days + "d", pad(hours) + "h", pad(mins) + "m"]
          : [pad(hours) + "h", pad(mins) + "m", pad(totalSec % 60) + "s"];
        boxes.forEach(function (el, i) {
          if (el) el.textContent = parts[i];
        });
      };
      tick();
      timer = setInterval(tick, reduceMotion ? 60000 : 1000);
    } else if (clock) {
      clock.hidden = true;
    }

    function attachSticky() {
      api = stickyApi();
      if (!api) return false;
      sticky = api.resolve(root, rootId) || sticky;
      bindSticky();
      updateSticky();
      return true;
    }

    root.querySelectorAll("[data-st11-card]").forEach(paintCard);
    window.setTimeout(ensureModal, 0);
    placeReviewFilters();
    filterReviews("all");
    if (!attachSticky()) {
      var stickyTries = 0;
      var stickyWait = window.setInterval(function () {
        stickyTries += 1;
        if (attachSticky() || stickyTries > 40) window.clearInterval(stickyWait);
      }, 50);
    }
  }

  function boot() {
    document.querySelectorAll("[data-lph-root]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var next = event.target && event.target.querySelector ? event.target.querySelector("[data-lph-root]") : null;
    if (!next) return;
    delete next.dataset.lphBound;
    init(next);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-col-sale-pb-01"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MIN = 60000;
  var MAX_QTY = 6;
  var LIST_KEY = "bbe-pb-list";
  var SIGNUP_KEY = "bbe-pb-signup";

  function money(cents) {
    return "$" + (Math.max(0, cents) / 100).toFixed(2);
  }
  function pad(n) {
    return n < 10 ? "0" + n : String(n);
  }
  function readJSON(key, fallback) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }
  function writeJSON(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }
  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function init(root) {
    if (!root || root.dataset.pbBound === "1") return;
    root.dataset.pbBound = "1";

    var config = {};
    try {
      config = JSON.parse(root.getAttribute("data-pb-config") || "{}");
    } catch (err) {
      config = {};
    }
    var code = String(config.code || "");
    var percent = parseInt(config.percent, 10);
    if (!isFinite(percent) || percent < 0 || percent > 90) percent = 45;
    var stealPct = config.stealPct || {};
    var T = {
      app: Date.parse(config.appOpen),
      web: Date.parse(config.webOpen),
      end: Date.parse(config.saleEnd),
      code: Date.parse(config.codeFrom),
    };
    T.final = T.end - (parseInt(config.finalMinutes, 10) || 10) * MIN;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var rootId = root.id || "";

    var offset = 0;
    var override = new URLSearchParams(window.location.search).get("pb_now");
    if (override && isFinite(Date.parse(override))) {
      offset = Date.parse(override) - Date.now();
    } else {
      fetch(window.location.pathname, { method: "HEAD", cache: "no-store", credentials: "same-origin" })
        .then(function (res) {
          var d = Date.parse(res.headers.get("date") || "");
          if (isFinite(d) && Math.abs(d - Date.now()) > 5000) offset = d - Date.now();
        })
        .catch(function () {});
    }
    function now() {
      return Date.now() + offset;
    }
    function phaseAt(t) {
      if (t >= T.end) return "ended";
      if (t >= T.final) return "final";
      if (t >= T.web) return "live";
      if (t >= T.app) return "app";
      return "pre";
    }
    var phase = root.getAttribute("data-pb-phase") || "pre";
    function saleOn() {
      return phase === "live" || phase === "final";
    }
    function preSale() {
      return phase === "pre" || phase === "app";
    }

    var toast = root.querySelector("[data-pb-toast]");
    var toastTimer = null;
    function showToast(msg) {
      if (!toast || !msg) return;
      toast.textContent = msg;
      toast.classList.add("is-visible");
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove("is-visible");
        setTimeout(function () {
          if (!toast.classList.contains("is-visible")) toast.textContent = "";
        }, 250);
      }, 2800);
    }

    /* ---------- links: app, calendar, local time ---------- */
    var ua = navigator.userAgent || "";
    var appUrl = /android/i.test(ua) ? config.androidUrl : config.iosUrl;
    root.querySelectorAll("[data-pb-app-link]").forEach(function (a) {
      a.setAttribute("href", appUrl);
      a.setAttribute("target", "_blank");
      a.setAttribute("rel", "noopener");
    });
    function calStamp(ms) {
      return new Date(ms).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
    }
    var gcal = root.querySelector('[data-pb-cal="google"]');
    if (gcal && isFinite(T.web)) {
      gcal.href =
        "https://calendar.google.com/calendar/render?action=TEMPLATE&text=" +
        encodeURIComponent(config.calTitle) +
        "&dates=" + calStamp(T.web) + "/" + calStamp(T.end) +
        "&details=" + encodeURIComponent("Shop here: " + config.pageUrl) +
        "&location=" + encodeURIComponent(config.pageUrl);
    }
    function downloadIcs() {
      var ics = [
        "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Beauty by Earth//Birthday Sale//EN",
        "BEGIN:VEVENT", "UID:pb-" + T.web + "@beautybyearth.com", "DTSTAMP:" + calStamp(Date.now()),
        "DTSTART:" + calStamp(T.web), "DTEND:" + calStamp(T.end),
        "SUMMARY:" + config.calTitle, "URL:" + config.pageUrl, "DESCRIPTION:Shop here: " + config.pageUrl,
        "BEGIN:VALARM", "TRIGGER:-PT10M", "ACTION:DISPLAY", "DESCRIPTION:" + config.calTitle, "END:VALARM",
        "END:VEVENT", "END:VCALENDAR",
      ].join("\r\n");
      var url = URL.createObjectURL(new Blob([ics], { type: "text/calendar" }));
      var a = document.createElement("a");
      a.href = url;
      a.download = "prue-birthday-sale.ics";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz && tz !== "America/Chicago" && isFinite(T.web)) {
        var local = new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit", timeZoneName: "short" }).format(T.web);
        root.querySelectorAll("[data-pb-localtime]").forEach(function (el) {
          el.textContent = " (" + local + " your time)";
        });
      }
    } catch (e) {}

    /* ---------- cards ---------- */
    var list = readJSON(LIST_KEY, []);
    if (!Array.isArray(list)) list = [];
    function listHas(id) {
      return list.some(function (x) { return String(x.id) === String(id); });
    }
    function cardPct(card) {
      if (phase === "ended") return 0;
      var grid = card.closest("[data-pb-grid]");
      if (grid && grid.getAttribute("data-pb-grid") === "steals") {
        var p = parseInt(stealPct[card.getAttribute("data-st11-id")], 10);
        return isFinite(p) ? p : percent;
      }
      return percent;
    }
    function allCards() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-st11-card][data-st11-mode="select"]'));
    }
    function qtyOf(card) {
      return parseInt(card.getAttribute("data-pb-qty") || "0", 10) || 0;
    }
    function salePrice(card) {
      var list = parseInt(card.getAttribute("data-st11-price"), 10) || 0;
      return Math.round((list * (100 - cardPct(card))) / 100);
    }

    var seen = {};
    allCards().forEach(function (card) {
      var id = card.getAttribute("data-st11-id");
      if (seen[id]) {
        card.remove();
        return;
      }
      seen[id] = true;
    });

    function paintPrices(card) {
      var list = parseInt(card.getAttribute("data-st11-price"), 10) || 0;
      var pct = cardPct(card);
      var sale = salePrice(card);
      var strike = list > sale ? list : 0;
      var nowEl = card.querySelector("[data-st11-price-display]");
      var wasEl = card.querySelector("[data-st11-compare-display]");
      var row = card.querySelector(".lp-collection-card__price");
      if (nowEl) nowEl.textContent = money(sale);
      if (strike > sale) {
        if (!wasEl && row) {
          wasEl = document.createElement("s");
          wasEl.className = "lp-collection-card__price-was";
          wasEl.setAttribute("data-st11-compare-display", "");
          row.appendChild(wasEl);
        }
        if (wasEl) {
          wasEl.hidden = false;
          wasEl.textContent = money(strike);
        }
      } else if (wasEl) {
        wasEl.hidden = true;
      }
      var fri = card.querySelector("[data-pb-fri]");
      if (preSale() && pct > 0) {
        if (!fri && row) {
          fri = document.createElement("span");
          fri.className = "pb-fri";
          fri.setAttribute("data-pb-fri", "");
          fri.textContent = "Friday price";
          row.appendChild(fri);
        }
        if (fri) fri.hidden = false;
      } else if (fri) {
        fri.hidden = true;
      }
      var media = card.querySelector(".lp-collection-card__media");
      var off = card.querySelector("[data-pb-off]");
      if (pct > 0 && media) {
        if (!off) {
          off = document.createElement("span");
          off.className = "pb-off pb-num";
          off.setAttribute("data-pb-off", "");
          media.appendChild(off);
        }
        off.hidden = false;
        off.textContent = pct + "% OFF";
      } else if (off) {
        off.hidden = true;
      }
    }

    function paintCard(card) {
      paintPrices(card);
      var btn = card.querySelector("[data-st11-toggle]");
      var btnText = card.querySelector("[data-st11-btn-text]");
      var qtyWrap = card.querySelector("[data-st11-qty]");
      var count = card.querySelector("[data-st11-qty-count]");
      var minus = card.querySelector("[data-st11-qty-minus]");
      var plus = card.querySelector("[data-st11-qty-plus]");
      var check = card.querySelector("[data-st11-btn-check]");
      var name = card.getAttribute("data-st11-title") || "";
      if (preSale()) {
        var on = listHas(card.getAttribute("data-st11-id"));
        card.classList.toggle("pb-listed", on);
        card.classList.remove("is-selected");
        card.setAttribute("aria-pressed", on ? "true" : "false");
        if (btn) {
          btn.hidden = false;
          btn.setAttribute("aria-pressed", on ? "true" : "false");
          btn.setAttribute("aria-label", (on ? "Remove " : "Save ") + name + (on ? " from" : " to") + " your Friday list");
        }
        if (btnText) btnText.textContent = on ? "On your Friday list" : "Save to Friday list";
        if (check) check.hidden = !on;
        if (qtyWrap) {
          qtyWrap.hidden = true;
          qtyWrap.setAttribute("aria-hidden", "true");
        }
        return;
      }
      var qty = qtyOf(card);
      var picked = qty > 0;
      card.classList.remove("pb-listed");
      card.classList.toggle("is-selected", picked);
      card.setAttribute("aria-pressed", picked ? "true" : "false");
      if (btn) {
        btn.hidden = picked;
        btn.setAttribute("aria-pressed", picked ? "true" : "false");
        btn.removeAttribute("aria-label");
      }
      if (btnText) btnText.textContent = "Add to bag";
      if (check) check.hidden = !picked;
      if (qtyWrap) {
        qtyWrap.hidden = !picked;
        qtyWrap.setAttribute("aria-hidden", picked ? "false" : "true");
      }
      if (count) count.textContent = String(Math.max(qty, 1));
      if (minus) {
        minus.disabled = !picked;
        minus.setAttribute("aria-label", "Remove one " + name);
      }
      if (plus) {
        plus.disabled = qty >= MAX_QTY;
        plus.setAttribute("aria-label", "Add one " + name);
      }
    }

    function selectedCards() {
      return allCards()
        .filter(function (card) {
          return qtyOf(card) > 0 && card.getAttribute("data-st11-available") === "true";
        })
        .map(function (card) {
          return {
            el: card,
            id: Number(card.getAttribute("data-st11-id")),
            variant: Number(card.getAttribute("data-st11-variant")),
            price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
            sale: salePrice(card),
            img: card.getAttribute("data-st11-img") || "",
            qty: qtyOf(card),
          };
        });
    }

    var codeSent = false;
    function ensureCode() {
      if (codeSent || !code || !saleOn()) return;
      codeSent = true;
      var done = function () { showToast("Code " + code + " is on your bag"); };
      if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === "function") {
        window.liquidAjaxCart.update({ discount: code }, { lastCallback: done });
        return;
      }
      fetch(config.cartUpdateUrl || "/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ discount: code }),
      })
        .then(function (res) { if (res.ok) done(); })
        .catch(function () {});
    }

    function setQty(card, next) {
      if (!card || card.getAttribute("data-st11-available") !== "true") return;
      var qty = Math.max(0, Math.min(MAX_QTY, next));
      var was = qtyOf(card);
      card.setAttribute("data-pb-qty", String(qty));
      paintCard(card);
      if (qty > 0 && was === 0) ensureCode();
      updateSticky();
    }

    function toggleList(card) {
      var id = card.getAttribute("data-st11-id");
      if (listHas(id)) {
        list = list.filter(function (x) { return String(x.id) !== String(id); });
        showToast("Removed from your Friday list");
      } else {
        list.push({ id: id, variant: card.getAttribute("data-st11-variant") });
        showToast("Saved to your Friday list · " + (card.getAttribute("data-st11-title") || ""));
      }
      writeJSON(LIST_KEY, list);
      paintCard(card);
      updateSticky();
    }

    var listLoaded = false;
    var listBan = root.querySelector("[data-pb-listban]");
    function loadListIntoPicks() {
      if (listLoaded || !list.length) return;
      listLoaded = true;
      var added = 0;
      var gone = 0;
      list.forEach(function (item) {
        var card = root.querySelector('[data-st11-card][data-st11-id="' + item.id + '"]');
        if (!card || card.getAttribute("data-st11-available") !== "true") {
          gone += 1;
          return;
        }
        var sel = card.querySelector("[data-st11-variant-select]");
        if (sel && item.variant) {
          var opt = sel.querySelector('option[value="' + item.variant + '"]:not([disabled])');
          if (opt) {
            sel.value = item.variant;
            applyVariant(card, sel);
          }
        }
        card.setAttribute("data-pb-qty", "1");
        paintCard(card);
        added += 1;
      });
      if (added) ensureCode();
      if (listBan && added) {
        var total = selectedCards().reduce(function (a, c) { return a + c.sale * c.qty; }, 0);
        var txt = listBan.querySelector("[data-pb-listban-text]");
        if (txt) {
          txt.textContent = added + " item" + (added === 1 ? "" : "s") + " picked below · " + money(total) +
            (gone ? " · " + gone + " sold out before you got here" : "");
        }
        listBan.hidden = false;
      }
    }

    function applyVariant(card, sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      card.setAttribute("data-st11-variant", opt.value);
      card.setAttribute("data-st11-price", opt.getAttribute("data-price") || "0");
      card.setAttribute("data-st11-compare", opt.getAttribute("data-compare") || "0");
      paintPrices(card);
    }

    /* ---------- sticky ---------- */
    var api = null;
    var sticky = root.querySelector("[data-lp-sticky]");
    var signupState = readJSON(SIGNUP_KEY, null) || {};
    function stickyEls() {
      return {
        title: sticky && sticky.querySelector("[data-lp-sticky-title]"),
        status: sticky && sticky.querySelector("[data-lp-sticky-status]"),
        thumbs: sticky && sticky.querySelector("[data-lp-sticky-thumbs]"),
        empty: sticky && sticky.querySelector("[data-lp-sticky-empty]"),
        badge: sticky && sticky.querySelector("[data-lp-sticky-badge]"),
        price: sticky && sticky.querySelector("[data-lp-sticky-price]"),
        now: sticky && sticky.querySelector("[data-lp-sticky-price-now]"),
        was: sticky && sticky.querySelector("[data-lp-sticky-price-was]"),
        cta: sticky && sticky.querySelector("[data-lp-sticky-cta-text]"),
      };
    }
    function skinSticky() {
      if (!sticky) return;
      sticky.classList.add("pb-sticky");
      var st = sticky.querySelector("[data-lp-sticky-status]");
      if (st) st.classList.remove("is-offer-pulse");
    }
    skinSticky();
    var stickyAction = "signup";

    function updateSticky() {
      if (!sticky) return;
      var e = stickyEls();
      var picks = [];
      var units = 0;
      var total = 0;
      var regular = 0;
      if (preSale()) {
        list.forEach(function (item) {
          var card = root.querySelector('[data-st11-card][data-st11-id="' + item.id + '"]');
          if (!card) return;
          picks.push({ img: card.getAttribute("data-st11-img") || "" });
          units += 1;
          total += salePrice(card);
          regular += parseInt(card.getAttribute("data-st11-price"), 10) || 0;
        });
      } else {
        selectedCards().forEach(function (c) {
          picks.push(c);
          units += c.qty;
          total += c.sale * c.qty;
          regular += c.price * c.qty;
        });
      }
      if (e.thumbs) {
        e.thumbs.innerHTML = "";
        picks.slice(0, 3).forEach(function (c) {
          if (!c.img) return;
          var im = document.createElement("img");
          im.src = c.img;
          im.alt = "";
          e.thumbs.appendChild(im);
        });
      }
      if (e.empty) e.empty.hidden = units > 0;
      if (e.badge) {
        e.badge.textContent = String(units);
        e.badge.classList.toggle("is-active", units > 0);
      }
      sticky.classList.toggle("pb-sticky--empty", units < 1);
      var title = "";
      var status = "";
      var cta = "";
      if (preSale()) {
        var signed = signupState.step === 3;
        if (units) {
          title = "Friday list · " + units + " item" + (units === 1 ? "" : "s");
          status = money(total) + " on Friday · you save " + money(regular - total);
          cta = signed ? "Review list" : "Save my spot";
          stickyAction = signed ? "steals" : "signup";
        } else if (signed) {
          title = "You're on the list";
          status = "Next, save the Steals you want";
          cta = "Build my list";
          stickyAction = "steals";
        } else {
          title = "45% off everything · Fri 12:00 PM CT";
          status = "Get your link before doors open";
          cta = "Save my spot";
          stickyAction = "signup";
        }
      } else if (units) {
        title = "Bag (" + units + ") · " + money(total);
        status = (regular > total ? "You save " + money(regular - total) : "Ready to check out") + (saleOn() && code ? " · code " + code : "");
        cta = "Checkout";
        stickyAction = "checkout";
      } else if (saleOn()) {
        title = "45% off ends at " + (config.endLabel || "12:45 PM CT");
        status = code ? "Code " + code + " applies at checkout" : "Discount applies at checkout";
        cta = root.querySelector("#pb-steals") ? "Shop Steals" : "Shop now";
        stickyAction = "shop";
      } else {
        title = "Customer favorites";
        status = "Back at regular price";
        cta = "Shop";
        stickyAction = "shop";
      }
      if (e.title) e.title.textContent = title;
      if (e.status) e.status.textContent = status;
      if (e.cta) e.cta.textContent = cta;
      if (e.price) {
        e.price.hidden = preSale() || units < 1;
        if (e.now) e.now.textContent = money(total);
        if (e.was) e.was.textContent = regular > total ? money(regular) : "";
      }
      if (api) {
        var threshold = api.scrollThreshold(160, 240);
        if (units > 0 || api.scrollY() > threshold) api.reveal(sticky, root);
        else api.hide(sticky, root);
      }
    }

    /* ---------- navigation + checkout ---------- */
    function scrollToEl(el, block) {
      if (!el) return;
      el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: block || "start" });
    }
    function goSignup() {
      var target = phase === "ended" ? root.querySelector("#pb-ea") : root.querySelector("#pb-signup");
      if (!target) return;
      scrollToEl(target, "center");
      var input = target.querySelector("[data-pb-step]:not([hidden]) input");
      setTimeout(function () {
        (input || target).focus({ preventScroll: true });
      }, reduce ? 0 : 450);
    }
    function goShop() {
      var el = root.querySelector("#pb-steals:not([hidden])") || root.querySelector("#pb-all");
      if (api && el) api.scrollTo(el);
      else scrollToEl(el);
    }
    var modalApi = null;
    function ensureModal() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) return null;
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () { return selectedCards().map(function (c) { return c.variant; }); },
        getParentProductIds: function () { return selectedCards().map(function (c) { return c.id; }); },
        getParentCartItems: function () {
          return selectedCards().map(function (c) { return { id: c.variant, quantity: c.qty }; });
        },
        canCheckout: function () { return selectedCards().length > 0; },
        onCheckoutBlocked: function () {
          showToast("Choose a product first");
          goShop();
        },
        onStickySuppress: function (on) { if (api) api.suppress(on); },
      });
      return modalApi;
    }
    function directCheckout() {
      var items = selectedCards().map(function (c) {
        return { id: c.variant, quantity: c.qty };
      });
      if (!items.length) {
        showToast("Choose a product first");
        goShop();
        return;
      }
      var go = function () { window.location.assign("/checkout"); };
      var applyDiscount = function () {
        codeSent = true;
        if (!code) {
          go();
          return;
        }
        if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === "function") {
          window.liquidAjaxCart.update({ discount: code }, { lastCallback: go });
          return;
        }
        fetch(config.cartUpdateUrl || "/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: code }),
        }).finally(go);
      };
      fetch((window.routes && window.routes.cart_add_url) || "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("cart");
          return res.json();
        })
        .then(applyDiscount)
        .catch(function () {
          showToast("Couldn't start checkout. Try again.");
        });
    }
    function openCheckout() {
      if (!selectedCards().length) {
        showToast("Choose a product first");
        goShop();
        return;
      }
      if (config.upsell) {
        ensureCode();
        var modal = ensureModal();
        if (modal && typeof modal.open === "function") {
          modal.open();
          return;
        }
      }
      directCheckout();
    }
    function onStickyClick(event) {
      var bar = event.target.closest("[data-lp-sticky]");
      if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
      if (!event.target.closest("[data-lp-sticky-cta]")) return;
      event.preventDefault();
      if (stickyAction === "checkout") openCheckout();
      else if (stickyAction === "signup") goSignup();
      else if (stickyAction === "steals") scrollToEl(root.querySelector("#pb-steals") || root.querySelector("#pb-all"));
      else goShop();
    }
    if (root.dataset.pbStickyDoc !== "1") {
      root.dataset.pbStickyDoc = "1";
      document.addEventListener("click", onStickyClick);
    }

    /* ---------- signup ---------- */
    var emailOk = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()); };
    function klaviyoCompany() {
      if (config.klaviyoCompany && config.klaviyoCompany !== "x") return config.klaviyoCompany;
      var scripts = document.querySelectorAll('script[src*="klaviyo"]');
      for (var i = 0; i < scripts.length; i++) {
        var m = scripts[i].src.match(/company_id=([A-Za-z0-9]+)/) || scripts[i].src.match(/onsite\/js\/([A-Za-z0-9]+)\//);
        if (m) return m[1];
      }
      return "";
    }
    function subscribe(opts) {
      var company = klaviyoCompany();
      if (opts.listId && company) {
        var attrs = { email: opts.email };
        return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(company), {
          method: "POST",
          headers: { "Content-Type": "application/vnd.api+json", revision: "2024-10-15" },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: { custom_source: opts.source, profile: { data: { type: "profile", attributes: attrs } } },
              relationships: { list: { data: { type: "list", id: opts.listId } } },
            },
          }),
        }).then(function (res) {
          if (!res.ok) throw new Error("subscribe " + res.status);
        });
      }
      var body = new URLSearchParams();
      body.set("form_type", "customer");
      body.set("utf8", "\u2713");
      body.set("contact[email]", opts.email);
      body.set("contact[tags]", "newsletter," + opts.tag);
      return fetch(config.contactUrl || "/contact", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
        credentials: "same-origin",
      }).then(function (res) {
        if (!res.ok && res.status !== 302) throw new Error("contact " + res.status);
      });
    }
    function subscribeSms(phone) {
      return new Promise(function (resolve, reject) {
        if (!config.psShopId || !config.psKeywordId) {
          reject(new Error("postscript"));
          return;
        }
        var frame = root.querySelector("[data-pb-ps-frame]");
        if (!frame) {
          reject(new Error("postscript"));
          return;
        }
        var form = document.createElement("form");
        form.method = "post";
        form.action = "https://api.postscript.io/subscribe/form";
        form.target = frame.getAttribute("name");
        form.hidden = true;
        var fields = { shop_id: config.psShopId, keyword_id: config.psKeywordId, phone: phone };
        Object.keys(fields).forEach(function (name) {
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.value = fields[name];
          form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
        form.remove();
        resolve();
      });
    }

    function showStep(box, n, focus) {
      box.querySelectorAll("[data-pb-step]").forEach(function (el) {
        el.hidden = el.getAttribute("data-pb-step") !== String(n);
      });
      var shown = box.querySelector('[data-pb-step="' + n + '"]');
      if (!focus || !shown) return;
      var target = n === 3 ? shown.querySelector("[data-pb-done-title]") : shown.querySelector("input");
      if (target) target.focus();
    }
    function fillOut(box, state) {
      box.querySelectorAll('[data-pb-out="email"]').forEach(function (el) { el.textContent = state.email || ""; });
      box.querySelectorAll('[data-pb-out="phone"]').forEach(function (el) { el.textContent = state.phone || ""; });
      var smsLine = box.querySelector('li[data-pb-out="sms"]');
      if (smsLine) smsLine.hidden = !state.sms;
    }
    function setErr(form, msg) {
      var step = form.closest("[data-pb-step]");
      var err = step && step.querySelector("[data-pb-err]");
      var input = form.querySelector("input");
      if (err) err.textContent = msg || "";
      if (input) {
        if (msg) input.setAttribute("aria-invalid", "true");
        else input.removeAttribute("aria-invalid");
        if (msg) input.focus();
      }
    }
    function busy(form, on) {
      var btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      btn.disabled = on;
      btn.setAttribute("aria-busy", on ? "true" : "false");
    }
    var mainBox = root.querySelector('[data-pb-signup="main"]');
    var eaBox = root.querySelector('[data-pb-signup="ea"]');
    if (mainBox && signupState.step === 3) {
      fillOut(mainBox, signupState);
      showStep(mainBox, 3);
    }
    var eaState = readJSON(SIGNUP_KEY + "-ea", null);
    if (eaBox && eaState && eaState.email) {
      fillOut(eaBox, eaState);
      showStep(eaBox, 3);
    }

    root.addEventListener("input", function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('[data-pb-form="phone"] input')) return;
      var d = input.value.replace(/\D/g, "");
      if (d.length === 11 && d.charAt(0) === "1") d = d.slice(1);
      d = d.slice(0, 10);
      var f = d;
      if (d.length > 6) f = "(" + d.slice(0, 3) + ") " + d.slice(3, 6) + "-" + d.slice(6);
      else if (d.length > 3) f = "(" + d.slice(0, 3) + ") " + d.slice(3);
      else if (d.length) f = "(" + d;
      input.value = f;
    });

    root.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-pb-form]");
      if (!form) return;
      event.preventDefault();
      var kind = form.getAttribute("data-pb-form");
      var input = form.querySelector("input");
      var value = input ? input.value.trim() : "";
      if (kind === "email" || kind === "ea") {
        if (!emailOk(value)) {
          setErr(form, "Enter an email like name@example.com.");
          return;
        }
        setErr(form, "");
        busy(form, true);
        var isEa = kind === "ea";
        subscribe({
          email: value,
          listId: isEa ? config.eaListId : config.listId,
          tag: isEa ? config.eaTag : config.tag,
          source: isEa ? "Black Friday Early Access LP" : "Prue Birthday Sale LP",
        })
          .then(function () {
            busy(form, false);
            if (isEa) {
              var st = { email: value };
              writeJSON(SIGNUP_KEY + "-ea", st);
              fillOut(eaBox, st);
              showStep(eaBox, 3, true);
              showToast("You're on the Early Access list.");
              return;
            }
            signupState = { email: value, step: config.psKeywordId ? 2 : 3 };
            writeJSON(SIGNUP_KEY, signupState);
            fillOut(mainBox, signupState);
            showStep(mainBox, signupState.step, true);
            showToast(signupState.step === 2 ? "Spot saved. One more optional step." : "Spot saved.");
            updateSticky();
          })
          .catch(function () {
            busy(form, false);
            setErr(form, "That didn't go through. Check your connection and try again.");
          });
        return;
      }
      if (kind === "phone") {
        var digits = value.replace(/\D/g, "");
        if (digits.length !== 10) {
          setErr(form, "Enter a 10-digit US mobile number.");
          return;
        }
        setErr(form, "");
        busy(form, true);
        subscribeSms("+1" + digits)
          .then(function () {
            busy(form, false);
            signupState.phone = value;
            signupState.sms = true;
            signupState.step = 3;
            writeJSON(SIGNUP_KEY, signupState);
            fillOut(mainBox, signupState);
            showStep(mainBox, 3, true);
            showToast("We'll text your link before doors open.");
            updateSticky();
          })
          .catch(function () {
            busy(form, false);
            setErr(form, "That didn't go through. Check the number and try again.");
          });
      }
    });

    /* ---------- clicks ---------- */
    root.addEventListener("click", function (event) {
      var t = event.target;
      if (t.closest("[data-pb-to-signup]")) {
        event.preventDefault();
        goSignup();
        return;
      }
      if (t.closest("[data-pb-skip-sms]")) {
        signupState.step = 3;
        writeJSON(SIGNUP_KEY, signupState);
        fillOut(mainBox, signupState);
        showStep(mainBox, 3, true);
        updateSticky();
        return;
      }
      if (t.closest("[data-pb-edit]")) {
        signupState = {};
        writeJSON(SIGNUP_KEY, signupState);
        showStep(mainBox, 1, true);
        updateSticky();
        return;
      }
      if (t.closest('[data-pb-cal="ics"]')) {
        downloadIcs();
        return;
      }
      if (t.closest("[data-pb-checkout]")) {
        openCheckout();
        return;
      }
      var copyBtn = t.closest("[data-pb-copy]");
      if (copyBtn) {
        var label = copyBtn.querySelector("[data-pb-copy-label]");
        var finish = function () {
          if (label) label.textContent = "Copied";
          showToast("Code " + code + " copied");
          setTimeout(function () { if (label) label.textContent = "Copy"; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(finish, finish);
        else finish();
        ensureCode();
        return;
      }
      var hash = t.closest('a[href^="#pb-"]');
      if (hash) {
        event.preventDefault();
        var dest = root.querySelector(hash.getAttribute("href"));
        if (api && dest) api.scrollTo(dest);
        else scrollToEl(dest);
        return;
      }

      var minus = t.closest("[data-st11-qty-minus]");
      if (minus) {
        var mc = minus.closest("[data-st11-card]");
        if (mc) setQty(mc, qtyOf(mc) - 1);
        return;
      }
      var plus = t.closest("[data-st11-qty-plus]");
      if (plus) {
        var pc = plus.closest("[data-st11-card]");
        if (pc) setQty(pc, qtyOf(pc) + 1);
        return;
      }
      var card = t.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (t.closest("select")) return;
      if (card.getAttribute("data-st11-available") !== "true") return;
      event.preventDefault();
      if (preSale()) {
        toggleList(card);
        return;
      }
      if (qtyOf(card) > 0) return;
      setQty(card, 1);
    });

    root.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      var card = event.target.closest && event.target.closest('[data-st11-card][role="button"]');
      if (!card || event.target !== card) return;
      event.preventDefault();
      card.click();
    });

    root.addEventListener("change", function (event) {
      var sel = event.target.closest("[data-st11-variant-select]");
      if (!sel || !root.contains(sel)) return;
      var card = sel.closest("[data-st11-card]");
      if (!card) return;
      applyVariant(card, sel);
      if (preSale() && listHas(card.getAttribute("data-st11-id"))) {
        list.forEach(function (x) {
          if (String(x.id) === card.getAttribute("data-st11-id")) x.variant = sel.value;
        });
        writeJSON(LIST_KEY, list);
      }
      updateSticky();
    });

    /* ---------- phase + clocks ---------- */
    var TRANS = {
      app: "11:00 AM CT. App doors just opened.",
      live: "Website doors are open. 45% off starts now.",
      final: "Ten minutes left.",
      ended: "The sale has ended, right on time.",
    };
    function applyPhase(next, announce) {
      var changed = next !== phase;
      phase = next;
      root.setAttribute("data-pb-phase", phase);
      root.classList.toggle("is-urgent", phase === "final");
      root.querySelectorAll("[data-pb-show]").forEach(function (el) {
        el.hidden = el.getAttribute("data-pb-show").split(" ").indexOf(phase) === -1;
      });
      var tag = root.querySelector("[data-pb-ann-tag]");
      if (tag) tag.textContent = phase === "final" ? "Last 10 min" : "Live";
      var dayBox = root.querySelector('[data-pb-unit="d"]');
      if (dayBox) dayBox.hidden = phase === "app";
      if (saleOn()) loadListIntoPicks();
      if (!saleOn() && listBan) listBan.hidden = true;
      allCards().forEach(paintCard);
      updateSticky();
      if (changed && announce) showToast(TRANS[phase] || "");
    }

    var cdEls = root.querySelectorAll("[data-pb-countdown] [data-u]");
    var soonEl = root.querySelector("[data-pb-soon]");
    var notSoon = root.querySelectorAll("[data-pb-notsoon]");
    var nowLines = root.querySelectorAll("[data-pb-nowline]");
    var nowKey = root.querySelector("[data-pb-nowkey]");
    var codeBoxes = root.querySelectorAll("[data-pb-code]");
    function hms(ms) {
      ms = Math.max(0, ms);
      var h = Math.floor(ms / 3600000);
      var m = Math.floor(ms / MIN) % 60;
      var sec = Math.floor(ms / 1000) % 60;
      return h > 0 ? pad(h) + ":" + pad(m) + ":" + pad(sec) : pad(m) + ":" + pad(sec);
    }
    function tick() {
      var t = now();
      var next = phaseAt(t);
      if (next !== phase) applyPhase(next, true);
      var toWeb = Math.max(0, T.web - t);
      var parts = {
        d: Math.floor(toWeb / 86400000),
        h: phase === "app" ? Math.floor(toWeb / 3600000) : Math.floor(toWeb / 3600000) % 24,
        m: Math.floor(toWeb / MIN) % 60,
        s: Math.floor(toWeb / 1000) % 60,
      };
      cdEls.forEach(function (el) { el.textContent = pad(parts[el.getAttribute("data-u")]); });
      root.querySelectorAll("[data-pb-clock]").forEach(function (el) {
        var k = el.getAttribute("data-pb-clock");
        el.textContent = k === "web" ? hms(T.web - t) : hms(T.end - t);
      });
      var soon = phase === "app" && T.web - t <= 10 * MIN;
      if (soonEl) soonEl.hidden = !soon;
      notSoon.forEach(function (el) { el.hidden = soon || phase !== "app"; });
      var codeOn = t >= T.code && t < T.end;
      codeBoxes.forEach(function (el) { el.hidden = !codeOn; });
      var span = T.end - T.app;
      var inWin = t >= T.app && t <= T.end;
      nowLines.forEach(function (b) {
        b.hidden = !inWin;
        if (inWin) b.style.left = ((t - T.app) / span) * 100 + "%";
      });
      if (nowKey) nowKey.hidden = !inWin;
    }

    function attachSticky() {
      api = stickyApi();
      if (!api) return false;
      sticky = api.resolve(root, rootId) || sticky;
      skinSticky();
      updateSticky();
      return true;
    }

    window.addEventListener("scroll", function () { updateSticky(); }, { passive: true });
    applyPhase(phaseAt(now()), false);
    tick();
    window.setInterval(tick, 1000);
    window.setTimeout(ensureModal, 0);
    if (!attachSticky()) {
      var tries = 0;
      var wait = window.setInterval(function () {
        tries += 1;
        if (attachSticky() || tries > 40) window.clearInterval(wait);
      }, 50);
    }
  }

  function boot() {
    document.querySelectorAll("[data-pb-root]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
  document.addEventListener("shopify:section:load", function (event) {
    var next = event.target && event.target.querySelector ? event.target.querySelector("[data-pb-root]") : null;
    if (!next) return;
    delete next.dataset.pbBound;
    init(next);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-gift-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_QTY = 6;

  function money(cents) {
    return "$" + (Math.max(0, cents) / 100).toFixed(2);
  }

  function stickyApi() {
    return window.BBELP && window.BBELP.sticky ? window.BBELP.sticky : null;
  }

  function saleOf(cents, percent) {
    return Math.round((cents * (100 - percent)) / 100);
  }

  function init(root) {
    if (!root || root.dataset.lggBound === "1") return;
    root.dataset.lggBound = "1";

    var config = {};
    try { config = JSON.parse(root.getAttribute("data-lgg-config") || "{}"); } catch (err) { config = {}; }

    var code = String(config.discountCode || "").trim();
    var percent = parseInt(config.percent, 10);
    if (!isFinite(percent) || percent < 0 || percent > 90) percent = 0;
    var shipAt = parseInt(config.shipAt, 10) || 6500;
    var giftAt = parseInt(config.giftAt, 10) || 10000;
    var showGift = config.showGift === true;
    var idleLabel = config.idleLabel || "Shop gifts";
    var readyLabel = config.readyLabel || "Check out";
    var bestId = String(config.bestId || "");
    var rootId = root.id || "";
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var picks = {};
    var cartTotal = 0;
    var codeSent = false;
    var codePromise = null;
    var modalApi = null;
    var api = null;
    var toast = root.querySelector("[data-lgg-toast]");
    var toastText = root.querySelector("[data-lgg-toast-text]");
    var toastTimer = null;

    var sticky = root.querySelector("[data-lp-sticky]");
    var stickyStatus, stickyThumbs, stickyEmpty, stickyBadge, stickyPrice, stickyNow, stickyWas, stickyCtaText;
    function bindSticky() {
      if (!sticky) return;
      stickyStatus = sticky.querySelector("[data-lp-sticky-status]");
      stickyThumbs = sticky.querySelector("[data-lp-sticky-thumbs]");
      stickyEmpty = sticky.querySelector("[data-lp-sticky-empty]");
      stickyBadge = sticky.querySelector("[data-lp-sticky-badge]");
      stickyPrice = sticky.querySelector("[data-lp-sticky-price]");
      stickyNow = sticky.querySelector("[data-lp-sticky-price-now]");
      stickyWas = sticky.querySelector("[data-lp-sticky-price-was]");
      stickyCtaText = sticky.querySelector("[data-lp-sticky-cta-text]");
      if (stickyCtaText) stickyCtaText.textContent = "Shop the gift guide";
      if (stickyStatus) stickyStatus.classList.remove("is-offer-pulse");
    }
    bindSticky();

    function showToast(msg) {
      if (!toast) return;
      if (toastText) toastText.textContent = msg;
      toast.hidden = false;
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.hidden = true; }, 2800);
    }

    function applyCode(quiet) {
      return new Promise(function (resolve) {
        var settled = false;
        var finish = function (msg) {
          if (settled) return;
          settled = true;
          if (msg && !quiet) showToast(msg);
          resolve();
        };
        var timer = setTimeout(function () { finish(); }, 4000);
        var ok = function () { clearTimeout(timer); finish(); };
        var fallback = function () { clearTimeout(timer); finish("Code " + code + " will apply at checkout"); };
        if (window.liquidAjaxCart && typeof window.liquidAjaxCart.update === "function") {
          window.liquidAjaxCart.update({ discount: code }, { lastCallback: ok });
          return;
        }
        fetch(config.cartUpdateUrl || "/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: code })
        }).then(function (res) { if (res && res.ok) ok(); else fallback(); }).catch(fallback);
      });
    }

    function ensureCode(quiet) {
      if (!code || percent < 1) return Promise.resolve();
      if (codePromise) return codePromise;
      codeSent = true;
      codePromise = applyCode(quiet);
      return codePromise;
    }

    function listPicks() {
      return Object.keys(picks).map(function (id) { return picks[id]; }).filter(function (row) { return row && row.qty > 0; });
    }

    function paintPrices(card) {
      if (percent < 1) return;
      var list = parseInt(card.getAttribute("data-st11-price"), 10) || 0;
      var compare = parseInt(card.getAttribute("data-st11-compare"), 10) || 0;
      var sale = saleOf(list, percent);
      var strike = compare > sale ? compare : list > sale ? list : 0;
      var nowEl = card.querySelector("[data-st11-price-display]");
      var wasEl = card.querySelector("[data-st11-compare-display]");
      var priceRow = card.querySelector(".lp-collection-card__price");
      if (nowEl) nowEl.textContent = money(sale);
      if (strike > sale) {
        if (!wasEl && priceRow) {
          wasEl = document.createElement("s");
          wasEl.className = "lp-collection-card__price-was";
          wasEl.setAttribute("data-st11-compare-display", "");
          priceRow.appendChild(wasEl);
        }
        if (wasEl) { wasEl.hidden = false; wasEl.textContent = money(strike); }
      } else if (wasEl) {
        wasEl.hidden = true;
      }
    }

    function paintCard(card) {
      paintPrices(card);
      var id = card.getAttribute("data-st11-id");
      var qty = picks[id] ? picks[id].qty : 0;
      var on = qty > 0;
      card.classList.toggle("is-selected", on);
      card.setAttribute("data-lgg-qty", String(qty));
      if (card.hasAttribute("aria-pressed")) card.setAttribute("aria-pressed", on ? "true" : "false");
      var btn = card.querySelector("[data-st11-toggle]");
      var qtyWrap = card.querySelector("[data-st11-qty]");
      var count = card.querySelector("[data-st11-qty-count]");
      var minus = card.querySelector("[data-st11-qty-minus]");
      var plus = card.querySelector("[data-st11-qty-plus]");
      if (btn) { btn.hidden = on; btn.setAttribute("aria-pressed", on ? "true" : "false"); }
      if (qtyWrap) { qtyWrap.hidden = !on; qtyWrap.setAttribute("aria-hidden", on ? "false" : "true"); }
      if (count) count.textContent = String(Math.max(qty, 1));
      if (minus) minus.disabled = !on;
      if (plus) plus.disabled = qty >= MAX_QTY;
    }

    function mirror(id) {
      root.querySelectorAll('[data-st11-card][data-st11-id="' + id + '"]').forEach(function (card) {
        var row = picks[id];
        if (row) {
          card.setAttribute("data-st11-variant", String(row.variant));
          card.setAttribute("data-st11-price", String(row.price));
          card.setAttribute("data-st11-compare", String(row.compare));
          var sel = card.querySelector("[data-st11-variant-select]");
          if (sel && String(sel.value) !== String(row.variant)) sel.value = String(row.variant);
        }
        paintCard(card);
      });
      if (id === bestId) syncBest();
    }

    function writePick(card, qty) {
      var id = card.getAttribute("data-st11-id");
      if (!id || card.getAttribute("data-st11-available") !== "true") return;
      qty = Math.max(0, Math.min(MAX_QTY, qty));
      if (qty < 1) delete picks[id];
      else {
        picks[id] = {
          id: Number(id),
          variant: Number(card.getAttribute("data-st11-variant")),
          price: parseInt(card.getAttribute("data-st11-price"), 10) || 0,
          compare: parseInt(card.getAttribute("data-st11-compare"), 10) || 0,
          img: card.getAttribute("data-st11-img") || "",
          qty: qty
        };
      }
      mirror(id);
      refresh();
    }

    var mini = root.querySelector("[data-lgg-mini]");
    var miniCard = null;
    var miniInvoker = null;
    var miniGen = 0;
    var miniJson = new Map();
    var miniFeatures = new Map();
    var miniScroll = "";
    var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
    var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
    if (mini && mini.parentNode !== document.body) document.body.appendChild(mini);

    function escapeHtml(str) {
      return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function escapeAttr(str) { return escapeHtml(str).replace(/'/g, "&#39;"); }
    function shopRoot() {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      return base.charAt(base.length - 1) === "/" ? base : base + "/";
    }
    function handleFromCard(card) {
      var url = card.getAttribute("data-st11-url") || "";
      var match = url.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : "";
    }
    function withImageWidth(url, width) {
      var s = String(url || "").trim();
      if (!s) return "";
      try {
        var parsed = new URL(s, window.location.origin);
        if (parsed.hostname === "cdn.shopify.com" || parsed.pathname.indexOf("/cdn/shop/") === 0) {
          parsed.searchParams.set("width", String(width));
        }
        if (parsed.protocol === "http:" || parsed.protocol === "https:") return parsed.href;
      } catch (err) { /* skip */ }
      return "";
    }
    function clipText(text, max) {
      var t = String(text || "").replace(/\s+/g, " ").trim();
      if (t.length <= max) return t;
      return t.slice(0, max).replace(/\s+\S*$/, "") + "…";
    }
    function sanitizeDescription(html) {
      var doc;
      try { doc = new DOMParser().parseFromString(String(html || ""), "text/html"); } catch (err) { return ""; }
      if (!doc) return "";
      var blocks = Array.prototype.filter.call(doc.body.querySelectorAll("p, li, h2, h3, h4"), function (node) {
        return !node.querySelector("p, li");
      });
      var nodes = blocks.length ? blocks : [doc.body];
      var out = [];
      var used = 0;
      var inList = false;
      nodes.forEach(function (node) {
        if (used > 700 || out.length > 12) return;
        var text = clipText(node.textContent || "", 700);
        if (!text) return;
        var isItem = node.tagName === "LI";
        if (isItem !== inList) {
          out.push(isItem ? "<ul>" : "</ul>");
          inList = isItem;
        }
        out.push(isItem ? "<li>" + escapeHtml(text) + "</li>" : "<p>" + escapeHtml(text) + "</p>");
        used += text.length;
      });
      if (inList) out.push("</ul>");
      return out.join("");
    }
    function fetchJson(handle) {
      if (!miniJson.has(handle)) {
        miniJson.set(handle, fetch(shopRoot() + "products/" + encodeURIComponent(handle) + ".js", {
          credentials: "same-origin",
          headers: { Accept: "application/json" }
        }).then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; }));
      }
      return miniJson.get(handle);
    }
    function fetchFeatures(handle) {
      if (!miniFeatures.has(handle)) {
        miniFeatures.set(handle, fetch(shopRoot() + "products/" + encodeURIComponent(handle) + "?view=ppup-features", {
          credentials: "same-origin"
        }).then(function (res) { return res.ok ? res.text() : ""; }).then(function (text) {
          var start = text.indexOf("{");
          var end = text.lastIndexOf("}");
          if (start < 0 || end <= start) return [];
          var list = JSON.parse(text.slice(start, end + 1)).features;
          return Array.isArray(list) ? list : [];
        }).catch(function () { return []; }));
      }
      return miniFeatures.get(handle);
    }
    function paintMiniReviews(card) {
      var slot = mini.querySelector("[data-lgg-mini-reviews]");
      if (!slot || !card) return;
      var src = card.querySelector(".lp-collection-card__reviews");
      if (src) {
        slot.hidden = false;
        slot.innerHTML = src.innerHTML;
        slot.setAttribute("aria-label", src.getAttribute("aria-label") || "5 star rated");
        return;
      }
      var count = String(card.getAttribute("data-lgg-rating") || "").trim();
      slot.hidden = false;
      slot.innerHTML = '<span class="lgg-mini__stars" aria-hidden="true">★★★★★</span>' +
        (count ? '<span class="lgg-mini__reviews-ct">(' + escapeHtml(count) + ")</span>" : "");
      slot.setAttribute("aria-label", count ? "Rated 5 out of 5 stars, " + count + " reviews" : "5 star rated");
    }
    function paintMiniPrice(card) {
      var slot = mini.querySelector("[data-lgg-mini-price]");
      if (!slot || !card) return;
      var nowEl = card.querySelector("[data-st11-price-display]");
      var wasEl = card.querySelector("[data-st11-compare-display]");
      var nowText = nowEl ? nowEl.textContent.replace(/\s+/g, " ").trim() : (card.getAttribute("data-lgg-now") || "");
      var wasText = wasEl && !wasEl.hidden ? wasEl.textContent.replace(/\s+/g, " ").trim() : (card.getAttribute("data-lgg-was") || "");
      if (wasText === nowText) wasText = "";
      slot.innerHTML = (wasText ? "<s>" + escapeHtml(wasText) + "</s>" : "") + (nowText ? "<span>" + escapeHtml(nowText) + "</span>" : "");
    }
    function syncMiniCta(card) {
      var btn = mini.querySelector("[data-lgg-mini-add]");
      if (!btn || !card) return;
      if (card.getAttribute("data-st11-available") !== "true") {
        btn.disabled = true;
        btn.textContent = "Sold out";
        return;
      }
      btn.disabled = false;
      var id = card.getAttribute("data-st11-id");
      if (picks[id] && picks[id].qty > 0) {
        btn.textContent = "Added";
        return;
      }
      var now = card.querySelector("[data-st11-price-display]");
      var amount = now ? now.textContent.replace(/\s+/g, " ").trim() : (card.getAttribute("data-lgg-now") || "");
      btn.textContent = amount ? "Add to cart · " + amount : "Add to cart";
    }
    function variantHtml(card) {
      var sel = card.querySelector("[data-st11-variant-select]");
      if (!sel || sel.options.length < 2) return "";
      var labelEl = card.querySelector(".lp-collection-card__variant label");
      var name = "Option";
      if (labelEl) {
        var text = labelEl.textContent.replace(/\s+/g, " ").trim();
        var cut = text.indexOf(" for ");
        if (cut > 0) name = text.slice(0, cut);
      }
      var options = Array.prototype.map.call(sel.options, function (opt) {
        return '<option value="' + escapeAttr(opt.value) + '"' +
          (opt.selected ? " selected" : "") +
          (opt.disabled ? " disabled" : "") + ">" +
          escapeHtml(opt.textContent) + "</option>";
      }).join("");
      return '<label class="lgg-mini__variant"><span class="lgg-mini__variant-name">' + escapeHtml(name) +
        '</span><select class="lgg-mini__variant-select" data-lgg-mini-variant-select>' + options + "</select></label>";
    }
    function galleryTrack() {
      return mini.querySelector("[data-lgg-mini-track]");
    }
    function goToSlide(index) {
      var track = galleryTrack();
      var count = track ? track.children.length : 0;
      if (!count) return;
      var i = ((index % count) + count) % count;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? "auto" : "smooth" });
    }
    function renderGallery(images, title) {
      var gallery = mini.querySelector("[data-lgg-mini-gallery]");
      if (!gallery) return;
      var slides = (images || []).map(function (src) {
        return { full: withImageWidth(src, 900), thumb: withImageWidth(src, 120) };
      }).filter(function (slide) { return slide.full; });
      gallery.hidden = slides.length === 0;
      if (!slides.length) { gallery.innerHTML = ""; return; }
      var multi = slides.length > 1;
      gallery.innerHTML =
        '<div class="lgg-mini__track" data-lgg-mini-track' +
        (multi ? ' tabindex="0" role="region" aria-label="' + escapeAttr(title + " images") + '"' : "") + ">" +
        slides.map(function (slide, i) {
          return '<div class="lgg-mini__slide"><img src="' + escapeAttr(slide.full) + '" alt="' +
            escapeAttr(multi ? title + ", image " + (i + 1) + " of " + slides.length : title) +
            '" width="720" height="720"' + (i > 0 ? ' loading="lazy"' : "") + "></div>";
        }).join("") + "</div>" +
        (multi
          ? '<button type="button" class="lgg-mini__nav lgg-mini__nav--prev" data-lgg-mini-step="-1" aria-label="Previous image">' + ICON_PREV +
            '</button><button type="button" class="lgg-mini__nav lgg-mini__nav--next" data-lgg-mini-step="1" aria-label="Next image">' + ICON_NEXT +
            '</button><div class="lgg-mini__thumbs">' +
            slides.map(function (slide, i) {
              return '<button type="button" class="lgg-mini__thumb" data-lgg-mini-go="' + i + '" aria-label="Show image ' + (i + 1) + '"' +
                (i === 0 ? ' aria-current="true"' : "") + '><img src="' + escapeAttr(slide.thumb) + '" alt="" width="56" height="56" loading="lazy"></button>';
            }).join("") + "</div>"
          : "");
      var track = gallery.querySelector("[data-lgg-mini-track]");
      if (multi && track) {
        track.addEventListener("scroll", function () {
          var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          track.parentElement.querySelectorAll("[data-lgg-mini-go]").forEach(function (thumb, i) {
            if (i === index) thumb.setAttribute("aria-current", "true");
            else thumb.removeAttribute("aria-current");
          });
        }, { passive: true });
      }
    }
    function renderFeatures(features) {
      var list = mini.querySelector("[data-lgg-mini-features]");
      if (!list) return;
      var items = (features || []).map(function (item) {
        return { icon: String(item && item.icon || "").trim().toLowerCase(), label: String(item && item.label || "").trim() };
      }).filter(function (item) { return item.label; }).slice(0, 6);
      list.hidden = items.length === 0;
      var lucide = window.lucide;
      list.innerHTML = items.map(function (item) {
        var icon = lucide && /^[a-z0-9-]+$/.test(item.icon)
          ? '<i data-lucide="' + escapeAttr(item.icon) + '" aria-hidden="true"></i>'
          : ICON_CHECK;
        return "<li>" + icon + "<span>" + escapeHtml(item.label) + "</span></li>";
      }).join("");
      if (!items.length || !lucide || typeof lucide.createIcons !== "function") return;
      try { lucide.createIcons({ root: list }); } catch (err) { try { lucide.createIcons(); } catch (err2) { /* labels still read */ } }
      list.querySelectorAll("i[data-lucide]").forEach(function (node) {
        if (node.querySelector("svg")) return;
        node.insertAdjacentHTML("afterend", ICON_CHECK);
        node.remove();
      });
    }
    function lockMini(on) {
      if (on) {
        miniScroll = document.documentElement.style.overflow;
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = miniScroll;
      }
    }
    function closeMini() {
      if (!mini || mini.hidden) return;
      var back = miniInvoker;
      miniCard = null;
      miniInvoker = null;
      mini.hidden = true;
      lockMini(false);
      if (back && back.isConnected) back.focus();
    }
    function openMini(card, invoker) {
      if (!mini || !card) return;
      var handle = handleFromCard(card);
      var title = card.getAttribute("data-st11-title") || "";
      var gen = ++miniGen;
      miniCard = card;
      miniInvoker = invoker || null;
      mini.querySelector("[data-lgg-mini-title]").textContent = title;
      paintMiniReviews(card);
      paintMiniPrice(card);
      mini.querySelector("[data-lgg-mini-variant]").innerHTML = variantHtml(card);
      renderFeatures([]);
      mini.querySelector("[data-lgg-mini-desc]").innerHTML = "";
      syncMiniCta(card);
      var img = card.querySelector(".lp-collection-card__img--primary");
      var src = (img && (img.currentSrc || img.getAttribute("src"))) || card.getAttribute("data-st11-img") || "";
      renderGallery(src ? [src] : [], title);
      mini.hidden = false;
      var scroller = mini.querySelector("[data-lgg-mini-scroll]");
      if (scroller) scroller.scrollTop = 0;
      lockMini(true);
      var closeBtn = mini.querySelector(".lgg-mini__close");
      if (closeBtn) closeBtn.focus();
      if (!handle) return;
      fetchFeatures(handle).then(function (features) {
        if (gen !== miniGen) return;
        renderFeatures(features);
      });
      fetchJson(handle).then(function (product) {
        if (!product || gen !== miniGen) return;
        var images = (Array.isArray(product.images) ? product.images : []).filter(Boolean).slice(0, 6);
        if (images.length) renderGallery(images, title);
        var desc = sanitizeDescription(product.description);
        var descEl = mini.querySelector("[data-lgg-mini-desc]");
        if (desc && descEl) descEl.innerHTML = desc;
        if (card.querySelector("[data-st11-variant-select]") || !Array.isArray(product.variants) || product.variants.length < 2) return;
        var slot = mini.querySelector("[data-lgg-mini-variant]");
        if (!slot) return;
        var current = String(card.getAttribute("data-st11-variant") || "");
        slot.innerHTML = '<label class="lgg-mini__variant"><span class="lgg-mini__variant-name">Option</span><select class="lgg-mini__variant-select" data-lgg-mini-variant-select>' +
          product.variants.map(function (variant) {
            var label = variant.title || "Option";
            if (!variant.available) label += " — Sold out";
            return '<option value="' + escapeAttr(variant.id) + '"' +
              (String(variant.id) === current ? " selected" : "") +
              (variant.available ? "" : " disabled") + ">" + escapeHtml(label) + "</option>";
          }).join("") + "</select></label>";
        slot.dataset.variants = JSON.stringify(product.variants.map(function (variant) {
          return { id: variant.id, price: variant.price, compare: variant.compare_at_price || 0, available: !!variant.available };
        }));
      });
    }
    function openFromChip(chip) {
      var id = chip.getAttribute("data-lgg-id");
      var card = id && root.querySelector('[data-st11-card][data-st11-id="' + id + '"]');
      if (card) { openMini(card, chip); return; }
      var proxy = document.createElement("article");
      proxy.setAttribute("data-st11-id", id || "");
      proxy.setAttribute("data-st11-variant", chip.getAttribute("data-lgg-variant") || "");
      proxy.setAttribute("data-st11-price", chip.getAttribute("data-price") || "0");
      proxy.setAttribute("data-st11-compare", chip.getAttribute("data-compare") || "0");
      proxy.setAttribute("data-st11-available", chip.getAttribute("data-lgg-available") || "false");
      proxy.setAttribute("data-st11-img", chip.getAttribute("data-lgg-img") || "");
      proxy.setAttribute("data-st11-title", chip.getAttribute("data-lgg-title") || "");
      proxy.setAttribute("data-lgg-rating", chip.getAttribute("data-lgg-rating") || "");
      proxy.setAttribute("data-st11-url", "/products/" + (chip.getAttribute("data-lgg-handle") || ""));
      var now = chip.querySelector("[data-lgg-chip-now]");
      var was = chip.querySelector("[data-lgg-chip-was]");
      if (now) proxy.setAttribute("data-lgg-now", now.textContent.replace(/\s+/g, " ").trim());
      if (was) proxy.setAttribute("data-lgg-was", was.textContent.replace(/\s+/g, " ").trim());
      var src = chip.getAttribute("data-lgg-img");
      if (src) {
        var image = document.createElement("img");
        image.className = "lp-collection-card__img lp-collection-card__img--primary";
        image.src = src;
        proxy.appendChild(image);
      }
      openMini(proxy, chip);
    }
    function mountLearn() {
      root.querySelectorAll("[data-st11-card]").forEach(function (card) {
        if (!card.querySelector(".lgg-spark")) {
          var spark = document.createElement("span");
          spark.className = "lgg-spark";
          spark.setAttribute("aria-hidden", "true");
          for (var s = 0; s < 8; s++) spark.appendChild(document.createElement("i"));
          card.appendChild(spark);
        }
        if (card.querySelector("[data-lgg-learn]")) return;
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "lgg-learn";
        btn.setAttribute("data-lgg-learn", "");
        btn.setAttribute("aria-haspopup", "dialog");
        var name = card.getAttribute("data-st11-title") || "this product";
        btn.setAttribute("aria-label", "Learn more about " + name);
        btn.textContent = "Learn more";
        var body = card.querySelector(".lp-collection-card__body");
        if (body) body.appendChild(btn);
      });
    }
    function linkCards() {}
    if (mini) {
      mini.addEventListener("click", function (event) {
        if (event.target.closest("[data-lgg-mini-close]")) { event.preventDefault(); closeMini(); return; }
        if (event.target.closest("[data-lgg-mini-add]")) {
          event.preventDefault();
          if (!miniCard || miniCard.getAttribute("data-st11-available") !== "true") return;
          var id = miniCard.getAttribute("data-st11-id");
          if (!(picks[id] && picks[id].qty > 0)) writePick(miniCard, 1);
          closeMini();
          return;
        }
        var step = event.target.closest("[data-lgg-mini-step]");
        if (step) {
          event.preventDefault();
          var track = galleryTrack();
          var index = track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0;
          goToSlide(index + (parseInt(step.getAttribute("data-lgg-mini-step"), 10) || 0));
          return;
        }
        var go = event.target.closest("[data-lgg-mini-go]");
        if (go) { event.preventDefault(); goToSlide(parseInt(go.getAttribute("data-lgg-mini-go"), 10) || 0); }
      });
      mini.addEventListener("change", function (event) {
        var sel = event.target.closest("[data-lgg-mini-variant-select]");
        if (!sel || !miniCard) return;
        var cardSel = miniCard.querySelector("[data-st11-variant-select]");
        if (cardSel) {
          cardSel.value = sel.value;
          cardSel.dispatchEvent(new Event("change", { bubbles: true }));
          paintMiniPrice(miniCard);
          syncMiniCta(miniCard);
          return;
        }
        var list = [];
        try { list = JSON.parse((mini.querySelector("[data-lgg-mini-variant]") || {}).dataset.variants || "[]"); } catch (err) { list = []; }
        var picked = null;
        list.forEach(function (variant) { if (String(variant.id) === sel.value) picked = variant; });
        if (!picked) return;
        miniCard.setAttribute("data-st11-variant", String(picked.id));
        miniCard.setAttribute("data-st11-price", String(picked.price || 0));
        miniCard.setAttribute("data-st11-compare", String(picked.compare || 0));
        miniCard.setAttribute("data-st11-available", picked.available ? "true" : "false");
        var sale = percent > 0 ? saleOf(picked.price || 0, percent) : (picked.price || 0);
        var strike = (picked.compare || 0) > sale ? picked.compare : ((picked.price || 0) > sale ? picked.price : 0);
        miniCard.setAttribute("data-lgg-now", money(sale));
        miniCard.setAttribute("data-lgg-was", strike > sale ? money(strike) : "");
        var pickedId = miniCard.getAttribute("data-st11-id");
        if (picks[pickedId]) writePick(miniCard, picks[pickedId].qty);
        paintMiniPrice(miniCard);
        syncMiniCta(miniCard);
      });
      document.addEventListener("keydown", function (event) {
        if (!mini || mini.hidden) return;
        if (event.key === "Escape") { event.preventDefault(); closeMini(); return; }
        if (event.key !== "Tab") return;
        var nodes = mini.querySelectorAll("button, select, [tabindex='0']");
        var list = Array.prototype.filter.call(nodes, function (el) { return !el.disabled && el.offsetParent !== null; });
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }

    function paintBest() {
      var box = root.querySelector("[data-lgg-best]");
      if (!box) return;
      var shade = box.querySelector("input[data-price]:checked");
      var qtyInput = box.querySelector('input[name^="lgg-qty-"]:checked');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!shade) return;
      var price = parseInt(shade.getAttribute("data-price"), 10) || 0;
      var compare = parseInt(shade.getAttribute("data-compare"), 10) || price;
      var sale = price;
      box.querySelectorAll(".lgg-qty").forEach(function (label) {
        var input = label.querySelector("input");
        var q = parseInt(input.value, 10) || 1;
        var now = label.querySelector("[data-lgg-best-now]");
        var was = label.querySelector("[data-lgg-best-was]");
        if (now) now.textContent = money(sale * q);
        if (was) {
          was.hidden = compare <= price;
          if (compare > price) was.textContent = money(compare * q);
        }
      });
      var cta = box.querySelector("[data-lgg-best-cta]");
      if (cta && !cta.closest("button").disabled) cta.textContent = "Add to cart — " + money(sale * qty);
    }

    function syncBest() {
      var box = root.querySelector("[data-lgg-best]");
      if (!box || !picks[bestId]) return;
      var row = picks[bestId];
      box.querySelectorAll("input[data-price]").forEach(function (input) {
        input.checked = String(input.value) === String(row.variant);
      });
      box.querySelectorAll('input[name^="lgg-qty-"]').forEach(function (input) {
        if (parseInt(input.value, 10) === row.qty) input.checked = true;
      });
      paintBest();
    }

    function addBest(quiet) {
      var box = root.querySelector("[data-lgg-best]");
      if (!box || !bestId) return;
      var shade = box.querySelector("input[data-price]:checked");
      var qtyInput = box.querySelector('input[name^="lgg-qty-"]:checked');
      if (!shade || shade.disabled) return;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      picks[bestId] = {
        id: Number(bestId),
        variant: Number(shade.value),
        price: parseInt(shade.getAttribute("data-price"), 10) || 0,
        compare: parseInt(shade.getAttribute("data-compare"), 10) || 0,
        img: shade.getAttribute("data-img") || box.getAttribute("data-img") || "",
        qty: qty
      };
      mirror(bestId);
      refresh();
      if (!quiet) showToast("Added to your gift list");
    }

    function unitsAndTotals() {
      var units = 0;
      var list = 0;
      listPicks().forEach(function (row) {
        units += row.qty;
        list += row.price * row.qty;
      });
      return { units: units, list: list, sale: percent > 0 ? saleOf(list, percent) : list };
    }

    function updateBag(units) {
      var count = root.querySelector("[data-lgg-bag-count]");
      var bag = root.querySelector("[data-lgg-bag]");
      if (count) count.textContent = String(units);
      if (bag) bag.setAttribute("aria-label", "Bag, " + units + (units === 1 ? " gift selected" : " gifts selected"));
    }

    function updatePerk(sale) {
      var msg = root.querySelector("[data-lgg-perk-msg]");
      var fill = root.querySelector("[data-lgg-perk-fill]");
      var bag = root.querySelector("[data-lgg-perk-bag]");
      var sum = sale + cartTotal;
      var goal = showGift ? Math.max(giftAt, shipAt) : shipAt;
      var pct = Math.max(0, Math.min(100, Math.round((sum / goal) * 100)));
      if (fill) fill.style.width = pct + "%";
      if (bag) bag.textContent = "Bag " + money(sum);
      if (!msg) return;
      if (sum >= shipAt && (!showGift || sum >= giftAt)) {
        msg.textContent = showGift ? "Free U.S. shipping and your free gift are unlocked." : "Free U.S. shipping is unlocked.";
      } else if (sum >= shipAt && showGift) {
        msg.textContent = "Free U.S. shipping is unlocked. " + money(giftAt - sum) + " away from a free gift.";
      } else {
        msg.textContent = money(shipAt - sum) + " away from free U.S. shipping.";
      }
    }

    function updateSticky() {
      if (!root.isConnected) return;
      var totals = unitsAndTotals();
      var rows = listPicks();
      if (stickyThumbs) {
        var thumbs = [];
        rows.forEach(function (row) {
          if (row.img) thumbs.push(row.img);
        });
        if (thumbs.length > 2) thumbs = [thumbs[0], thumbs[thumbs.length - 1]];
        stickyThumbs.innerHTML = "";
        thumbs.forEach(function (src) {
          var im = document.createElement("img");
          im.src = src;
          im.alt = "";
          stickyThumbs.appendChild(im);
        });
      }
      if (stickyEmpty) stickyEmpty.hidden = totals.units > 0;
      if (stickyBadge) {
        stickyBadge.textContent = String(totals.units);
        stickyBadge.classList.toggle("is-active", totals.units > 0);
      }
      if (stickyPrice) {
        stickyPrice.hidden = totals.units < 1;
        if (stickyNow) stickyNow.textContent = money(totals.sale);
        if (stickyWas) stickyWas.textContent = totals.list > totals.sale ? money(totals.list) : "";
      }
      if (stickyCtaText) {
        var checkingOut = totals.units > 0;
        stickyCtaText.textContent = checkingOut ? "Checkout now" : "Shop the gift guide";
        stickyCtaText.setAttribute("data-lgg-mode", checkingOut ? "checkout" : "shop");
      }
      if (sticky && api) {
        var mobileBar = window.matchMedia("(max-width: 820px)").matches;
        var threshold = mobileBar ? 0 : api.scrollThreshold(160, 240);
        if (mobileBar || totals.units > 0 || api.scrollY() > threshold) api.reveal(sticky, root);
        else api.hide(sticky, root);
      }
      updateBag(totals.units);
      updatePerk(totals.sale);
    }

    function refresh() { updateSticky(); }

    function scrollToShop() {
      var shop = root.querySelector("[data-lgg-shop]");
      if (!shop) return;
      if (api && typeof api.scrollTo === "function") api.scrollTo(shop);
      else shop.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    }

    function ensureModal() {
      if (modalApi) return modalApi;
      if (!(window.BBELP && window.BBELP.modal && typeof window.BBELP.modal.init === "function")) return null;
      modalApi = window.BBELP.modal.init({
        root: root,
        getParentVariantIds: function () { return listPicks().map(function (row) { return row.variant; }); },
        getParentProductIds: function () { return listPicks().map(function (row) { return row.id; }); },
        getParentCartItems: function () { return listPicks().map(function (row) { return { id: row.variant, quantity: row.qty }; }); },
        canCheckout: function () { return listPicks().length > 0; },
        onCheckoutBlocked: function () { showToast("Choose a gift first"); scrollToShop(); },
        onStickySuppress: function (on) { if (api) api.suppress(on); }
      });
      return modalApi;
    }

    var sentQty = {};
    var checkoutBusy = false;
    function pendingAdds() {
      var items = [];
      listPicks().forEach(function (row) {
        var prev = sentQty[row.variant] || 0;
        if (row.qty > prev) items.push({ id: row.variant, quantity: row.qty - prev });
      });
      return items;
    }
    function markSent() {
      listPicks().forEach(function (row) {
        sentQty[row.variant] = Math.max(sentQty[row.variant] || 0, row.qty);
      });
    }
    function whenPpupReady() {
      return new Promise(function (resolve) {
        var tries = 0;
        var wait = window.setInterval(function () {
          tries += 1;
          if (typeof window.bbePreparePreUpsellOffers === "function" || tries > 40) {
            window.clearInterval(wait);
            resolve(typeof window.bbePreparePreUpsellOffers === "function");
          }
        }, 50);
      });
    }
    function openPpup(invoker) {
      return whenPpupReady().then(function (ready) {
        var ppup = document.querySelector("pre-upsell-modal");
        var go = function () { window.location.href = "/checkout"; };
        if (!ready || !ppup || typeof window.bbePreparePreUpsellOffers !== "function") { go(); return; }
        return window.bbePreparePreUpsellOffers(ppup).then(function (outcome) {
          if (!outcome || outcome.action !== "open") { go(); return; }
          var drawer = document.querySelector("cart-drawer");
          if (drawer && typeof drawer.close === "function") drawer.close();
          if (typeof ppup.open === "function") ppup.open(invoker || null);
          else go();
        }).catch(go);
      });
    }
    function openCheckout(invoker) {
      if (config.usePpup !== true) {
        ensureCode();
        var modal = ensureModal();
        if (modal && typeof modal.open === "function") { modal.open(); return; }
        showToast("One moment, then tap again");
        return;
      }
      if (!listPicks().length) { showToast("Choose a gift first"); scrollToShop(); return; }
      if (checkoutBusy) return;
      checkoutBusy = true;
      ensureCode().then(function () {
        var items = pendingAdds();
        var added = items.length
          ? fetch(shopRoot() + "cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ items: items })
            }).then(function (res) { if (!res.ok) throw new Error("cart"); markSent(); })
          : Promise.resolve();
        return added.then(function () { return openPpup(invoker); });
      }).catch(function () {
        showToast("Could not add these gifts. Try again.");
      }).then(function () { checkoutBusy = false; });
    }
    function goStraightToCheckout() {
      if (!listPicks().length) { showToast("Choose a gift first"); scrollToShop(); return; }
      if (checkoutBusy) return;
      checkoutBusy = true;
      var items = pendingAdds();
      var added = items.length
        ? fetch(shopRoot() + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: items })
          }).then(function (res) { if (!res.ok) throw new Error("cart"); markSent(); })
        : Promise.resolve();
      added.then(function () { window.location.href = shopRoot() + "checkout"; }).catch(function () {
        showToast("Could not add these gifts. Try again.");
        checkoutBusy = false;
      });
    }
    root.__lggCheckout = goStraightToCheckout;

    function onStickyClick(event) {
      var bar = event.target.closest("[data-lp-sticky]");
      if (!bar || bar.getAttribute("data-lp-sticky-root-id") !== rootId) return;
      if (!event.target.closest("[data-lp-sticky-cta]")) return;
      event.preventDefault();
      if (listPicks().length > 0) goStraightToCheckout();
      else scrollToShop();
    }

    function selectTab(tab) {
      var tabs = root.querySelectorAll("[data-lgg-tab]");
      var panels = root.querySelectorAll("[data-lgg-panel]");
      tabs.forEach(function (el) {
        var on = el === tab;
        el.setAttribute("aria-selected", on ? "true" : "false");
        el.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.id !== tab.getAttribute("aria-controls");
      });
      var shopAll = root.querySelector("[data-lgg-shopall]");
      if (shopAll) {
        shopAll.href = tab.getAttribute("data-lgg-shop-url") || "#sets";
        shopAll.textContent = "Shop all " + (tab.getAttribute("data-lgg-shop-name") || "gifts");
      }
    }

    root.addEventListener("click", function (event) {
      var pause = event.target.closest("[data-lgg-ticker-toggle]");
      if (pause && root.contains(pause)) {
        var ticker = pause.closest("[data-lgg-ticker]");
        var paused = !ticker.classList.contains("is-paused");
        ticker.classList.toggle("is-paused", paused);
        pause.setAttribute("aria-pressed", paused ? "true" : "false");
        var label = pause.querySelector("[data-lgg-ticker-label]");
        if (label) label.textContent = paused ? "Play announcements" : "Pause announcements";
        return;
      }

      var tab = event.target.closest("[data-lgg-tab]");
      if (tab && root.contains(tab)) { selectTab(tab); return; }

      var chip = event.target.closest("[data-lgg-chip]");
      if (chip && root.contains(chip)) {
        event.preventDefault();
        openFromChip(chip);
        return;
      }
      if (event.target.closest("[data-lgg-best-add]")) { event.preventDefault(); addBest(); return; }
      if (event.target.closest("[data-lgg-bag]")) {
        event.preventDefault();
        if (listPicks().length > 0) openCheckout();
        else scrollToShop();
        return;
      }

      var minus = event.target.closest("[data-st11-qty-minus]");
      if (minus && root.contains(minus)) {
        var minusCard = minus.closest("[data-st11-card]");
        if (minusCard) writePick(minusCard, (picks[minusCard.getAttribute("data-st11-id")] || { qty: 0 }).qty - 1);
        return;
      }
      var plus = event.target.closest("[data-st11-qty-plus]");
      if (plus && root.contains(plus)) {
        var plusCard = plus.closest("[data-st11-card]");
        if (plusCard) {
          var hadFocus = plusCard.contains(document.activeElement);
          writePick(plusCard, (picks[plusCard.getAttribute("data-st11-id")] || { qty: 0 }).qty + 1);
          if (hadFocus) {
            var nextPlus = plusCard.querySelector("[data-st11-qty-plus]");
            if (nextPlus) nextPlus.focus({ preventScroll: true });
          }
        }
        return;
      }

      var opener = event.target.closest(".lp-collection-card__media, .lp-collection-card__title, [data-lgg-learn]");
      if (opener && root.contains(opener) && !event.target.closest("select, [data-st11-qty], .lp-collection-card__action-wrap")) {
        var openerCard = opener.closest("[data-st11-card]");
        if (openerCard) {
          event.preventDefault();
          openMini(openerCard, opener);
        }
        return;
      }

      var card = event.target.closest('[data-st11-card][data-st11-mode="select"]');
      if (!card || !root.contains(card)) return;
      if (event.target.closest("select, [data-st11-qty], a, [data-lgg-learn], .lp-collection-card__media, .lp-collection-card__title")) return;
      var current = (picks[card.getAttribute("data-st11-id")] || { qty: 0 }).qty;
      if (current > 0) return;
      event.preventDefault();
      writePick(card, 1);
      var plusBtn = card.querySelector("[data-st11-qty-plus]");
      if (plusBtn && card.contains(document.activeElement)) plusBtn.focus({ preventScroll: true });
    });

    root.addEventListener("keydown", function (event) {
      var tab = event.target.closest && event.target.closest("[data-lgg-tab]");
      if (tab && root.contains(tab)) {
        var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-lgg-tab]"));
        var index = tabs.indexOf(tab);
        var next = null;
        if (event.key === "ArrowRight" || event.key === "ArrowDown") next = (index + 1) % tabs.length;
        if (event.key === "ArrowLeft" || event.key === "ArrowUp") next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === "Home") next = 0;
        if (event.key === "End") next = tabs.length - 1;
        if (next !== null) { event.preventDefault(); selectTab(tabs[next]); tabs[next].focus(); }
        return;
      }
      if (event.key !== "Enter" && event.key !== " ") return;
      var card = event.target;
      if (!card.matches || !card.matches('[data-st11-card][data-st11-mode="select"]')) return;
      event.preventDefault();
      openMini(card, card);
    });

    root.addEventListener("change", function (event) {
      var sel = event.target.closest("[data-st11-variant-select]");
      if (sel && root.contains(sel)) {
        var card = sel.closest("[data-st11-card]");
        var opt = sel.options[sel.selectedIndex];
        if (!card || !opt) return;
        card.setAttribute("data-st11-variant", opt.value);
        card.setAttribute("data-st11-price", opt.getAttribute("data-price") || "0");
        card.setAttribute("data-st11-compare", opt.getAttribute("data-compare") || "0");
        var id = card.getAttribute("data-st11-id");
        if (picks[id]) writePick(card, picks[id].qty);
        else paintPrices(card);
        return;
      }
      if (event.target.closest("[data-lgg-best]")) {
        paintBest();
        if (picks[bestId]) addBest(true);
      }
    });

    root.addEventListener("change", function (event) {
      var quizInput = event.target.closest && event.target.closest("#lp-shade-quiz-lb input");
      if (!quizInput) return;
      var profile = root.querySelector("[data-lgg-profile]");
      if (profile) profile.classList.add("is-live");
    });

    root.addEventListener("bbe:shade-quiz:select", function (event) {
      var detail = event.detail || {};
      var profile = root.querySelector("[data-lgg-profile]");
      if (profile) profile.classList.add("is-live");
      var empty = root.querySelector("[data-lgg-profile-empty]");
      var result = root.querySelector("[data-lgg-profile-result]");
      var value = root.querySelector("[data-lgg-profile-value]");
      if (empty) empty.hidden = true;
      if (result) result.hidden = false;
      if (value) value.textContent = detail.title || detail.shade || "";
      var box = root.querySelector("[data-lgg-best]");
      if (!box || !detail.title) return;
      var wanted = String(detail.title).toLowerCase();
      box.querySelectorAll("input[data-title]").forEach(function (input) {
        var title = String(input.getAttribute("data-title") || "").toLowerCase();
        if (title && (title === wanted || title.indexOf(wanted) !== -1 || wanted.indexOf(title) !== -1)) input.checked = true;
      });
      paintBest();
    });

    function paintChip() {
      if (percent < 1) return;
      root.querySelectorAll("[data-lgg-chip]").forEach(function (chip) {
        var list = parseInt(chip.getAttribute("data-price"), 10) || 0;
        var compare = parseInt(chip.getAttribute("data-compare"), 10) || list;
        var now = chip.querySelector("[data-lgg-chip-now]");
        var was = chip.querySelector("[data-lgg-chip-was]");
        if (now) now.textContent = money(saleOf(list, percent));
        if (was) was.textContent = money(compare > list ? compare : list);
      });
    }

    var chipStack = root.querySelector("[data-lgg-chips]");
    var chipCards = chipStack ? chipStack.querySelectorAll("[data-lgg-chip]") : [];
    if (chipStack && chipCards.length > 1 && !reduceMotion) {
      var chipIndex = 0;
      var chipTimer = 0;
      function showChip(next) {
        chipIndex = next;
        chipCards.forEach(function (card, index) {
          var on = index === chipIndex;
          card.classList.toggle("is-on", on);
          card.setAttribute("aria-hidden", on ? "false" : "true");
          if (on) card.removeAttribute("tabindex");
          else card.setAttribute("tabindex", "-1");
        });
      }
      function stopChips() {
        if (chipTimer) window.clearInterval(chipTimer);
        chipTimer = 0;
      }
      function startChips() {
        stopChips();
        chipTimer = window.setInterval(function () {
          showChip((chipIndex + 1) % chipCards.length);
        }, 5000);
      }
      chipStack.addEventListener("mouseenter", stopChips);
      chipStack.addEventListener("mouseleave", startChips);
      chipStack.addEventListener("focusin", stopChips);
      chipStack.addEventListener("focusout", function (event) {
        if (!chipStack.contains(event.relatedTarget)) startChips();
      });
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) stopChips();
        else startChips();
      });
      startChips();
    }

    var clock = root.querySelector("[data-lgg-countdown]");
    var end = Date.parse(config.countdownEnd || "");
    if (clock && isFinite(end)) {
      var tick = function () {
        var left = end - Date.now();
        if (left <= 0) {
          clock.hidden = true;
          var ended = root.querySelector("[data-lgg-ended]");
          if (ended) ended.hidden = false;
          return;
        }
        var total = Math.floor(left / 1000);
        var parts = {
          d: String(Math.floor(total / 86400)),
          h: String(Math.floor((total % 86400) / 3600)).padStart(2, "0"),
          m: String(Math.floor((total % 3600) / 60)).padStart(2, "0"),
          s: String(total % 60).padStart(2, "0")
        };
        var units = { d: "d", h: "h", m: "m", s: "s" };
        Object.keys(parts).forEach(function (key) {
          var el = clock.querySelector('[data-lgg-cd="' + key + '"]');
          if (el) el.textContent = parts[key] + units[key];
        });
      };
      tick();
      setInterval(tick, reduceMotion ? 60000 : 1000);
    }

    function loadCart() {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          cartTotal = cart && cart.total_price ? cart.total_price : 0;
          updateSticky();
        })
        .catch(function () {});
    }

    function pinQuiz() {
      var lb = root.querySelector("#lp-shade-quiz-lb");
      if (!lb) return;
      var show = function () {
        if (typeof lb.__lpOpenShadeQuiz === "function") lb.__lpOpenShadeQuiz();
        lb.hidden = false;
        lb.setAttribute("aria-hidden", "false");
        document.documentElement.classList.remove("lp-shade-quiz-lb-open");
      };
      var tries = 0;
      var wait = window.setInterval(function () {
        tries += 1;
        if (typeof lb.__lpOpenShadeQuiz === "function" || tries > 40) {
          window.clearInterval(wait);
          show();
        }
      }, 50);
      if (window.MutationObserver) {
        new MutationObserver(function () {
          if (lb.hidden) {
            lb.hidden = false;
            lb.setAttribute("aria-hidden", "false");
            document.documentElement.classList.remove("lp-shade-quiz-lb-open");
          }
        }).observe(lb, { attributes: true, attributeFilter: ["hidden"] });
      }
    }

    var firstTab = root.querySelector("[data-lgg-tab]");
    if (firstTab) selectTab(firstTab);
    root.__lggOpenMini = openMini;
    mountLearn();
    linkCards();
    pinQuiz();
    root.querySelectorAll("[data-st11-card]").forEach(function (card) {
      var sel = card.querySelector("[data-st11-variant-select]");
      var vid = card.getAttribute("data-st11-variant");
      if (sel && vid) sel.value = vid;
      paintCard(card);
    });
    paintBest();
    paintChip();
    loadCart();
    window.setTimeout(ensureModal, 0);

    function attachSticky() {
      api = stickyApi();
      if (!api) return false;
      sticky = api.resolve(root, rootId) || sticky;
      bindSticky();
      updateSticky();
      return true;
    }
    if (!attachSticky()) {
      var tries = 0;
      var wait = window.setInterval(function () {
        tries += 1;
        if (attachSticky() || tries > 40) window.clearInterval(wait);
      }, 50);
    }

    if (document.documentElement.dataset.lggDoc !== "1") {
      document.documentElement.dataset.lggDoc = "1";
      document.addEventListener("click", function (event) {
        var bar = event.target.closest && event.target.closest("[data-lp-sticky]");
        if (!bar) return;
        var host = document.getElementById(bar.getAttribute("data-lp-sticky-root-id") || "");
        if (host && host.lggOnSticky) host.lggOnSticky(event);
      });
      window.addEventListener("scroll", function () {
        document.querySelectorAll("[data-lgg-root]").forEach(function (el) {
          if (el.lggUpdate) el.lggUpdate();
        });
      }, { passive: true });
    }
    root.lggOnSticky = onStickyClick;
    root.lggUpdate = updateSticky;
  }

  function boot() {
    document.querySelectorAll("[data-lgg-root]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();

  document.addEventListener("shopify:section:load", function (event) {
    var next = event.target && event.target.querySelector ? event.target.querySelector("[data-lgg-root]") : null;
    if (!next && event.target && event.target.matches && event.target.matches("[data-lgg-root]")) next = event.target;
    if (!next) return;
    delete next.dataset.lggBound;
    init(next);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
